// https://orcid.org/oauth/authorize?client_id=APP-RAKRR9CDZ5FK8R7Z
// &response_type=code&scope=openid&redirect_uri=https://unikove.com/projects/orcid/orcid.php

import React, { useRef, createRef, useEffect, useState } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";
import axios from "axios";
import { Modal } from "react-bootstrap";
import html2canvas from "html2canvas";
import Confetti from "react-confetti";
import { Link } from "react-router-dom";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import Draggable from "react-draggable";
import {
  DragDropContext as DragDropContextn,
  Draggable as Draggablen,
  Droppable as Droppablen,
} from "react-beautiful-dnd";
import { Grammarly } from "@grammarly/editor-sdk-react"; //GrammarlyEditorPlugin
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { isMobile } from "react-device-detect";
import Popover from "react-bootstrap/Popover";
// import TrinkaScript from "../../assets/js/Trinka-new-test";
import {
  UploadArticleContent,
  startSimilarityCheck,
  downloadSimiliratyReport,
} from "../../store/apiCalls/profileDetails";
import { getDictionary } from "../../store/apiCalls/dashboard";
import { jsPDF } from "jspdf";
import { SERVER_URL } from "../../config";

import jwt_decode from "jwt-decode";
import SunRichText from "./SunEditor";
/*eslint-disable*/
import MySubmission from "./preSubmitArticleDetails/mySubmission";
import StarRating from "./starRating";
import ContentDetails from "../viewArticle/contentDetails";
import "../../containers/autherFlow/personalDetails/PersonalDetails.scss";
import jwtDecode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import doneSvg from "../../assets/img/icons/done02.svg";
import notyet from "../../assets/img/icons/notarticle.svg";
import noGrammar from "../../assets/img/icons/smileicon.svg";
import alertSvg from "../../assets/img/icons/alert_info.svg";
import alertSearch from "../../assets/img/icons/alertSearch.svg";
import rightChk from "../../assets/img/icons/tickChk.svg";
import group from "../../assets/img/icons/Group.png";
import feedWant from "../../assets/img/icons/wantFeed.svg";
import coins from "../../assets/img/icons/coins.svg";
import arrowwhiteright from "../../assets/img/icons/arrowwhiteright.svg";
import kalashIcon from "../../assets/img/icons/kalash.png";
import email48 from "../../assets/img/icons/icons-gmail.png";
import whatsapp48 from "../../assets/img/icons/whatsapp-48.png";
import twitter48 from "../../assets/img/icons/twitter-48.png";
import vector_img from "../../assets/assets_html/images/Vector.png";

import checkRounded from "../../assets/img/icons/check_round_fill.svg";
import closeRounded from "../../assets/img/icons/close_round_fill.svg";
import bookmark from "../../assets/img/icons/bookmark.svg";
import bookmarkSelected from "../../assets/img/icons/bookmark-sel.svg";

import Input from "./Input";
import Checkbox from "./Checkbox";
import Textarea from "./Textarea";
import downloadImg from "../../assets/img/icons/downloadBlue.svg";
import tickChkImg from "../../assets/img/icons/tickChk.svg";
import CheckPri from "../../assets/img/icons/checkpri.svg";

import {
  FetchArticleById,
  EditCurrentArticle,
  SaveToDraft,
  FetchSimiilarityReport,
  findReviewer,
  FetchProfanityList,
  SaveAuthorsFeedback,
} from "../../containers/autherFlow/submitArticle/queries";
import { getAllMasterData } from "../../store/apiCalls/fetchmaster";
import { UploadMediaWithName } from "../../store/apiCalls/profileDetails";
import {
  getAPCValues,
  saveArticleToDraft as saveArticleToDraftApi,
  markDocumentUploadFailed as markDocUploadFailedApi,
} from "../../store/apiCalls/articles";

/*eslint-disable*/
import {
  checkUrl,
  getUnique,
  downLoadFile,
  toTitleCase,
  checkEmptyArticle,
  checkGrammar,
  addToDictionaryFun,
} from "../../utils";
import active_info from "../../svg/active-info.svg";
import {
  EmailShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import GrammarSpellModal from "../Modal/GrammarSpellModal";

const SubmitArticle = ({}) => {
  const shareUrl = SERVER_URL;
  // var trinka="";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.LoginReducer);
  // console.log(user);
  const code = useSelector((state) => state?.LoginReducer?.user?.promoCode);
  const gramrlyClientID = process.env.REACT_APP_GRAMMERLY_ID;
  const [trinka, settrinka] = useState("");
  const [articleID, setarticleID] = useState("");
  const [articleType, setarticleType] = useState("");
  const [spellCheckModal, setSpellCheckModal] = useState(false);
  const [isForRevision, setisForRevision] = useState(false);
  const [showprePage, setshowprePage] = useState(true);
  const [profanitySuccess, setprofanitySuccess] = useState(false);
  const [isEdited, setisEdited] = useState(true);
  const [profanityWords, setProfanityWords] = useState([]);
  const [subjectList, setsubjectList] = useState([]);
  const [invalidFilePopup, setinvalidFilePopup] = useState(false);
  const [APCData, setAPCData] = useState([]);
  const [citationPopup, setcitationPopup] = useState(false);
  const [isOpenTableContent, setisOpenTableContent] = useState(false);
  const [grammarWaiting, setGrammarWaiting] = useState(false);
  const [iSaveDraft, setiSaveDraft] = useState(0);
  const [autoSaveStatus, setAutoSaveStatus] = useState("");
  const lastSavedPayloadRef = useRef("");
  const [masterDataLoaded, setmasterDataLoaded] = useState(false);
  const [appointArticleStatus, setAppointArticleStatus] = useState("");
  const [simillarityResult, setsimillarityResult] = useState({
    percent: 0,
    status: "",
    indexId: "",
  });

  const [savedDetailsPupup, setsavedDetailsPupup] = useState(false);
  const [grammarModal, setGrammarModal] = useState(false);
  const [grammarFound, setGrammarFound] = useState([]);
  const [stateGrammarFound, setStateGrammarFound] = useState([]);
  // console.log(">>>>stateGrammarFound",stateGrammarFound);
  const [mobileAlert, setMobileAlert] = useState(false);
  const [prePaymentStatus, setprePaymentStatus] = useState(false);
  const [postValueStatus, setpostValueStatus] = useState(false);
  const [subjectSpecializationList, setsubjectSpecializationList] = useState(
    [],
  );
  const [blinkError, setblinkError] = useState("");
  const [specializationList, setspecializationList] = useState([]);
  const [desciplineMaster, setdesciplineMaster] = useState([]);
  const [articleTypeList, setarticleTypeList] = useState([]);
  const [supplimentImges, setsupplimentImges] = useState([]);
  const [profanityWordsFound, setProfanityWordsFound] = useState([]);
  const tokenVal = jwtDecode(localStorage.usertoken);
  const [gernalMaster, setgernalMaster] = useState([]);
  const [gernalType, setgernalType] = useState([]);
  const [preStepData, setpreStepData] = useState({
    plagirismCheck: "notDone",
    status: "draft",
    articleVersion: "",
    initialPayment: true,
    submissionDetail: {},
    statements: {},
    reviewType: {},
    authorDtl: {},
    fundingDetails: {},
    conference: {},
  });

  const [completedTabs, setcompletedTabs] = useState({
    mySubmission: false,
    review: false,
    author: false,
    funding: false,
    statement: false,
    conference: false,
  });
  const [showResult, setShowResult] = useState(false);
  // ---
  // New
  // ---
  const [showGrammarSucessModal, setshowGrammarSucessModal] = useState(false);
  const [showSimilarityInProgressModal, setShowSimilarityInProgressModal] =
    useState(false);
  // ---
  const [isUpdateNewVersion, setisUpdateNewVersion] = useState(false);
  const [isUpdateNewVersionPopup, setisUpdateNewVersionPopup] = useState(false);
  const [authorAffiliationsCount, setauthorAffiliationsCount] = useState([0]);
  const [mainTitle, setmainTitle] = useState("");
  const [finalSubmitPupup, setfinalSubmitPupup] = useState(false);
  const [finalSubmitConfirmPupup, setfinalSubmitConfirmPupup] = useState(false);
  const [feedbackPupup, setfeedbackPupup] = useState({
    openPopup: false,
    successPopup: false,
    starVal: 0,
    feedback: "",
    rateError: "",
    feedbackError: "",
  });
  const [showReferAndEarn, setShowReferAndEarn] = useState(false);
  const [articleWordLimit, setarticleWordLimit] = useState({
    wordLimitStatus: "",
    wordLimitType: "",
    alreadyExistReqPopup: false,
    reqSuccessPopup: false,
    openPopup: false,
    isIncrease: false,
    isDecrease: false,
    detail: "",
    detailError: "",
  });
  const [mendatoryAlert, setmendatoryAlert] = useState("");
  const [articleContent, setarticleContent] = useState({
    id: "",
    runningTitle: "",
    abstract: "",
    title: "",
    abbreviations: [],
    abbreviationsFull: [],
    keywords: [],
    references: "",
    acknowledgements: "",
    status: "",
  });
  const [articleContentError, setarticleContentError] = useState({
    titleError: "",
    runningTitleError: "",
    abstractError: "",
    introductionError: "",
    conclusionError: "",
    referencesError: "",
    keywordsError: "",
  });
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [showPdfPreviewModal, setShowPdfPreviewModal] = useState(false);

  useEffect(() => {
    const articleId =
      preStepData?._id || preStepData?.id || articleContent?.id || "current";
    const savedPdfData =
      sessionStorage.getItem(`generated_pdf_data_${articleId}`) ||
      sessionStorage.getItem(`generated_pdf_url_${articleId}`);
    if (savedPdfData) {
      setPdfPreviewUrl(savedPdfData);
    }
  }, [preStepData, articleContent.id]);
  const [citationDetails, setcitationDetails] = useState({
    publishPopup: false,
    totalLength: [0],
    url: "",
    isMulti: false,
    year: "",
    artTitle: "",
    urlError: "",
    yearError: "",
    fname: [{ val: "" }],
    lname: [{ val: "" }],
    fnameError: [],
    lnameError: [],
    artTitleError: [],
  });
  const [cancelArticle, setCancelArticle] = useState(false);
  const [editorLength, seteditorLength] = useState([0, 1, 2, 3, 4, 5]);
  const [uploadeImages, setuploadeImages] = useState([]);
  const [articleXmlFormat, setarticleXmlFormat] = useState("");
  const [ugcValidationPopup, setUgcValidationPopup] = useState({
    isOpen: false,
    missingSections: [],
  });
  const [editorTitleValue, seteditorTitleValue] = useState([
    { val: "Introduction" },
    { val: "Background" },
    { val: "Methodology" },
    { val: "Results" },
    { val: "Discussion" },
    { val: "Conclusion" },
  ]);
  const [editorTitleEdit, seteditorTitleEdit] = useState([
    { val: false },
    { val: false },
    { val: false },
    { val: false },
    { val: false },
    { val: false },
  ]);
  const [editorTitleValueError, seteditorTitleValueError] = useState([
    { val: "" },
    { val: "" },
    { val: "" },
    { val: "" },
    { val: "" },
    { val: "" },
  ]);
  const [editorAddToDictionaryWords, setEditorAddToDictionaryWords] = useState(
    [],
  );
  const [editorRejectedWords, setEditorRejectedWords] = useState([]);
  const [editorDictionary, setEditorDictionary] = useState([]);
  // console.log("editorDictionary------>",editorDictionary);
  const [editorTitleGrammar, setEditorTitleGrammar] = useState([{}, {}, {}]);
  // console.log("editorTitleGrammar===>",editorTitleGrammar);
  const [editorContentGrammar, seteditorContentGrammar] = useState([
    {},
    {},
    {},
    {},
    {},
    {},
  ]);
  const [editorContentGrammarIndex, setEditorContentGrammarIndex] = useState(0);
  // console.log("editorContentGrammar>>>>>>",editorContentGrammar);
  const [editorContentValue, seteditorContentValue] = useState([
    { val: "" },
    { val: "" },
    { val: "" },
    { val: "" },
    { val: "" },
    { val: "" },
  ]);
  // console.log(editorContentValue, "editorContentValue");
  const [refranceAck, setrefranceAck] = useState({
    refrances: "",
    acknowledgements: "",
  });
  // console.log(refranceAck, "refranceAck");
  const [savedDraftArticle, setsavedDraftArticle] = useState(false);
  const [showProfinityAl, setShowProfinityAl] = useState(false);
  const [showProfinityMain, setShowProfinityMain] = useState(false);
  const [showFlaggedNotificationModal, setShowFlaggedNotificationModal] =
    useState(false);

  const [saveArticleConfirmation, setsaveArticleConfirmation] = useState(false);
  const [saveArticleConfirmationNew, setsaveArticleConfirmationNew] =
    useState(false);
  const [finalSubmitds, setfinalSubmitds] = useState("false");
  console.log(finalSubmitds);
  const [profanityMatches, setProfanityMatches] = useState([]);
  // console.log("profanityMatches",profanityMatches);
  const [showDownloadbtn, setShowDownloadbtn] = useState(false);
  const [profanityAlert, setprofanityAlert] = useState({
    isOPen: false,
    type: 0,
  });
  const [plagiarismAlert, setPlagiarismAlert] = useState(false);
  const [titleGrammarHandle, setTitleGrammarHandle] = useState(false);
  // console.log("titleGrammarHandle>>>>>>>>",titleGrammarHandle, editorContentGrammarIndex, editorTitleGrammar);
  const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };
  const [unicheckData, setUnicheckData] = useState({
    similaritycheckId: null,
    url: null,
  });
  const router = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(router.search);
    if (
      queryParams.get("tab") === "submissionDetails" ||
      router.state?.tab === "submissionDetails"
    ) {
      setshowprePage(true);
    }
  }, [router.search, router.state]);
  const keyRef = useRef("");
  const submissionRef = useRef(null);
  const iSaveDraftRef = useRef(iSaveDraft);
  iSaveDraftRef.current = iSaveDraft;
  const showprePageRef = useRef(showprePage);
  showprePageRef.current = showprePage;
  const lastSavedTabRef = useRef("");
  const editorContentValueRef = useRef(editorContentValue);
  editorContentValueRef.current = editorContentValue;
  const abbreviationsRef = useRef("");
  const backgroundRef = useRef();
  const abbreviationsFullRef = useRef("");
  const refranceRef = useRef(null);
  const acknowledgementRef = useRef(null);
  const articleContentRefs = useRef(editorLength.map(() => createRef()));

  const title = `I have registered with Aakashganga, a new open access journals platform, built with love in India, for the world.

  As a researcher, I appreciate their vision of removing traditional barriers to publishing research, and democratizing knowledge through their automated digital Open Access Journals Platform to accelerate scientific progress. 
  
  I invite you to join Aakashganga. Use the special invitation code: ${code} to register on the platform and publish your research. Their APCs are one of the lowest in the world, and their smart automated solutions fast track research publishing.`;

  const handleCodeCopy = (e) => {
    copy(code);
    e.target.textContent = "Copied";
    e.target.style.setProperty("color", "#404040");
  };

  const AddDictionaryWord = (newWord) => {
    setEditorAddToDictionaryWords((prevWords) => [...prevWords, newWord]);
  };
  const AddRejectedWord = (newWord) => {
    setEditorRejectedWords((prevWords) => [...prevWords, newWord]);
  };

  const fetchDictionary = async () => {
    try {
      const { id } = jwt_decode(localStorage.usertoken);
      dispatch({ type: "SET_LOADER", payload: true });
      const params = {
        userId: id,
      };
      const response = await getDictionary(headers, params);

      // console.log(response?.data?.data);
      if (response?.status === 200) {
        setEditorDictionary((prevState) => ({
          ...prevState,
          reject: response?.data?.data?.reject,
          word: response?.data?.data?.word,
        }));
      }
    } catch (error) {
      console.error("fetchDictionary error:", error);
    } finally {
      dispatch({ type: "SET_LOADER", payload: false });
    }
  };

  const sucessHandler = (articleDetails) => {
    try {
      if (articleDetails?.status === 200) {
        const editDetl = articleDetails?.data?.data;
        if (!editDetl) return;
        const w = articleWordLimit;
        if (editDetl?.updateNewVersion === true) setisUpdateNewVersion(true);
        if (editDetl?.wordLimit === true) {
          if (editDetl.wordLimitType === "Less than 8k") {
            w.isIncrease = false;
            w.isDecrease = true;
          } else if (editDetl.wordLimitType === "More than 10k") {
            w.isIncrease = true;
            w.isDecrease = false;
          }
          w.wordLimitStatus = editDetl.wordLimitStatus;
          w.wordLimitType = editDetl.wordLimitType;
        } else {
          w.wordLimitStatus = editDetl?.wordLimitStatus;
          w.wordLimitType = editDetl?.wordLimitType;
        }

        setarticleWordLimit({ ...w });
        const cmpTab = completedTabs;
        const preDAta = {
          submissionDetail: {},
          statements: {},
          reviewType: {},
          authors: {},
          fundingDetails: {},
          conference: {},
          validCouponCode: {},
          initialPayment: "",
          paymentBySociety: {},
          _id: editDetl._id,
        };

        if (
          editDetl?.submissionDetail?.journalName &&
          editDetl.submissionDetail.journalName !== ""
        ) {
          cmpTab.mySubmission = true;
          preDAta.submissionDetail = editDetl.submissionDetail;
          preDAta.initialPayment = editDetl.initialPayment;
          preDAta.validCouponCode = editDetl.validCouponCode;
          preDAta.paymentBySociety = editDetl.paymentBySociety;
        }
      if (editDetl?.conference?.conferenceName !== "") {
        cmpTab.conference = true;
        preDAta.conference = editDetl.conference;
      }
      if (
        editDetl.reviewType?.typeOfReview &&
        editDetl.reviewType?.typeOfReview !== ""
      ) {
        const jName = editDetl.submissionDetail?.journalName?.trim()?.toLowerCase();
        const isBypassJournal =
          jName === "minorities in world politics" ||
          jName === "community learning and social transformation" ||
          jName === "applied and basic obesity, diabetes and endocrinology";
        cmpTab.review =
          editDetl.initialPayment === true ||
          editDetl.paymentBySociety?.apcPayBySociety === true ||
          isBypassJournal
            ? true
            : false;
        preDAta.reviewType = editDetl.reviewType;
        preDAta.reviewType.paymentDone = editDetl.initialPayment;
      }
      if (editDetl.authorDetails?._id && editDetl.authorDetails?._id !== "") {
        cmpTab.author = true;
        preDAta.authorDtl = editDetl.authorDetails;
      }

      preDAta.plagirismCheck = editDetl.plagirismCheck;
      if (
        editDetl.similarityCheckPercentage &&
        editDetl.similarityCheckPercentage > 15
      ) {
        preDAta.plagirismCheck = "notDone";
        preDAta.status = "draft";
        setblinkError(
          `ATTENTION: Similarity Index Check - ${editDetl.similarityCheckPercentage}%`
        );
        setsimillarityResult({
          percent: editDetl.similarityCheckPercentage,
          status: editDetl.plagirismCheck,
          indexId: editDetl.similarityCheckId,
        });
      } else if (
        editDetl.similarityCheckPercentage >= 0 &&
        editDetl.similarityCheckPercentage <= 15
      ) {
        setsimillarityResult({
          percent: editDetl.similarityCheckPercentage,
          status: editDetl.plagirismCheck,
          indexId: editDetl.similarityCheckId,
        });
      } else if (
        (editDetl.plagirismCheck === "Done" || editDetl.plagirismCheck === "done") &&
        !editDetl.similarityCheckPercentage
      ) {
        preDAta.plagirismCheck = "notDone";
      }
      if (editDetl.plagirismCheck === "reject") {
        preDAta.plagirismCheck = "notDone";
        preDAta.status = "draft";
      }

      if (editDetl.fundingDetails?._id && editDetl.fundingDetails?._id !== "") {
        cmpTab.funding = true;
        preDAta.fundingDetails = editDetl.fundingDetails;
      }

      if (
        editDetl.statements?.commercial &&
        editDetl.statements?.commercial
          ?.commercialOrfinancialConflictOfInterest !== ""
      ) {
        cmpTab.statement = true;
        preDAta.statements = editDetl.statements;

        const isSocietyJournal =
          editDetl?.submissionDetail?.journalType?.journalType ===
            "Society Journal" ||
          editDetl?.submissionDetail?.journalType ===
            "6454a6390d88e62fa10503bf" ||
          editDetl?.submissionDetail?.journalType?._id ===
            "6454a6390d88e62fa10503bf" ||
          editDetl?.journalType === "Society Journal" ||
          editDetl?.journalType === "6454a6390d88e62fa10503bf" ||
          editDetl?.journaldstype === "societyArticle";

        const queryParams = new URLSearchParams(router.search);
        const isSubmissionDetailsTab =
          queryParams.get("tab") === "submissionDetails" ||
          router.state?.tab === "submissionDetails";

        if (isSocietyJournal) {
          sessionStorage.removeItem("reupload_article_triggered");
        }
        if (isSocietyJournal && !isSubmissionDetailsTab) {
          setshowprePage(false);
        } else {
          setshowprePage(true);
        }
      }
      if (editDetl.status) {
        preDAta.status = editDetl.status;
      }
      if (
        editDetl.similarityCheckPercentage &&
        editDetl.similarityCheckPercentage > 15
      ) {
        preDAta.plagirismCheck = "notDone";
        preDAta.status = "draft";
      }
      if (editDetl.resubmissionRequested === true) {
        preDAta.plagirismCheck = "notDone";
        preDAta.status = "draft";
      }
      if (
        editDetl.articleStatus &&
        (editDetl.articleStatus === "sentForRevision" ||
          editDetl.articleStatus === "First Revision")
      ) {
        preDAta.plagirismCheck = "notDone";
        preDAta.status = "draft";
        if (editDetl.articleStatus === "sentForRevision") {
          const version = editDetl.articleVersion.split(" ");
          const newVersion = parseInt(version[1]) + 1;
          preDAta.articleVersion = `Version ${newVersion}`;
        }
        setisForRevision(true);
      }

      setpreStepData(preDAta);
      setcompletedTabs({ ...cmpTab });
      const data = articleContent;
      data.id = editDetl._id;
      data.title = editDetl.title;
      setmainTitle(editDetl.title);
      data.runningTitle = editDetl.runningTitle;
      data.abstract = editDetl.abstract;
      const refack = refranceAck;
      if (editDetl?.articleData?.references)
        refack.refrances = editDetl.articleData.references;
      if (editDetl?.articleData?.acknowledgement)
        refack.acknowledgements = editDetl.articleData.acknowledgement;
      setrefranceAck({ ...refack });
      const abbr = [];
      const abbrfull = [];
      if (editDetl?.abbreviations) {
        editDetl.abbreviations.forEach((abbreviation, k) => {
          abbr.push(abbreviation.apprv);
          abbrfull.push(abbreviation.fullForm);
        });
      }
      data.abbreviations = abbr;
      data.abbreviationsFull = abbrfull;
      if (editDetl?.status) {
        data.status = editDetl.status;
      }
      if (editDetl?.keywords) data.keywords = editDetl.keywords;
      if (editDetl?.supplymentaryMaterial)
        setsupplimentImges([...editDetl.supplymentaryMaterial]);
      const editorLength = [];
      const titleData = [];
      const DescData = [];
      const errorTitle = [];
      const isEditerTitleEdit = [];
      if (editDetl?.articleData?.articleSection && Array.isArray(editDetl.articleData.articleSection)) {
        editDetl.articleData.articleSection.forEach((detlart, k) => {
          editorLength.push(k);
          titleData.push({ val: detlart.title });
          DescData.push({ val: detlart.content });
          errorTitle.push({ val: "" });
          isEditerTitleEdit.push({ val: false });
        });
      }
      if (editorLength.length > 0) {
        seteditorTitleEdit([...isEditerTitleEdit]);
        seteditorLength([...editorLength]);
        seteditorTitleValue([...titleData]);
        seteditorContentValue([...DescData]);
        seteditorTitleValueError([...errorTitle]);
      }

      setarticleContent({ ...data });

      // Extract images freshly from the loaded HTML to fix previously corrupted drafts
      const allLoadedImg = [];
      const parser = new DOMParser();
      
      DescData.forEach((section) => {
        if (section.val) {
          const doc = parser.parseFromString(section.val, 'text/html');
          const images = doc.querySelectorAll('img');
          images.forEach((img) => {
            const src = img.getAttribute('src');
            if (src && checkUrl(src)) allLoadedImg.push(src);
          });
        }
      });
      if (refack.refrances) {
        const matches = [...refack.refrances.matchAll(imgRgx)];
        matches.forEach((m) => { if (m[1] && checkUrl(m[1])) allLoadedImg.push(m[1]); });
      }
      if (refack.acknowledgements) {
        const matches = [...refack.acknowledgements.matchAll(imgRgx)];
        matches.forEach((m) => { if (m[1] && checkUrl(m[1])) allLoadedImg.push(m[1]); });
      }
      
      if (allLoadedImg.length > 0) {
        setuploadeImages([...getUnique(allLoadedImg)]);
      } else if (editDetl?.images) {
        setuploadeImages(editDetl?.images);
      }

      // console.log(preDAta,"preDAta")
      setisEdited(false);
    }
  } catch (err) {
    console.error("Error in sucessHandler (submitArticle):", err);
  } finally {
    dispatch({ type: "SET_LOADER", payload: false });
  }
};
  const sucessHandlerUpdate = (articleDetails) => {
    if (articleDetails.status === 200) {
      if (postValueStatus === true) setsavedDraftArticle(true);
      else setpostValueStatus(true);
    }
    dispatch({ type: "SET_LOADER", payload: false });
  };

  const handleNavigation = (direction) => {
    setEditorContentGrammarIndex((prev) => {
      if (direction === "next") {
        if (prev === 0 && titleGrammarHandle) {
          // First "next" click: set title to false, keep index at 0
          setTitleGrammarHandle(false);
          return 0;
        }
        return prev + 1; // Increment index for subsequent clicks
      } else if (direction === "previous") {
        if (prev === 0) {
          // Trying to go back from index 0
          setTitleGrammarHandle(true);
          return 0; // Keep index at 0
        }
        return prev - 1; // Decrement index if above 0
      }
      return prev; // Default case (no change)
    });
  };

  const sucessHandlerSaveDraft = (articleDetails) => {
    // console.log("articleDetails  => ", articleDetails);
    // console.log("finalSubmitds  => ", finalSubmitds);
    if (iSaveDraftRef.current === 99) {
      if (articleDetails.status === 200) {
        const data = articleContent;
        const data1 = articleContent;
        data1.id = articleDetails.data.articleId;
        setarticleContent({ ...data1 });
        setpreStepData((prev) => ({
          ...prev,
          _id: articleDetails.data.articleId,
        }));
        setAutoSaveStatus("Saved");
        setTimeout(() => {
          setAutoSaveStatus("");
        }, 2000);
      }
      return;
    }
    if (articleDetails.status === 200) {
      const data = articleContent;
      if (
        finalSubmitds === "adminctrl" &&
        iSaveDraftRef.current !== 8 &&
        iSaveDraftRef.current !== 9
      ) {
        // console.log("finalSubmitds HEREEEEEE  => ");
        navigate("/myArticle/draft", { state: "draft" });
      }

      const data1 = articleContent;
      data1.id = articleDetails.data.articleId;
      setarticleContent({ ...data1 });
      setpreStepData((prev) => ({
        ...prev,
        _id: articleDetails.data.articleId,
      }));

      // console.log(articleDetails,'===========');
      if (
        articleDetails.data.articleId &&
        articleDetails?.data?.statements?.AakashGangaJournal
          ?.versionOfManuscript
      ) {
        data.id = articleDetails.data.articleId;
        // console.log(articleDetails.data.articleId,"articleIdarticleIdarticleIdarticleIdarticleId")
        handleRedirect(
          "",
          `/dashboard/edit-article/${articleDetails.data.articleId}`,
        );

        setarticleContent({ ...data });
      }
      if (
        articleDetails.data.articleId &&
        completedTabs.author &&
        finalSubmitds != "adminctrl"
      ) {
        handleRedirect(
          "",
          `/dashboard/edit-article/${articleDetails.data.articleId}`,
        );
      }
      const isEditArticlePage = router.pathname.includes(
        "/dashboard/edit-article",
      );
      if (
        iSaveDraftRef.current === 1 &&
        (lastSavedTabRef.current === "0" ||
          (isEditArticlePage && showprePageRef.current === false))
      ) {
        setsavedDetailsPupup(true);
      } else if (iSaveDraftRef.current === 2) {
        setprofanitySuccess(true);
      } else if (iSaveDraftRef.current === 3) {
        if (isUpdateNewVersion === false) setfinalSubmitConfirmPupup(true);
        else setisUpdateNewVersionPopup(true);
        // assigneReviwer();
      } else if (iSaveDraftRef.current === 4) {
        const articleID = articleContent.id;
        handleRedirect("", `/perviewArticle/${articleID}`);
      } else if (iSaveDraftRef.current === 5) {
        paymentInitiation();
      } else if (iSaveDraftRef.current === 6) {
        const w = articleWordLimit;
        w.detail = "";
        w.reqSuccessPopup = true;
        w.openPopup = false;
        setarticleWordLimit({ ...w });
      } else if (iSaveDraftRef.current === 7) {
        handleRedirect(
          "",
          `/manage-payment/${articleDetails.data.articleId || articleContent.id}`,
        );
      } else if (iSaveDraftRef.current === 8) {
        setsavedDraftArticle(true);
      } else if (iSaveDraftRef.current === 9) {
        setShowSimilarityInProgressModal(true);
      }
    }

    dispatch({ type: "SET_LOADER", payload: false });
  };
  const sucessHandlerSimillarityReport = (articleDetails) => {
    if (articleDetails.status === 200) {
      downLoadFile(articleDetails.data.url, "report.pdf");
    }
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const sucessHandlerFindReviewer = (articleDetails) => {
    if (articleDetails.status === 200) {
      setAppointArticleStatus(articleDetails?.data?.data?.status);
      if (isUpdateNewVersion === false) setfinalSubmitConfirmPupup(true);
      else setisUpdateNewVersionPopup(true);
    }
    dispatch({ type: "SET_LOADER", payload: false });
  };

  const errorHandlerArticle = (err) => {
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const { mutate: getArticleById } = FetchArticleById(
    sucessHandler,
    errorHandlerArticle,
  );
  const { mutate: updateArticle } = EditCurrentArticle(sucessHandlerUpdate);
  const { mutate: saveArticleToDraft } = SaveToDraft(sucessHandlerSaveDraft);
  const { mutate: downloadSimiliratyReport } = FetchSimiilarityReport(
    sucessHandlerSimillarityReport,
  );
  const { mutate: assigneArticleToReview } = findReviewer(
    sucessHandlerFindReviewer,
  );
  useEffect(() => {
    // let output = document.querySelector(`[id="output"]`);
    // var trinka = new Trinka({
    //   alertCountChangeEvent: (editorId, count) => { console.log('[AG-DEBUG] alert count updated', editorId, count) }
    // });
    // settrinka(trinka);
    // console.log('[AG-DEBUG] trinka instance ===> ', trinka);

    // const script = document.createElement("script");
    // script.src = TrinkaScript;
    // script.id = 'trinkaId'
    // script.async = true;
    // if (!document.getElementById('trinkaId')) {
    //   document.body.appendChild(script);
    // }

    dispatch({ type: "SET_LOADER", payload: false });
    getMasterList();

    if (router.pathname.includes("/dashboard/edit-article")) {
      const articleID = router.pathname.split("/")[3];
      setarticleID(articleID);
      getArticleDetail(articleID);
    } else {
      setisEdited(false);
    }
    getProfanity();
    handleAPCData();

    setMobileAlert(isMobile);
    fetchDictionary();
  }, []);

  useEffect(() => {
    // Initialize lastSavedPayloadRef when article content loads
    if (articleContent && articleContent.id && !lastSavedPayloadRef.current) {
      try {
        const initialPayload = getPayload("draft");
        lastSavedPayloadRef.current = JSON.stringify(
          initialPayload.saveDetails,
        );
      } catch (e) {
        // payload details might not be ready/valid yet
      }
    }
  }, [articleContent]);

  useEffect(() => {
    const interval = setInterval(() => {
      // Only auto-save if plagiarism check is not done and status is draft
      if (
        preStepData.plagirismCheck !== "notDone" ||
        preStepData.status !== "draft"
      ) {
        return;
      }

      // Check if we have a title (minimum requirement to save)
      if (!mainTitle) {
        return;
      }

      try {
        const payloadData = getPayload("draft");
        const currentPayloadStr = JSON.stringify(payloadData.saveDetails);

        // If nothing has changed, do not save
        if (currentPayloadStr === lastSavedPayloadRef.current) {
          return;
        }

        // Check runningTitle limit (draft check)
        if (articleContent.runningTitle) {
          const wordcount = articleContent.runningTitle.trim().split(" ");
          if (wordcount.length > 10) return;
        }
        if (mainTitle) {
          const wordcount = mainTitle.trim().split(" ");
          if (wordcount.length > 20) return;
        }

        // Perform quiet auto-save
        setAutoSaveStatus("Saving...");
        lastSavedPayloadRef.current = currentPayloadStr;

        const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
        const queryParams = {
          payload: payloadData.saveDetails,
          headers,
        };
        saveArticleToDraftApi(queryParams)
          .then((response) => {
            if (response?.status === 200) {
              const data1 = { ...articleContent };
              data1.id = response.data.articleId;
              setarticleContent(data1);
              setpreStepData((prev) => ({
                ...prev,
                _id: response.data.articleId,
              }));
              setAutoSaveStatus("Saved");
              setTimeout(() => {
                setAutoSaveStatus("");
              }, 2000);
            }
          })
          .catch((error) => {
            console.error("Auto save API error:", error);
          });
      } catch (error) {
        console.error("Auto save error:", error);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [
    articleContent,
    mainTitle,
    editorContentValue,
    supplimentImges,
    uploadeImages,
    preStepData,
    finalSubmitds,
  ]);

  const handleAPCData = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      typeOfApc: user.nationality ?? "withInIndia",
    };
    const response = await getAPCValues(headers, params);
    if (response?.status === 200) {
      setAPCData(response?.data?.data);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const sucessHandlerProfanity = (profanity) => {
    if (profanity.status === 200) {
      setProfanityWords(profanity.data.data);
    }
  };
  async function getProfanity() {
    // console.log("getProfanity",getProfanity);
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      headers: headers,
    };

    getProfanityList(queryParams);
  }
  const { mutate: getProfanityList } = FetchProfanityList(
    sucessHandlerProfanity,
  );
  async function getArticleDetail(id) {
    //
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { articleId: id },
      headers: headers,
    };

    getArticleById(queryParams);
  }

  function getDetailsInfo() {
    if (articleID === "") {
    }
    const isSocietyJournal =
      preStepData?.submissionDetail?.journalType?.journalType ===
        "Society Journal" ||
      preStepData?.submissionDetail?.journalType ===
        "6454a6390d88e62fa10503bf" ||
      preStepData?.submissionDetail?.journalType?._id ===
        "6454a6390d88e62fa10503bf" ||
      preStepData?.journalType === "Society Journal" ||
      preStepData?.journalType === "6454a6390d88e62fa10503bf" ||
      preStepData?.journaldstype === "societyArticle" ||
      preStepData?.paymentBySociety?.apcPayBySociety === true;

    if (isSocietyJournal) {
      sessionStorage.removeItem("reupload_article_triggered");
    }
    setshowprePage(true);
  }

  function checkInDictionary(data) {
    let vaild = true;
    if (editorDictionary?.reject.includes(data)) {
      vaild = false;
    } else if (editorDictionary?.word.includes(data)) {
      vaild = false;
    }
    return vaild;
  }

  const scrollToSection = (index) => {
    if (articleContentRefs.current[index]?.current) {
      articleContentRefs.current[index].current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  async function getMasterList() {
    const msterlst = await getAllMasterData();

    if (msterlst.status === 200) {
      setspecializationList(msterlst.data.specializationdata);
      const journalMaster = [];
      const journalType = [];
      msterlst.data.jouranlData.forEach((element) => {
        const data = { key: element._id, value: element.journalType };
        journalType.push(data);
        journalMaster[element._id] = element.journalName;
      });

      setgernalMaster(journalMaster);
      setgernalType(journalType);
      setdesciplineMaster(msterlst.data.disciplineData);
      const affiliation = [];
      msterlst.data.affiliateddata.forEach((element) => {
        const data = { key: element._id, value: element.affiliated };
        affiliation.push(data);
      });

      const subjectLists = [];
      const subjectSpecialization = [];
      msterlst.data.subjectdata.forEach((element) => {
        const data = { key: element._id, value: element.subjectName };
        subjectLists.push(data);
        subjectSpecialization[element._id] = element.specializationId;
      });

      setsubjectList(subjectLists);
      setsubjectSpecializationList(subjectSpecialization);
      const typeOfArticledata = [];
      msterlst.data.typeOfArticledata.forEach((element) => {
        const data = {
          key: element._id,
          value: element.articleName,
          description: element.description,
          wordCount: element.wordCount,
        };
        typeOfArticledata.push(data);
      });
      setarticleTypeList(typeOfArticledata);
    }
    setmasterDataLoaded(true);
  }
  const handleRedirect = (e, path, state = null) => {
    if (e !== "") e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    if (state) {
      navigate(path, state);
    } else {
      navigate(path);
    }
  };

  const escapeRegExpMatch = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  };
  const isExactMatch = (str, match) => {
    return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str);
  };

  function checkRequiredField(type) {
    const regex = /(<([^>]+)>)/gi;
    setblinkError("");
    const intro = editorContentValue[0].val.replace(regex, "");
    const data = articleContentError;
    let isError = false;
    let requiredFiled = "";
    if (
      !(
        articleContent.runningTitle == "" ||
        articleContent.runningTitle == undefined
      )
    ) {
      const wordcount = articleContent.runningTitle.trim().split(" ");
      if (wordcount.length > 10) {
        isError = true;
        data.runningTitleError =
          "A running title can be a maximum of 10 words in length.";
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      data.runningTitleError = "";
    }
    if (mainTitle === "" || mainTitle === undefined) {
      isError = true;
      data.titleError = "Please enter title";
      if (requiredFiled !== "") requiredFiled += ", ";
      requiredFiled += "Title";
    } else {
      data.titleError = "";
    }
    if (mainTitle != "") {
      const wordcount = mainTitle.trim().split(" ");

      if (wordcount.length > 20) {
        isError = true;
        data.titleError = "A title can be a maximum of 20 words in length.";
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      data.titleError = "";
    }

    const isConferencePaperSpecific =
      (preStepData?.submissionDetail?.journalType?.journalType ===
        "Society Journal" ||
        preStepData?.submissionDetail?.journalType ===
          "6454a6390d88e62fa10503bf") &&
      preStepData?.submissionDetail?.journalName ===
        "Applied and Basic Obesity, Diabetes and Endocrinology" &&
      (preStepData?.submissionDetail?.articleType?.articleType ===
        "Conference Paper" ||
        preStepData?.submissionDetail?.articleType?.value ===
          "Conference Paper" ||
        preStepData?.submissionDetail?.articleType ===
          "664aed76ada7b4f743b760a9" ||
        preStepData?.submissionDetail?.articleType?._id ===
          "664aed76ada7b4f743b760a9");

    const selArtType =
      preStepData?.submissionDetail?.articleType?.articleType ||
      preStepData?.submissionDetail?.articleType?.value ||
      preStepData?.submissionDetail?.articleType?.label ||
      (typeof preStepData?.submissionDetail?.articleType === "string"
        ? preStepData?.submissionDetail?.articleType
        : "") ||
      (typeof articleType === "string" ? articleType : "");

    const targetArtTypeId =
      preStepData?.submissionDetail?.articleType?._id ||
      (typeof preStepData?.submissionDetail?.articleType === "string"
        ? preStepData?.submissionDetail?.articleType
        : preStepData?.submissionDetail?.articleType?.key || articleType);

    const matchedArtTypeObj = articleTypeList?.find(
      (item) => item.key === targetArtTypeId || item._id === targetArtTypeId
    );

    const isMiniReview =
      selArtType === "Mini Review" ||
      matchedArtTypeObj?.value === "Mini Review" ||
      matchedArtTypeObj?.articleType === "Mini Review" ||
      matchedArtTypeObj?.articleName === "Mini Review";

    if (type !== "draft") {
      if (!isConferencePaperSpecific && !isMiniReview && articleContent.keywords.length < 5) {
        isError = true;
        data.keywordsError = "Minimum 5 keywords are required";
        // console.log("YESSSSSS");
        requiredFiled += "Keywords";
      }
      if (mainTitle === "" || mainTitle === undefined) {
        isError = true;
        data.titleError = "Please enter title";
        if (requiredFiled !== "") requiredFiled += ", ";
        requiredFiled += "Title";
      } else {
        data.titleError = "";
      }
      if (mainTitle != "") {
        const wordcount = mainTitle.trim().split(" ");

        if (wordcount.length > 20) {
          isError = true;
          data.titleError = "A title can be a maximum of 20 words in length.";
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        data.titleError = "";
      }
      if (!articleContent.abstract || articleContent.abstract === "") {
        isError = true;
        data.abstractError = "Please enter abstract";
        if (requiredFiled !== "") requiredFiled += ", ";
        requiredFiled += "Abstract";
      } else if (
        articleContent.abstract &&
        articleContent.abstract.split(" ").length > 500
      ) {
        isError = true;
        data.abstractError = "500 words are allowed";
      } else {
        data.abstractError = "";
      }
      if (intro === "") {
        isError = true;
        data.introductionError = "Please enter introduction";
        if (requiredFiled !== "") requiredFiled += ", ";
        requiredFiled += "Introduction";
      } else {
        data.introductionError = "";
      }

      if (isMiniReview) {
        const conclusionIdx = editorTitleValue.findIndex(
          (e) => e?.val?.toLowerCase()?.trim() === "conclusion"
        );
        const conclusionContent =
          conclusionIdx !== -1
            ? (editorContentValue[conclusionIdx]?.val || "")
                .replace(regex, "")
                .trim()
            : "";
        if (conclusionIdx === -1 || conclusionContent === "") {
          isError = true;
          data.conclusionError = "Please enter conclusion";
          if (requiredFiled !== "") requiredFiled += ", ";
          requiredFiled += "Conclusion";
        } else {
          data.conclusionError = "";
        }

        const referencesContent = (refranceAck?.refrances || "")
          .replace(regex, "")
          .trim();
        if (referencesContent === "") {
          isError = true;
          data.referencesError = "Please enter references";
          if (requiredFiled !== "") requiredFiled += ", ";
          requiredFiled += "References";
        } else {
          data.referencesError = "";
        }
      } else {
        data.conclusionError = "";
        data.referencesError = "";
      }
    }
    const editorTitleError = editorTitleValueError;
    let titleerro = false;
    let allEditorContent = "";
    for (let e = 0; e < editorLength.length; e++) {
      if (!isConferencePaperSpecific && !isMiniReview && editorTitleValue[e].val === "") {
        titleerro = true;
        editorTitleError[e].val = "This filed is required";
      } else {
        if (editorTitleValue[e].val !== "Introduction")
          allEditorContent += editorContentValue[e].val;
      }
    }

    const htmlFreeData = allEditorContent.replace(regex, "");
    const actualWordCount = allEditorContent.replace(/(<([^>]+)>)/ig, " ").trim().split(/\s+/).filter(w => w !== "").length;
    const wrdlimit = articleWordLimit;
    const isSocietyJournal = (preStepData?.submissionDetail?.journalType?.journalType === "Society Journal" || preStepData?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" || preStepData?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf");
    
    if (
      !isConferencePaperSpecific &&
      !isMiniReview &&
      (isSocietyJournal ? actualWordCount > 10000 : htmlFreeData.split(" ").length > 10000) &&
      type !== "draft" &&
      articleWordLimit.wordLimitStatus !== "approved"
    ) {
      isError = true;
      if (requiredFiled === "") {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setblinkError("ATTENTION: Word limit exceeded");
        wrdlimit.openPopup = true;
        wrdlimit.isIncrease = true;
        wrdlimit.isDecrease = false;
        setarticleWordLimit({ ...wrdlimit });
      }
    } else if (
      !isConferencePaperSpecific &&
      !isMiniReview &&
      (isSocietyJournal ? actualWordCount < 1000 : htmlFreeData.split(" ").length < 200) &&
      type !== "draft" &&
      articleWordLimit.wordLimitStatus !== "approved"
    ) {
      isError = true;
      if (requiredFiled === "") {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setblinkError("ATTENTION: Word Limit Requirement Not Met");
        wrdlimit.openPopup = true;
        wrdlimit.isIncrease = false;
        wrdlimit.isDecrease = true;
        setarticleWordLimit({ ...wrdlimit });
      }
    }

    if (!isConferencePaperSpecific && !isMiniReview && titleerro === true) {
      isError = true;
      seteditorTitleValueError([...editorTitleError]);
    }
    setmendatoryAlert("");
    if (requiredFiled !== "") {
      setmendatoryAlert(`Mandatory Sections - ${requiredFiled}`);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setarticleContentError({ ...data });
    return isError;
  }

  function sendLimitReason() {
    const w = articleWordLimit;
    if (
      articleWordLimit.detail !== "" &&
      articleWordLimit.wordLimitStatus !== "newRequest"
    ) {
      setiSaveDraft(6);
      dispatch({ type: "SET_LOADER", payload: true });
      const data = getPayload("draft");
      let wtype = "Less than 8k";
      if (articleWordLimit.isIncrease === true) wtype = "More than 10k";
      data.saveDetails.wordLimit = true;
      data.saveDetails.wordLimitType = wtype;
      data.saveDetails.wordLimitReason = articleWordLimit.detail;
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const queryParams = {
        payload: data.saveDetails,
        headers,
      };
      w.wordLimitStatus = "newRequest";
      w.wordLimitType = wtype;
      saveArticleToDraft(queryParams);
    } else if (
      articleWordLimit.detail === "" &&
      articleWordLimit.wordLimitStatus !== "newRequest"
    ) {
      w.detailError = "Please provide valid reason";
    } else if (articleWordLimit.wordLimitStatus === "newRequest") {
      w.alreadyExistReqPopup = true;
      w.openPopup = false;
    }
    setarticleWordLimit({ ...w });
  }

  function collectUpdates() {
    const data = editorContentValueRef.current;
    if (!data || !Array.isArray(data)) return;
    for (let k = 0; k < editorLength.length; k++) {
      if (!data[k]) continue;
      const refObj =
        articleContentRefs[k] ||
        (articleContentRefs.current && articleContentRefs.current[k]);
      let newContent = undefined;
      if (refObj && typeof refObj.getEditorContent === "function") {
        try {
          newContent = refObj.getEditorContent();
        } catch (e) {}
      }
      if (
        newContent !== undefined &&
        newContent !== null &&
        newContent !== ""
      ) {
        data[k].val = newContent;
      }
    }
    seteditorContentValue([...data]);
  }

  function getPayload(type) {
    collectUpdates();
    const { id } = jwt_decode(localStorage.usertoken);

    const abbreviations = [];
    for (let i = 0; i < articleContent.abbreviations.length; i++) {
      const abbre = {
        apprv: articleContent.abbreviations[i],
        fullForm: articleContent.abbreviationsFull[i],
      };
      abbreviations.push(abbre);
    }
    const articleSection = [];
    let plagrism = "";

    for (let k = 0; k < editorLength.length; k++) {
      const cVal =
        editorContentValue[k]?.val !== undefined &&
        editorContentValue[k]?.val !== null
          ? editorContentValue[k].val
          : "";
      const content = {
        title: editorTitleValue[k]?.val || "",
        content: cVal,
        order: k + 1,
      };
      articleSection.push(content);
      if (cVal) {
        plagrism += cVal + " ";
      }
    }
    plagrism += (refranceAck.acknowledgements || "") + " ";
    const data = {
      userId: id,
      title: mainTitle,
      runningTitle: articleContent.runningTitle,
      abstract: articleContent.abstract,
      articleSection: articleSection,
      keywords: articleContent.keywords,
      formulae: [],
      citations: [],
      abbreviations: abbreviations,
      supplymentaryMaterial: supplimentImges,
      status: type,
      stage: finalSubmitds,
      images: uploadeImages,
      acknowledgement: acknowledgementRef.current?.getEditorContent(),
      references: refranceRef.current?.getEditorContent(),
      articleXmlFormat:
        articleXmlFormat || sessionStorage.getItem("articleXmlFormat") || "",
    };
    if (articleContent.id !== "") data.articleId = articleContent.id;

    const detailsData = { saveDetails: data, plagrismeCheck: plagrism };
    return detailsData;
  }

  async function saveArticleDetails(type) {
    const { id } = jwt_decode(localStorage.usertoken);
    const abbreviations = [];
    for (let i = 0; i < articleContent.abbreviations.length; i++) {
      const abbre = {
        apprv: articleContent.abbreviations[i],
        fullForm: articleContent.abbreviationsFull[i],
      };
      abbreviations.push(abbre);
    }
    let articleSection = [];
    let plagrism = "";

    for (let k = 0; k < editorLength.length; k++) {
      const cVal =
        editorContentValue[k]?.val !== undefined &&
        editorContentValue[k]?.val !== null
          ? editorContentValue[k].val
          : "";
      const content = {
        title: editorTitleValue[k]?.val || "",
        content: cVal,
        order: k + 1,
      };
      articleSection.push(content);
      if (cVal) {
        plagrism += cVal + " ";
      }
    }

    if (articleSection.length > 0) {
      articleSection = await processAndUploadFigureImages(articleSection);
    }

    plagrism += refranceAck.acknowledgements + " ";
    plagrism += refranceAck.refrances + " ";
    const data = {
      userId: id,
      title: mainTitle,
      runningTitle: articleContent.runningTitle,
      abstract: articleContent.abstract,
      articleSection: articleSection,
      keywords: articleContent.keywords,
      formulae: [],
      citations: [],
      abbreviations: abbreviations,
      supplymentaryMaterial: supplimentImges,
      status: type,
      stage: finalSubmitds,
      images: uploadeImages,
      acknowledgement: acknowledgementRef.current?.getEditorContent(),
      references: refranceRef.current?.getEditorContent(),
      articleXmlFormat:
        articleXmlFormat || sessionStorage.getItem("articleXmlFormat") || "",
    };
    if (articleContent.id !== "") data.articleId = articleContent.id;

    const detailsData = { saveDetails: data, plagrismeCheck: plagrism };
    return detailsData;
  }
  async function submitAsDraft() {
    setprofanityAlert({ isOPen: false, type: 0 });
    const isRequired = checkRequiredField("draft");
    if (isRequired === false) {
      setiSaveDraft(1);
      dispatch({ type: "SET_LOADER", payload: true });

      const data = getPayload("draft");
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const queryParams = {
        payload: data.saveDetails,
        headers,
      };
      removeRedColorStyle();
      saveArticleToDraft(queryParams);
    }
  }
  async function previewArticle() {
    setprofanityAlert({ isOPen: false, type: 0 });
    const articleId =
      preStepData?._id || preStepData?.id || articleContent?.id || "current";
    const savedPdfData =
      pdfPreviewUrl ||
      sessionStorage.getItem(`generated_pdf_data_${articleId}`) ||
      sessionStorage.getItem(`generated_pdf_url_${articleId}`);
    if (savedPdfData) {
      setPdfPreviewUrl(savedPdfData);
      setShowPdfPreviewModal(true);
      return;
    }

    const isRequired = checkRequiredField("draft");
    if (isRequired === false) {
      setiSaveDraft(4);
      dispatch({ type: "SET_LOADER", payload: true });

      const data = getPayload("draft");
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const queryParams = {
        payload: data.saveDetails,
        headers,
      };
      if (preStepData?.plagirismCheck === "Done") {
        dispatch({ type: "SET_LOADER", payload: false });
        const articleID = articleContent.id;
        handleRedirect("", `/perviewArticle/${articleID}`);
      } else {
        saveArticleToDraft(queryParams);
      }
    }
  }

  const processGrammarCheck = async (content, index) => {
    try {
      let guessName =
        index == 0
          ? "title"
          : index == 1
            ? "runningTitle"
            : index == 2
              ? "abstract"
              : "None";
      const response = await checkGrammar(content, guessName);
      const resultTitle = response?.data?.data;

      const modifiedResponse = resultTitle?.response?.map((item) => ({
        ...item,
        begin: item?.begin, // Default value
        end: item?.end, // Default value
      }));

      setEditorTitleGrammar((prevState) => {
        const newState = [...prevState]; // Create a shallow copy of the previous state
        newState[index] = modifiedResponse; // Update the state at the correct index
        return newState;
      });
      setGrammarModal(true);
    } catch (error) {
      console.error("Error during grammar check:", error);
    } finally {
      dispatch({ type: "SET_LOADER", payload: false });
    }
  };

  const addToDictionaryMain = async () => {
    const { id } = jwt_decode(localStorage.usertoken);
    const articleId = router.pathname.split("/")[3];
    const response = await addToDictionaryFun(
      editorAddToDictionaryWords,
      id,
      editorRejectedWords,
    );
    // console.log(response);
  };
  const checkGrammarTool = async () => {
    setEditorTitleGrammar([{}, {}, {}]);
    setEditorContentGrammarIndex(0);
    setTitleGrammarHandle(true);
    setGrammarWaiting(false);

    if (mainTitle !== "") {
      dispatch({ type: "SET_LOADER", payload: true });
      await processGrammarCheck(mainTitle, 0);
      dispatch({ type: "SET_LOADER", payload: false });
      setGrammarModal(true);
    }
    if (articleContent?.runningTitle !== "") {
      await processGrammarCheck(articleContent?.runningTitle, 1);
    }

    if (articleContent?.abstract !== "") {
      await processGrammarCheck(articleContent?.abstract, 2);
    }

    seteditorContentGrammar([{}, {}, {}, {}, {}, {}]);

    for (let i = 0; i < articleContentRefs.current.length; i++) {
      const value = articleContentRefs[i]?.getEditorContent();
      // console.log("valuevaluevalue", value);

      const response = await checkGrammar(value, editorTitleValue[i].val);

      const result = response?.data?.data;
      setGrammarFound(result?.response);

      const modifiedResponse = result?.response?.map((item) => ({
        ...item,
        begin: item?.begin, // Default value
        end: item?.end, // Default value
      }));

      setStateGrammarFound(modifiedResponse);

      if (i == 5) {
        setGrammarWaiting(true);
      }

      seteditorContentGrammar((prevState) => {
        const newState = [...prevState]; // Create a shallow copy of the previous state
        newState[i] = modifiedResponse; // Set amended content at the correct index
        return newState;
      });
    }
  };

  // const makeGrammarAmendments = () => {
  //   const value = articleContentRefs[1]?.getEditorContent(); // Get content from the editor

  //   let finalContent = value; // Start with the current content

  //   // Process stateGrammarFound items in reverse order
  //   for (let i = stateGrammarFound.length - 1; i >= 0; i--) {
  //     const item = stateGrammarFound[i];
  //     if (item?.begin !== undefined && item?.end !== undefined && item?.correct !== undefined) {
  //       // Loop in reverse order
  //       for (let index = item?.result.length - 1; index >= 0; index--) {
  //         const child = item?.result[index];
  //         console.log("Start word", child?.begin + item?.begin);
  //         console.log("End word", child?.begin + item?.end);
  //         if (child?.status == "accepted") {
  //           finalContent = finalContent.slice(0, child?.begin + item?.begin) + child?.suggestions[0].suggestion + finalContent.slice(item?.begin + child?.end + 1);
  //         }
  //       }
  //       // console.log("Accepted:", finalContent);
  //       console.log(new Date().toLocaleString());
  //     }
  //   }

  //   console.log("finalContent", finalContent);
  //   // debugger;
  //   // After amendments, update the state with the final content
  //   // seteditorContentValue(prevState => {
  //   //   const newState = [...prevState]; // Create a shallow copy of the previous state
  //   //   newState[1].val = finalContent; // Set amended content at index 1
  //   //   return newState;
  //   // });
  // }

  const makeGrammarAmendments = () => {
    const articleContentdata = articleContent;
    for (let i = 0; i < editorTitleGrammar.length; i++) {
      let value;
      if (i == 0) {
        value = mainTitle;
      } else if (i == 1) {
        value = articleContent?.runningTitle;
      } else if (i == 2) {
        value = articleContent?.abstract;
      }

      let finalContent = value; // Start with the current content
      if (editorTitleGrammar[i]?.length > 0) {
        // Process stateGrammarFound items in reverse order
        for (let j = editorTitleGrammar[i].length - 1; j >= 0; j--) {
          const item = editorTitleGrammar[i][j];
          if (
            item?.begin !== undefined &&
            item?.end !== undefined &&
            item?.correct !== undefined
          ) {
            // Loop in reverse order through item.result
            for (let k = item?.result.length - 1; k >= 0; k--) {
              const child = item?.result[k];
              // console.log("Start word", child?.begin + item?.begin);
              // console.log("End word", child?.begin + item?.end);
              if (child?.status == "accepted") {
                finalContent =
                  finalContent.slice(0, child?.begin + item?.begin) +
                  child?.suggestions[0].suggestion +
                  finalContent.slice(item?.begin + child?.end + 1);
              } else if (child?.status == "addToDictionary") {
                AddDictionaryWord(child?.suggestions[0].suggestion);
              } else if (child?.status == "rejected") {
                AddRejectedWord(child?.suggestions[0].suggestion);
              }
            }
            // console.log("Accepted:", finalContent);
            // console.log(new Date().toLocaleString());
          }
        }
      }

      // After amendments, update the state with the final content
      if (i == 0) {
        setmainTitle(finalContent);
        articleContentdata.title = finalContent;
      } else if (i == 1) {
        articleContentdata.runningTitle = finalContent;
      } else if (i == 2) {
        articleContentdata.abstract = finalContent;
      }
    }
    setarticleContent({ ...articleContentdata });

    // Loop through each editor content in articleContentRefs
    // console.log("---------",articleContentRefs.current);
    for (let i = 0; i < articleContentRefs.current.length; i++) {
      const value = articleContentRefs[i]?.getEditorContent(); // Get content from the editor

      let finalContent = value; // Start with the current content
      if (editorContentGrammar[i]?.length > 0) {
        // Process stateGrammarFound items in reverse order
        for (let j = editorContentGrammar[i].length - 1; j >= 0; j--) {
          const item = editorContentGrammar[i][j];
          if (
            item?.begin !== undefined &&
            item?.end !== undefined &&
            item?.correct !== undefined
          ) {
            // Loop in reverse order through item.result
            for (let k = item?.result.length - 1; k >= 0; k--) {
              const child = item?.result[k];
              if (child?.status == "accepted") {
                finalContent =
                  finalContent.slice(0, child?.begin + item?.begin) +
                  child?.suggestions[0].suggestion +
                  finalContent.slice(item?.begin + child?.end + 1);
              } else if (child?.status == "addToDictionary") {
                AddDictionaryWord(child?.suggestions[0].suggestion);
              } else if (child?.status == "rejected") {
                AddRejectedWord(child?.suggestions[0].suggestion);
              }
            }
            // console.log("Accepted:", finalContent);
            // console.log(new Date().toLocaleString());
          }
        }
      }

      // console.log("finalContent for index", i, finalContent);

      // After amendments, update the state with the final content
      seteditorContentValue((prevState) => {
        const newState = [...prevState]; // Create a shallow copy of the previous state
        newState[i].val = finalContent; // Set amended content at current index
        return newState;
      });
    }
    addToDictionaryMain();
  };

  const toggleGrammar = (index, key) => {
    setStateGrammarFound((prevState) =>
      prevState.map((item, idx) => {
        if (idx === index) {
          // If toggling 'accepted', reset 'rejected', and vice versa
          return {
            ...item,
            [key]: !item[key],
            ...(key === "accepted" && { rejected: false }),
            ...(key === "rejected" && { accepted: false }),
          };
        }
        return item;
      }),
    );
  };

  const updateResultStatus = (
    parentInx,
    index,
    resultIndex,
    status,
    secName = null,
  ) => {
    if (secName == "titleGrammarSection") {
      setEditorTitleGrammar((prevState) => {
        const updatedState = [...prevState]; // Create a copy of the state to avoid direct mutation
        const result = (updatedState[parentInx][index].result[
          resultIndex
        ].status = status); // Get the specific result to update
        // result.status = status;

        return updatedState; // Return the updated state
      });
    } else {
      seteditorContentGrammar((prevState) => {
        const updatedState = [...prevState]; // Create a copy of the state to avoid direct mutation
        const result = (updatedState[parentInx][index].result[
          resultIndex
        ].status = status); // Get the specific result to update
        // result.status = status;

        return updatedState; // Return the updated state
      });
    }
  };
  const extractClosestWords = (text, startIndex, endIndex) => {
    // Ensure indices are within bounds
    if (startIndex < 0) startIndex = 0;
    if (endIndex >= text.length) endIndex = text.length - 1;

    // Helper function to find the start of a word
    function findWordStart(index) {
      while (index > 0 && !/\s/.test(text[index - 1])) {
        index--;
      }
      return index;
    }

    // Helper function to find the end of a word
    function findWordEnd(index) {
      while (index < text.length && !/\s/.test(text[index])) {
        index++;
      }
      return index;
    }

    // Find the closest word start and end for the given indices
    const startWordStart = findWordStart(startIndex);
    const endWordEnd = findWordEnd(endIndex);

    // Extract the substring containing the closest words
    return text.substring(startWordStart, endWordEnd).trim();
  };

  const submitArticleWithGrammar = async () => {
    // collectUpdates();
    // let allEditorContent = "";
    // dispatch({ type: "SET_LOADER", payload: true });
    let error = false;
    // const regex = /(<([^>]+)>)/gi;
    // for (let e = 0; e < editorLength.length; e++) {
    //   if(editorTitleValue[e].val!=='') {
    //     const data= editorContentValue[e].val;
    //     const htmlFreeData = data.replace(regex, "");
    //       //  const response = await checkGrammar(htmlFreeData);
    //        const result = response?.data?.url?.sentences;
    //        result?.map((sentence) => {
    //         sentence.result?.forEach((item) => {
    //           if (
    //             (item?.cta_present?.[0] === true && (item?.error_category?.[0] === "Word/Phrase choice" && item?.error_category?.[0] === "Spellings & Typos" && item?.error_category?.[0] === "Verbs" && item?.error_category?.[0] === "Subject-verb agreement")) ||
    //             (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Word/Phrase choice") ||
    //             (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Spellings & Typos") ||
    //             (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Verbs") ||
    //             (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Subject-verb agreement")
    //           ) {
    //             error = true;

    //           } else {

    //           }
    //         })
    //       })
    //   }
    // }
    // const refData= refranceRef.current?.getEditorContent();
    // if(refData=='') {
    // const htmlFreeDataRef = refData.replace(regex, "");
    // const responseRef = await checkGrammar(htmlFreeDataRef);
    // const resultRef = responseRef?.data?.url?.sentences;
    //  resultRef?.map((sentence) => {
    //       sentence.result?.forEach((item) => {
    //         if (
    //           (item?.cta_present?.[0] === true && (item?.error_category?.[0] === "Word/Phrase choice" && item?.error_category?.[0] === "Spellings & Typos" && item?.error_category?.[0] === "Verbs" && item?.error_category?.[0] === "Subject-verb agreement")) ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Word/Phrase choice") ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Spellings & Typos") ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Verbs") ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Subject-verb agreement")
    //         ) {
    //           error = true;

    //         }
    //       })
    //     })
    //   }
    //   const ackData= acknowledgementRef.current?.getEditorContent();
    //   if(ackData=='') {

    // const htmlFreeDataackData = ackData.replace(regex, "");
    // const responseAck = await checkGrammar(htmlFreeDataackData);
    // const resultAck = responseAck?.data?.url?.sentences;
    // resultAck?.map((sentence) => {
    //       sentence.result?.forEach((item) => {
    //         if (
    //           (item?.cta_present?.[0] === true && (item?.error_category?.[0] === "Word/Phrase choice" && item?.error_category?.[0] === "Spellings & Typos" && item?.error_category?.[0] === "Verbs" && item?.error_category?.[0] === "Subject-verb agreement")) ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Word/Phrase choice") ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Spellings & Typos") ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Verbs") ||
    //           (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Subject-verb agreement")
    //         ) {
    //           error = true;

    //         }
    //       })
    //     })
    //   }
    if (error === true) {
      dispatch({ type: "SET_LOADER", payload: false });
      setSpellCheckModal(true);
      return;
    } else {
      // dispatch({ type: "SET_LOADER", payload: false });
      // setblinkError("");
      submit();
    }
  };

  function submit() {
    const isRequired = checkRequiredField("similarityCheck");
    if (isRequired === false) setsaveArticleConfirmationNew(true);
  }

  function assigneReviwer() {
    dispatch({ type: "SET_LOADER", payload: true });

    const data = {
      articleId: articleContent.id,
    };
    const saveData = { headers: headers, payload: data };
    assigneArticleToReview(saveData);
  }

  function finalSubmitNow() {
    dispatch({ type: "SET_LOADER", payload: true });
    setiSaveDraft(3);
    setfinalSubmitPupup(false);
    const { id } = jwt_decode(localStorage.usertoken);
    var journaldstype = "";
    if (
      preStepData?.submissionDetail?.journalType?.journalType ===
      "Society Journal"
    ) {
      var journaldstype = "societyArticle";
    }
    const data = {
      userId: id,
      articleId: articleContent.id,
      status: "submit",
      peStatus: preStepData.articleVersion !== "" ? "draft" : "",
      journaldstype: journaldstype,
    };
    if (preStepData.articleVersion !== "")
      data.articleVersion = preStepData.articleVersion;
    const saveData = { headers: headers, payload: data };
    saveArticleToDraft(saveData);
  }

  async function confirmToSubmitArticle(skipProfanity = false) {
    setsaveArticleConfirmationNew(false);
    setfinalSubmitds("false");
    setprofanityAlert({ isOPen: false, type: 0 });

    // dispatch({ type: "SET_LOADER", payload: true });
    // const data = getPayload("similarityCheck");
    const data = getPayload("submit");

    console.log(data);

    // setiSaveDraft(2);
    removeRedColorStyle();
    let isProfinityWord = false;
    const profanityWordList = [];
    const cleanText = data.plagrismeCheck.replace(/(<([^>]+)>)/gi, "");
    for (var i = 0; i < profanityWords.length; i++) {
      if (isExactMatch(cleanText.toLowerCase(), profanityWords[i])) {
        isProfinityWord = true;
        profanityWordList.push(profanityWords[i]);
      }
    }

    console.log("profanityWordList", profanityWordList);
    console.log("profanityWords", profanityWords);
    if (!skipProfanity && isProfinityWord) {
      data.saveDetails.profanityWordsPresent = {
        isPresent: true,
        words: profanityWordList,
        isFlaggedToUs: true,
      };
      data.saveDetails.isProfaneFlagged = true;
      data.saveDetails.isFlaggedToUs = true;
      const saveData = { headers: headers, payload: data.saveDetails };
      saveArticleToDraft(saveData);

      setProfanityWordsFound(profanityWordList);
      setprofanityAlert({ isOPen: true, type: 0 });
      dispatch({ type: "SET_LOADER", payload: false });
      setblinkError("PROFANITY CHECK RESULTS");
    } else {
      setiSaveDraft(0);
      setshowGrammarSucessModal(true);
      setfinalSubmitds("submitted");
      data.saveDetails.stage = "submitted";
      data.saveDetails.status = "submit";
      const saveData = { headers: headers, payload: data.saveDetails };
      saveArticleToDraft(saveData);
    }
  }

  const runSimilarityCheck = async (targetSaveDraftType = 0) => {
    setShowSimilarityInProgressModal(false);
    setshowGrammarSucessModal(false);
    dispatch({ type: "SET_LOADER", payload: true });
    setfinalSubmitds("adminctrl");

    const data = getPayload("submit");
    data.saveDetails.stage = "adminctrl";
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const saveData = { headers: headers, payload: data.saveDetails };

    setiSaveDraft(targetSaveDraftType);
    saveArticleToDraft(saveData);
  };

  async function confirmToSubmitArticleOld() {
    setsaveArticleConfirmation(false);
    dispatch({ type: "SET_LOADER", payload: true });
    const data = getPayload("submit");

    const fileData = data.plagrismeCheck;
    let isProfinityWord = false;
    const profanityWordList = [];
    const cleanText = fileData.replace(/(<([^>]+)>)/gi, "");
    for (var i = 0; i < profanityWords.length; i++) {
      if (isExactMatch(cleanText.toLowerCase(), profanityWords[i])) {
        isProfinityWord = true;
        profanityWordList.push(profanityWords[i]);
      }
    }
    if (isProfinityWord) {
      data.saveDetails.profanityWordsPresent = {
        isPresent: true,
        words: profanityWordList,
      };
      setProfanityWordsFound(profanityWordList);
      setprofanityAlert({ isOPen: true, type: 0 });
      dispatch({ type: "SET_LOADER", payload: false });
    } else {
      const blob = new Blob([fileData], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      const txtFile = new File([blob], "down.html", { type: "text/html" });
      const formData = new FormData();
      formData.append("file", txtFile);
      const link = document.createElement("a");
      link.download = "user-info.html";
      link.href = url;
      link.click();

      try {
        const resp = await UploadArticleContent({
          data: formData,
          headers,
          userId: tokenVal?.id,
        });
        data.saveDetails.similarityCheckId = resp.data.data.similaritycheckId;
        setUnicheckData({
          ...unicheckData,
          similaritycheckId: resp.data.data.similaritycheckId,
        });
      } catch (err) {
        alert("Unicheck Error First");
        dispatch({ type: "SET_LOADER", payload: false });
      }
      setTimeout(function () {
        checkSimilartyReport(data);
      }, 10000);
    }
  }
  async function checkSimilartyReport(data) {
    try {
      const resp = await startSimilarityCheck({
        data: {
          similarityCheckId: data.saveDetails.similarityCheckId,
          userId: tokenVal?.id,
        },
        headers,
      });
      if (resp.status === 200) {
        if (resp.data.data.similarityCheckResult.attributes.similarity < 40) {
          const saveData = { headers: headers, payload: data.saveDetails };
          saveArticleToDraft(saveData);

          setsavedDraftArticle(true);
          dispatch({ type: "SET_LOADER", payload: false });
        } else {
          setPlagiarismAlert(true);

          dispatch({ type: "SET_LOADER", payload: false });
        }
      }
    } catch (err) {
      alert("Unicheck Error Second");
      dispatch({ type: "SET_LOADER", payload: false });
    }
  }

  function submit() {
    const isRequired = checkRequiredField();
    if (isRequired === false) setsaveArticleConfirmationNew(true);
  }

  function editInputLable(key) {
    const edit = editorTitleEdit;
    edit[key].val = true;
    seteditorTitleEdit([...edit]);
  }

  const downloadReport = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    const input = document.getElementById("textContent");
    input.style.display = "block";
    const fileData = JSON.stringify(input.innerHTML);
    let isProfinityWord = false;
    const cleanText = fileData.replace(/(<([^>]+)>)/gi, "");
    for (var i = 0; i < profanityWords.length; i++) {
      if (isExactMatch(cleanText.toLowerCase(), profanityWords[i]))
        isProfinityWord = true;
    }
    if (isProfinityWord) {
      alert("Profanity Word found");
      dispatch({ type: "SET_LOADER", payload: false });
      return false;
    }

    html2canvas(input).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("download.pdf");

      try {
        const resp = await downloadSimiliratyReport({
          data: {
            similarityCheckId: unicheckData.similaritycheckId,
            userId: tokenVal?.id,
          },
          headers,
        });
      } catch (err) {
        debugger;
      }
    });
    dispatch({ type: "SET_LOADER", payload: false });
  };

  function editorContent(content, type, key) {
    const regex = /(<([^>]+)>)/gi;
    const dataError = articleContentError;
    const data = editorContentValueRef.current;
    if (key === "acknowledgements") {
      const data = refranceAck;
      data.acknowledgements = content;
      setrefranceAck({ ...data });
    } else if (key === "references") {
      const data = refranceAck;
      data.refrances = content;
      setrefranceAck({ ...data });
      const refText = content.replace(regex, "").trim();
      if (refText !== "") dataError.referencesError = "";
      setarticleContentError({ ...dataError });
    } else {
      data[key].val = content;
      seteditorContentValue([...data]);
      if (editorTitleValue[key]?.val === "Introduction") {
        const abstrct = content.replace(regex, "");
        if (abstrct !== "") dataError.introductionError = "";
        setarticleContentError({ ...dataError });
      }
      if (editorTitleValue[key]?.val?.toLowerCase()?.trim() === "conclusion") {
        const concText = content.replace(regex, "").trim();
        if (concText !== "") dataError.conclusionError = "";
        setarticleContentError({ ...dataError });
      }
    }

    // Always sync the extracted images when content changes
    getExtractImageFromContent(data);
  }

  const handleEditorChange = (html, key) => {
    console.log(key);
    console.log(html);
  };

  const makeProfinityCheck = () => {
    let foundWords = []; // Temporary array to store matched words
    const totalItems = Math.max(
      articleContentRefs.current?.length || 0,
      editorContentValue?.length || 0,
    );

    for (let i = 0; i < totalItems; i++) {
      let value =
        articleContentRefs.current[i]?.getEditorContent?.() ||
        editorContentValue[i]?.val ||
        "";
      let matches = []; // Store found profanity words for this content

      if (value) {
        const cleanText = value.replace(/(<([^>]+)>)/gi, "");
        profanityWordsFound.forEach((word) => {
          const safeWord = escapeRegExpMatch(word);
          const regex = new RegExp(`\\b${safeWord}\\b`, "gi"); // Match whole word case-insensitively
          if (cleanText.match(regex)) {
            matches.push(word); // Store matched word
          }
          // Safely replace in HTML: only if not inside a tag
          value = value.replace(
            new RegExp(`(<[^>]+>)|(\\b${safeWord}\\b)`, "gi"),
            (match, tag, wordMatch) =>
              tag ? tag : `<strong style="color:red;">${wordMatch}</strong>`,
          );
        });

        // Store found words with reference index
        if (matches.length > 0) {
          foundWords.push({
            index: i,
            words: matches,
            ref: articleContentRefs.current[i],
          });
        }

        // Update the editor content with highlighted words
        seteditorContentValue((prevState) => {
          const newState = [...prevState];
          if (newState[i]) {
            newState[i] = { ...newState[i], val: value };
          }
          return newState;
        });
      }
    }

    // Update state with found profanity words
    setProfanityMatches(foundWords);
  };

  // const makeProfinityCheck = () => {
  //   for (let i = 0; i < articleContentRefs.current.length; i++) {
  //     let value = articleContentRefs[i]?.getEditorContent(); // Get content from the editor

  //     if (value) {
  //       profanityWordsFound.forEach(word => {
  //         const regex = new RegExp(`\\b${word}\\b`, 'gi'); // Match whole word case-insensitively
  //         value = value.replace(regex, `<strong style="color:red;">${word}</strong>`);
  //       });

  //       // Update the content after highlighting

  //       seteditorContentValue(prevState => {
  //         const newState = [...prevState]; // Create a shallow copy of the previous state
  //         newState[i].val = value; // Set amended content at current index
  //         return newState;
  //       });
  //     }

  //   }
  // }

  function removeRedColorStyle() {
    for (let i = 0; i < articleContentRefs.current.length; i++) {
      let value = articleContentRefs[i]?.getEditorContent(); // Get content from the editor

      if (value) {
        // Remove the <strong> tags and the inline styles
        value = value.replace(
          /<strong style="color:red;">(.*?)<\/strong>/gi,
          "$1",
        );

        // Update the content after removing the style
        seteditorContentValue((prevState) => {
          const newState = [...prevState]; // Create a shallow copy of the previous state
          newState[i].val = value; // Set amended content at current index
          return newState;
        });
      }
    }
  }

  function getExtractImageFromContent(editorContentDetails) {
    const allImg = [];
    
    // Create a DOM element to parse HTML safely
    const parser = new DOMParser();

    for (let j = 0; j < editorContentDetails.length; j++) {
      const content = editorContentDetails[j].val;
      if (content && content !== "") {
        const doc = parser.parseFromString(content, 'text/html');
        const images = doc.querySelectorAll('img');
        images.forEach((img) => {
          const src = img.getAttribute('src');
          if (src && checkUrl(src)) {
            allImg.push(src);
          }
        });
      }
    }
    if (refranceAck.acknowledgements !== "") {
      const doc = parser.parseFromString(refranceAck.acknowledgements, 'text/html');
      const images = doc.querySelectorAll('img');
      images.forEach((img) => {
        const src = img.getAttribute('src');
        if (src && checkUrl(src)) allImg.push(src);
      });
    }
    if (refranceAck.refrances !== "") {
      const doc = parser.parseFromString(refranceAck.refrances, 'text/html');
      const images = doc.querySelectorAll('img');
      images.forEach((img) => {
        const src = img.getAttribute('src');
        if (src && checkUrl(src)) allImg.push(src);
      });
    }
    const data = getUnique(allImg);
    setuploadeImages([...data]);
  }
  function editorUploadedImg(img, type) {
    setuploadeImages((prevImages) => {
      const updated = [...prevImages, img];
      return getUnique(updated);
    });
  }
  function removeFocusFromEditorTitle(e, key) {
    const editorEditL = editorTitleEdit;
    editorEditL[key].val = false;
    seteditorTitleEdit([...editorEditL]);
  }

  function addKeyWord(type) {
    const data = articleContent;
    if (type === "keyword" && keyRef.current.value !== "") {
      data.keywords.push(keyRef.current.value);
      keyRef.current.value = "";
      if (data.keywords.length <= 5) {
        const err = articleContentError;
        err.keywordsError = "";
        setarticleContentError({ ...err });
      }
    } else if (
      type === "abbreviations" &&
      abbreviationsRef.current.value !== "" &&
      abbreviationsFullRef.current.value !== ""
    ) {
      data.abbreviations.push(abbreviationsRef.current.value);
      data.abbreviationsFull.push(abbreviationsFullRef.current.value);
      abbreviationsRef.current.value = "";
      abbreviationsFullRef.current.value = "";
    }
    setarticleContent({ ...data });
  }
  function removeKeyWord(type, key) {
    const data = articleContent;
    if (type === "keyword") {
      data.keywords.splice(key, 1);
    } else if (type === "abbreviations") {
      data.abbreviations.splice(key, 1);
      data.abbreviationsFull.splice(key, 1);
    }

    setarticleContent({ ...data });
  }

  const smallWords = [
    "of",
    "and",
    "on",
    "in",
    "to",
    "from",
    "at",
    "for",
    "about",
    "as",
    "but",
    "over",
    "is",
    "are",
    "am",
    "the",
  ];

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word, index) =>
        smallWords.includes(word) && index !== 0
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");
  };

  function handleChangeInput(e) {
    const data = articleContent;
    const dataError = articleContentError;
    if (e.target.name === "title") {
      // const titlname = toTitleCase(e.target.value);
      const titlname = toTitleCase(e.target.value);
      data.title = titlname;
      setmainTitle(titlname);
      if (e.target.value !== "") dataError.titleError = "";
    } else if (e.target.name === "runningTitle") {
      data.runningTitle = e.target.value;
      const wordcount = e.target.value.trim().split(" ");
      if (e.target.value !== "") dataError.runningTitleError = "";
      if (e.target.value !== "" && wordcount.length > 10) {
        dataError.runningTitleError =
          "A running title can be a maximum of 10 words in length. ";
      } else {
        dataError.runningTitleError = "";
      }
    } else if (e.target.name === "abstract") {
      data.abstract = e.target.value;
      if (e.target.value !== "") dataError.abstractError = "";
    }
    setarticleContent({ ...data });
    setarticleContentError({ ...dataError });
  }
  function handleChangeInputEditorTitle(e, k) {
    const data = editorTitleValue;
    const editorError = editorTitleValueError;
    data[k].val = e.target.value;
    seteditorTitleValue([...data]);
    editorError[k].val = "";
    seteditorTitleValueError([...editorError]);
  }

  function addMoreEditor() {
    const data = editorLength;
    const editorEditL = editorTitleEdit;
    const editorContent = editorContentValue;
    const editorTitle = editorTitleValue;
    const editorError = editorTitleValueError;
    data.push(editorLength.length);
    seteditorLength([...data]);
    editorEditL.push({ val: true });
    seteditorTitleEdit([...editorEditL]);
    editorContent.push({ val: "" });
    editorTitle.push({ val: "" });
    seteditorTitleValue([...editorTitle]);
    seteditorContentValue([...editorContent]);
    editorError.push({ val: "" });
    seteditorTitleValueError([...editorError]);
  }
  function removeEditor(key) {
    const editor = editorLength;
    const editorEditL = editorTitleEdit;
    const editorTitle = editorTitleValue;
    const editorContent = editorContentValue;
    const editorError = editorTitleValueError;
    if (editorEditL[key]) {
      editorEditL.splice(key, 1);
      seteditorTitleEdit([...editorEditL]);
    }
    if (editorError[key]) {
      editorError.splice(key, 1);
      seteditorTitleValueError([...editorError]);
    }
    if (editor[key]) {
      editor.splice(key, 1);
      const countedit = [];
      editor.forEach((element, k) => {
        countedit.push(k);
      });
      seteditorLength([...countedit]);
    }
    if (editorTitle[key]) {
      editorTitle.splice(key, 1);
      seteditorTitleValue([...editorTitle]);
    }
    if (editorContent[key]) {
      editorContent.splice(key, 1);

      seteditorContentValue([...editorContent]);
      getExtractImageFromContent(editorContent);
    }
  }
  function removeAuthorInputs(key) {
    const dataError = articleContentError;
    const data = authorAffiliationsCount;
    const details = articleContent;
    if (details.affiliationInstitute[key]) {
      details.affiliationInstitute.splice(key, 1);
    }
    if (details.affiliationDepartment[key]) {
      details.affiliationDepartment.splice(key, 1);
    }
    if (details.affiliationAuthorName[key]) {
      details.affiliationAuthorName.splice(key, 1);
    }
    if (details.affiliationTitle[key]) {
      details.affiliationTitle.splice(key, 1);
    }
    dataError.affiliationAuthorNameError[key] = "";
    dataError.affiliationDepartmentError[key] = "";
    dataError.affiliationTitleError[key] = "";
    dataError.affiliationInstituteError[key] = "";
    setarticleContentError({ ...dataError });
    setarticleContent({ ...details });
    data.splice(key, 1);
    let newatc = data;
    newatc = newatc.filter(function (_, index) {
      return newatc.hasOwnProperty(index);
    });
    setauthorAffiliationsCount([...data]);
  }

  const SimilarityCheck = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    try {
      const resp = await startSimilarityCheck({
        data: {
          similarityCheckId: unicheckData.similaritycheckId,
          userId: tokenVal?.id,
        },
        headers,
      });
      if (resp.status === 200) {
        setShowDownloadbtn(true);
        setUnicheckData({ ...unicheckData, url: resp.data.url });
        dispatch({ type: "SET_LOADER", payload: false });
      }
    } catch (err) {
      dispatch({ type: "SET_LOADER", payload: false });
    }
    dispatch({ type: "SET_LOADER", payload: false });
  };

  const getSimillarityReport = async (e) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { similarityCheckId: simillarityResult.indexId },
      headers: headers,
    };
    downloadSimiliratyReport(queryParams);
  };
  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }
    const sourceIndex = result.source.index;
    const DestinationIndex = result.destination.index;
    removeFocusFromEditorTitle("", sourceIndex);
    removeFocusFromEditorTitle("", DestinationIndex);

    const editorTitle = editorTitleValue;
    const editorTitleSourceVal = editorTitle[sourceIndex].val;
    const editorTitleDestiationVal = editorTitle[DestinationIndex].val;
    editorTitle[sourceIndex].val = editorTitleDestiationVal;
    editorTitle[DestinationIndex].val = editorTitleSourceVal;
    seteditorTitleValue([...editorTitle]);

    const editorContent = editorContentValue;
    const editorContentSourceVal = editorContent[sourceIndex].val;
    const editorContentDestiationVal = editorContent[DestinationIndex].val;
    editorContent[sourceIndex].val = editorContentDestiationVal;
    editorContent[DestinationIndex].val = editorContentSourceVal;
    seteditorContentValue([...editorContent]);
  }
  function removeSupplimentFile(index) {
    setsupplimentImges((prev) => prev.filter((_, i) => i !== index));
  }
  async function uploadSupplimentFile(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const extension = file.name.split(".").pop()?.toLowerCase();
    if (
      extension === "pdf" ||
      extension === "docx" ||
      extension === "doc" ||
      extension === "xlsx" ||
      extension === "pptx" ||
      extension === "rtf"
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      try {
        const formData = new FormData();
        formData.append("file", file);
        const fname = `${Date.now()}_${file.name}`;
        const uploadResp = await UploadMediaWithName(
          formData,
          `?fileName=${fname}`,
        );
        if (uploadResp?.status === 200 && uploadResp?.data?.url) {
          setsupplimentImges((prev) => [...prev, uploadResp.data.url]);
        } else {
          alert("s3 bucket upload error");
        }
      } catch (error) {
        console.error("Failed to upload supplementary material:", error);
        alert(
          error?.response?.data?.message ||
            "Failed to upload supplementary material. Please try again."
        );
      } finally {
        dispatch({ type: "SET_LOADER", payload: false });
      }
    } else {
      setinvalidFilePopup(true);
    }
    e.target.value = "";
  }

  function saveAndPay(predata, type, tabno) {
    lastSavedTabRef.current = tabno;
    setiSaveDraft(type);
    const { id } = jwt_decode(localStorage.usertoken);

    const comptab = completedTabs;
    const preDetails = preStepData;
    if (tabno === "0") {
      //disciplineType
      const payload = {
        userId: id,
        submissionDetail: {
          societyName: predata.societyName,
          journalType: predata.journalType,
          journalName: predata.journal,
          articleType: predata.articleType,
          subject: predata.subjectId,
        },
        validCouponCode:
          typeof predata.validCouponCode === "boolean"
            ? predata.validCouponCode
            : predata.validCouponCode &&
                Object.keys(predata.validCouponCode).length > 0
              ? true
              : false,
        paymentBySociety: predata.paymentBySociety,
      };
      setarticleType(predata.articleType);
      if (predata.paymentBySociety?.apcPayBySociety) {
        var reviewData = {
          typeOfReview: predata.reviewType,
          isRecommendReviewers: predata.recommendReviwer,
          suggestedReviewers: [],
        };
        payload.reviewType = reviewData;
      }

      if (predata.specializationId && predata.specializationId !== "")
        payload.submissionDetail.specialization = predata.specializationId;
      if (predata.disciplineType !== "")
        payload.submissionDetail.disciplineType = predata.disciplineType;
      if (predata.secondarySpecialization !== "")
        payload.submissionDetail.secondarySpecialization =
          predata.secondarySpecialization;
      if (predata.secondarySubject !== "")
        payload.submissionDetail.secondarySubject = predata.secondarySubject;
      if (predata.secondaryJournalName !== "")
        payload.submissionDetail.secondaryJournalName =
          predata.secondaryJournalName;
      if (articleContent.id !== "") payload.articleId = articleContent.id;
      const saveData = { headers: headers, payload: payload };

      saveArticleToDraft(saveData);
      comptab.mySubmission = true;
      let discipline = "";
      if (predata.disciplineType !== "") discipline = predata.disciplineType;
      const submissionData = {
        submissionDetail: {
          secondarySpecialization: predata.secondarySpecialization,
          secondarySubject: predata.secondarySubject,
          secondaryJournalName: predata.secondaryJournalName,
          societyName: predata.societyName,
          articleType: { _id: predata.articleType },
          disciplineType: { _id: discipline },
          specialization: {
            _id: predata.specialization,
            specialization: predata.specialization,
          },
          specializationId: { _id: predata.specializationId },
          subject: { _id: predata.subject, subjectName: predata.subject },

          subjectId: { _id: predata.subjectId },
          journalType: { _id: predata.journalType },
          journalName: predata.journal,
        },
      };
      preDetails.submissionDetail = submissionData.submissionDetail;
      preDetails.paymentBySociety = predata.paymentBySociety;
      if (
        predata.validCouponCode &&
        typeof predata.validCouponCode !== "boolean" &&
        Object.keys(predata.validCouponCode).length > 0
      ) {
        preDetails.validCouponCode = predata.validCouponCode;
      }
      setpreStepData({ ...preDetails });
    } else if (tabno === "2") {
      const payload = {
        userId: id,
        articleId: articleContent.id,
        reviewType: {
          typeOfReview: predata.reviewType,
          isRecommendReviewers: predata.recommendReviwer,
          suggestedReviewers: [],
        },
      };
      const suggestedReviewers = [];
      const storeReview = [];
      for (let i = 0; i < predata.name.length; i++) {
        const detl = {
          title: predata.title[i].val,
          fullName: predata.name[i].val,
          email: predata.email[i].val,
          affiliatedDepartment: "",
          affiliatedInstitude: predata.university[i].val,
          orcidId: predata.orcidId[i].val,
          specialization: predata.specialization[i].val,
          additionalComment: "",
        };
        if (predata.department[i] && predata.department[i].val !== "")
          detl.affiliatedDepartment = predata.department[i].val;
        if (
          predata.additionalComment[i] &&
          predata.additionalComment[i].val !== ""
        )
          detl.additionalComment = predata.additionalComment[i].val;
        if (predata.recommendReviwer === true) suggestedReviewers.push(detl);
        detl.specialization = { _id: predata.specialization[i].val };
        if (predata.recommendReviwer === true) storeReview.push(detl);
      }
      // console.log("suggestedReviewers",suggestedReviewers[0]?.fullName);
      // console.log('suggestedReviewers[0]?.fullName',suggestedReviewers[0]?.fullName)
      if (
        suggestedReviewers.length > 0 &&
        suggestedReviewers[0]?.fullName != ""
      ) {
        payload.reviewType.suggestedReviewers = suggestedReviewers;
      }

      const queryParams = {
        payload: payload,
        headers,
      };
      saveArticleToDraft(queryParams);
      if (predata.paymentBySociety) {
        preDetails.paymentBySociety = predata.paymentBySociety;
      }
      const jName1 = preDetails.submissionDetail?.journalName?.trim()?.toLowerCase();
      const jName2 = predata.journal?.trim()?.toLowerCase();
      const isMinorities =
        jName1 === "minorities in world politics" ||
        jName2 === "minorities in world politics" ||
        jName1 === "community learning and social transformation" ||
        jName2 === "community learning and social transformation" ||
        jName1 === "applied and basic obesity, diabetes and endocrinology" ||
        jName2 === "applied and basic obesity, diabetes and endocrinology";
      const isSocietyJournal =
        preDetails.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
        preDetails.submissionDetail?.journalType?.journalType === "Society Journal" ||
        predata.journalType === "6454a6390d88e62fa10503bf" ||
        predata.journalType === "Society Journal" ||
        predata.journalType?._id === "6454a6390d88e62fa10503bf";
      const isMega =
        preDetails.submissionDetail?.journalType?._id ===
          "6454a6390d88e62fa10503be" ||
        predata.journalType === "6454a6390d88e62fa10503be" ||
        predata.journalType?._id === "6454a6390d88e62fa10503be";
      if (
        predata.validCouponCode ||
        preDetails.paymentBySociety?.apcPayBySociety ||
        predata.paymentBySociety?.apcPayBySociety ||
        isMinorities ||
        isSocietyJournal ||
        isMega
      ) {
        comptab.review = true;
      } else {
        comptab.review = false;
        handleRedirect("", `/manage-payment/${articleContent.id}`);
      }

      const review = {
        reviewType: {
          typeOfReview: predata.reviewType,
          paymentDone: user.nationality !== "withInIndia" ? true : false,
          isRecommendReviewers: predata.recommendReviwer,
          suggestedReviewers: storeReview,
        },
      };

      preDetails.reviewType = review.reviewType;
      setpreStepData({ ...preDetails });
    } else if (tabno === "3") {
      const authors = [];

      for (let i = 0; i < predata.authorEmail.length; i++) {
        const detl = {
          title: predata.authorTitle[i].val,
          fullName: predata.authorname[i].val,
          email: predata.authorEmail[i].val,
          affiliatedDepartment: "",
          affiliatedInstitude: predata.authorUniversity[i].val,
          orcidId: predata.authorOrcidID[i].val,
        };
        if (
          predata.authorDepartment[i] &&
          predata.authorDepartment[i].val !== ""
        )
          detl.affiliatedDepartment = predata.authorDepartment[i].val;

        authors.push(detl);
      }

      const payload = {
        userId: id,
        articleId: articleContent.id,
        authorDetails: {
          author: authors,
          notThePrimaryAuthor: predata.isMePrimaryAuthor,
          contributionStatement: predata.contributionStatement,
        },
      };
      const queryParams = {
        payload: payload,
        headers,
      };
      saveArticleToDraft(queryParams);
      comptab.author = true;
      const authorDtl = {
        authorDetails: {
          contributionStatement: predata.contributionStatement,
          notThePrimaryAuthor: predata.isMePrimaryAuthor,
          _id: "7867",
          author: authors,
        },
      };
      preDetails.authorDtl = authorDtl.authorDetails;
      setpreStepData({ ...preDetails });
    } else if (tabno === "4") {
      const funder = [];
      const payload = {
        userId: id,
        articleId: articleContent.id,
        fundingDetails: {
          fundingInformation: predata.fundingInformation,
          noFundingRecevied: predata.noFundingRecevied,
          funder: funder,
        },
      };
      for (let i = 0; i < predata.fundingAgency.length; i++) {
        const detl = {
          NameOfFundingAgency: predata.fundingAgency[i].val,
          urlOfFundingAgency: predata.fundingAgencyUrl[i].val,
          grantAmount: predata.grantAmount[i].val,
          nameOfContactPerson: predata.name[i].val,
          emailId: predata.email[i].val,
          mobileNumber: predata.phone[i].val,
        };
        funder.push(detl);
      }
      if (predata.noFundingRecevied === false)
        payload.fundingDetails.funder = funder;

      const queryParams = {
        payload: payload,
        headers,
      };
      saveArticleToDraft(queryParams);
      comptab.funding = true;

      const fund = {
        fundingDetails: {
          _id: "dcfsd",
          funder: funder,
          fundingInformation: predata.fundingInformation,
          noFundingRecevied: predata.noFundingRecevied,
        },
      };
      preDetails.fundingDetails = fund.fundingDetails;
      setpreStepData({ ...preDetails });
    } else if (tabno === "5") {
      const payload = {
        userId: id,
        articleId: articleContent.id,
        allconditionCheck: predata.checkedCondition,
        statements: {
          commercial: {
            commercialOrfinancialConflictOfInterest:
              predata.commercialFinanceConflict,
            text: predata.conflictDetail,
          },
          AakashGangaJournal: {
            versionOfManuscript: predata.manuscriptVersion,
            text: predata.manuscriptVersionDetail,
          },
        },
      };
      const queryParams = {
        payload: payload,
        headers,
      };
      saveArticleToDraft(queryParams);
      comptab.statement = true;
      // REDIRECT HANDLED BY MODAL CALLBACK
      // setshowprePage(false);
      // setshowprePage(false);

      // window.location.reload();
      const ststement = {
        statements: {
          AakashGangaJournal: {
            versionOfManuscript: predata.manuscriptVersion,
            text: predata.manuscriptVersionDetail,
          },
          commercial: {
            commercialOrfinancialConflictOfInterest:
              predata.commercialFinanceConflict,
            text: predata.conflictDetail,
          },
        },
      };
      preDetails.statements = ststement.statements;
      setpreStepData({ ...preDetails });
    } else if (
      tabno === "1" &&
      preStepData?.submissionDetail?.articleType?._id ===
        "664aed76ada7b4f743b760a9"
    ) {
      // console.log("reached");
      const payload = {
        userId: id,
        articleId: articleContent.id,
        allconditionCheck: predata.checkedCondition,
        conference: {
          conferenceName: predata.conferenceName,
          city: predata.city,
          country: predata.country,
          url: predata.url,
          date: predata.date,
          conferenceChairName: predata.conferenceChairName,
          conferenceChairiEmail: predata.conferenceChairiEmail,
          trackChairName: predata.trackChairName,
          trackChairEmail: predata.trackChairEmail,
        },
      };
      const queryParams = {
        payload: payload,
        headers,
      };

      const conferenc = {
        conference: {
          conferenceName: predata.conferenceName,
          city: predata.city,
          country: predata.country,
          url: predata.url,
          date: predata.date,
          conferenceChairName: predata.conferenceChairName,
          conferenceChairiEmail: predata.conferenceChairiEmail,
          trackChairName: predata.trackChairName,
          trackChairEmail: predata.trackChairEmail,
        },
      };
      saveArticleToDraft(queryParams);
      comptab.conference = true;
      preDetails.conference = conferenc.conference;
      setpreStepData({ ...preDetails });
      // setshowprePage(false);
      // window.location.reload();
      // console.log("reached");
    }
    setcompletedTabs({ ...comptab });
    if (type === 1 && tabno === "0")
      setsavedDetailsPupup(true);
  }

  function getNameFromUrl(url) {
    let name = "";
    const pieces = (url || "").split(/[\s/]+/);
    const last = pieces[pieces.length - 1];
    if (last) {
      const firstUnderscore = last.indexOf("_");
      if (firstUnderscore !== -1) {
        name = last.substring(firstUnderscore + 1).replace(/%20/g, " ");
      } else {
        name = last.replace(/%20/g, " ");
      }
    }

    return name;
  }
  console.log("preStepData?.submissionDetail :", preStepData?.submissionDetail);
  function manageProfanitySuccessPopup() {
    setprofanitySuccess(false);
    dispatch({ type: "SET_LOADER", payload: true });
    setTimeout(() => {
      dispatch({ type: "SET_LOADER", payload: false });
      setsavedDraftArticle(true);
    }, "2000");
  }

  function addCitation() {
    const data = {
      publishPopup: false,
      totalLength: [0],
      url: "",
      isMulti: false,
      year: "",
      artTitle: "",
      urlError: "",
      yearError: "",
      fname: [{ val: "" }],
      lname: [{ val: "" }],
      fnameError: [],
      lnameError: [],
      artTitleError: [],
    };
    setcitationDetails(data);
    setcitationPopup(true);
  }
  function removeCitationAuthor(key) {
    const citation = citationDetails;
    if (citation.fname[key]) {
      citation.fname.splice(key, 1);
    }
    if (citation.lname[key]) {
      citation.lname.splice(key, 1);
    }
    if (citation.fnameError[key]) {
      citation.fnameError.splice(key, 1);
    }
    if (citation.lnameError[key]) {
      citation.lnameError.splice(key, 1);
    }
    citation.totalLength.splice(key, 1);
    setcitationDetails({ ...citation });
  }
  function handleMultiCitation() {
    const citation = citationDetails;
    const totlCitation = citation.totalLength;
    totlCitation.push(citation.totalLength.length);
    citation.fname.push({ val: "" });
    citation.lname.push({ val: "" });
    citation.totalLength = totlCitation;
    setcitationDetails({ ...citation });
  }
  function handleMultiAuthorCheckbox(e) {
    const citation = citationDetails;
    if (e.target.checked) citation.isMulti = true;
    else citation.isMulti = false;
    setcitationDetails({ ...citation });
  }
  function handleCitationInput(e, index, type) {
    const citation = citationDetails;
    if (type === "fname") {
      citation.fname[index].val = e.target.value;
      if (citation.fnameError[index]) citation.fnameError[index] = "";
    } else if (type === "lname") {
      citation.lname[index].val = e.target.value;
      if (citation.lnameError[index]) citation.lnameError[index] = "";
    } else if (type === "url") {
      citation.url = e.target.value;
      citation.urlError = "";
    } else if (type === "year") {
      citation.year = e.target.value;
      citation.yearError = "";
    } else if (type === "artTitle") {
      citation.artTitle = e.target.value;
      citation.artTitleError = "";
    }
    setcitationDetails({ ...citation });
  }
  function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );
  }
  function genrateCitaion() {
    // console.log(citationDetails);
    const citation = citationDetails;
    let error = false;
    for (let i = 0; i < citation.totalLength.length; i++) {
      if (citation.fname[i].val === "")
        citation.fnameError[i] = "Please enter first name";
      if (citation.lname[i].val === "")
        citation.lnameError[i] = "Please enter last name";
    }
    if (citation.url === "") {
      citation.urlError = "Please enter url";
      error = true;
    } else if (checkUrl(citation.url) === false) {
      error = true;
      citation.urlError = "Please enter correct url";
    }
    if (citation.year === "") {
      citation.yearError = "Please enter year of publication";
      error = true;
    }
    if (citation.artTitle === "") {
      citation.artTitleError = "Please enter Article Title";
      error = true;
    }

    if (error === false) {
      citation.publishPopup = true;
      setcitationPopup(false);
    }
    setcitationDetails({ ...citation });
  }
  function calculateCitaions() {
    let count = 1;
    if (refranceAck.refrances !== "") {
      const matches = [];

      refranceAck.refrances.replace(
        /[^<]*(<a href="([^"]+)">([^<]+)<\/a>)/g,
        function () {
          matches.push(Array.prototype.slice.call(arguments, 1, 4));
        },
      );

      count = matches.length + 1;
    }

    return count;
  }

  function copyCitationDetails() {
    const citation = citationDetails;
    let lnames = citation.lname.map((x) => x.val).join(", ");
    let fnames = citation.fname.map((x) => x.val).join(", ");
    const uid = uuidv4();
    const content = `<div id="linkTo${uid}" class='generatedCitation'><a href="#${uid}">(${lnames}, ${citation.year})</a></div>Extract<div id="${uid}" class='generatedCitationLink'><span>number </span><a href="${citation.url}IDTAG=${uid}">${citation.url}</a><br></br></div>`;
    copy(content);
    var newContent = `${refranceAck.refrances} <p id="${uid}" class='generatedCitationLink'><b>${lnames}, ${fnames}, ${citation.artTitle}, ${citation.year}, </b><a href="${citation.url}IDTAG=${uid}">${citation.url}</a></p>`;
    refranceAck.refrances = newContent;
    setrefranceAck({ ...refranceAck });
    // console.log(newContent);
    return toast.success("Copied");
  }
  function closeCitationPublish() {
    const citation = citationDetails;
    citation.publishPopup = false;
    setcitationDetails({ ...citation });
  }
  function manageCiatation(citation) {
    const citationLength = calculateCitaions();
    let c = citation.replace("number", citationLength + ". ");
    // refranceRef.current.citationInRefrance(c);
  }

  function getRatingValue(rating) {
    const feedback = feedbackPupup;
    feedback.starVal = rating;
    if (rating === 0) feedback.rateError = "Please provide rating";
    else feedback.rateError = "";
    setfeedbackPupup({ ...feedback });
  }

  function saveFeedBackDetails() {
    const feedback = feedbackPupup;
    if (feedbackPupup.starVal === 0) {
      feedback.rateError = "Please provide rating";
      setfeedbackPupup({ ...feedback });
    } else {
      const { id } = jwt_decode(localStorage.usertoken);
      const payload = {
        userId: id,
        articleId: articleContent.id,
        rating: feedback.starVal,
        feedbackText: feedback.feedback,
      };
      const queryParams = {
        payload: payload,
        headers,
      };
      saveAuthorFeedback(queryParams);
    }
  }
  const sucessHandlerFeedback = (details) => {
    if (details.status === 200) {
      const feedback = feedbackPupup;
      feedback.starVal = 0;
      feedback.rateError = "";
      feedback.openPopup = false;
      feedback.successPopup = true;
      setfeedbackPupup({ ...feedback });
    }
    dispatch({ type: "SET_LOADER", payload: false });
  };

  const { mutate: saveAuthorFeedback } = SaveAuthorsFeedback(
    sucessHandlerFeedback,
  );

  const handledownloadWordArticle = async (articleId) => {
    try {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const params = {
        userId: tokenVal?.id,
        articleId: articleId,
      };

      const response = await axios.get(
        `${SERVER_URL}/AakashGanga/downloadWordFileArticle`,
        {
          headers,
          params,
          responseType: "blob",
        },
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "article.docx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Failed to download article");
    }
  };

  const parseJatsXml = (xmlData, uploadedImageUrls = []) => {
    if (!xmlData) return null;
    try {
      const xmlString = typeof xmlData === "string" ? xmlData : String(xmlData);
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "text/xml");

      const titleNode =
        xmlDoc.querySelector("article-title") ||
        xmlDoc.querySelector("title-group title") ||
        xmlDoc.querySelector("front title");
      const title = titleNode ? titleNode.textContent.trim() : "";

      let abstract = "";
      const abstractNode = xmlDoc.querySelector("abstract");
      if (abstractNode) {
        const ps = abstractNode.querySelectorAll("p");
        if (ps.length > 0) {
          abstract = Array.from(ps)
            .map((p) => p.textContent.trim())
            .filter(Boolean)
            .join("\n\n");
        } else {
          abstract = abstractNode.textContent.trim();
        }
      }

      const keywords = [];
      const kwdNodes = xmlDoc.querySelectorAll("kwd-group kwd, kwd");
      kwdNodes.forEach((k) => {
        const val = k.textContent.trim();
        const lower = val.toLowerCase();
        if (
          val &&
          lower !== "keywords" &&
          lower !== "keyword" &&
          lower !== "n/a" &&
          lower !== "none" &&
          !keywords.includes(val)
        ) {
          keywords.push(val);
        }
      });
      // Fallback: If kwdNodes is empty, check kwd-group text content directly
      if (keywords.length === 0) {
        const kwdGroup = xmlDoc.querySelector("kwd-group");
        if (kwdGroup) {
          const rawText = kwdGroup.textContent
            .replace(/keywords\s*:?/i, "")
            .trim();
          if (rawText) {
            rawText.split(/[,;]/).forEach((item) => {
              const val = item.trim();
              const lower = val.toLowerCase();
              if (
                val &&
                lower !== "keywords" &&
                lower !== "keyword" &&
                lower !== "n/a" &&
                lower !== "none" &&
                !keywords.includes(val)
              ) {
                keywords.push(val);
              }
            });
          }
        }
      }

      const sections = [];
      const secNodes =
        xmlDoc.querySelectorAll("body > sec").length > 0
          ? xmlDoc.querySelectorAll("body > sec")
          : xmlDoc.querySelectorAll("sec");

      const parseJatsNode = (node) => {
        if (!node) return "";
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          return text ? `<p>${text}</p>` : "";
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return "";

        const tagName = node.tagName.toLowerCase();

        if (tagName === "sec") {
          const secTitleEl = node.querySelector("title");
          let subTitleHtml = "";
          if (secTitleEl) {
            const subTitleText = stripLeadingHeadingNumber(
              secTitleEl.textContent.trim(),
            );
            subTitleHtml = `<h4 class="section-subtitle fw-bold my-3" style="color: #006f94; font-size: 1.15rem; margin-top: 18px; margin-bottom: 10px;">${subTitleText}</h4>`;
            secTitleEl.remove();
          }
          const childHtml = Array.from(node.childNodes)
            .map(parseJatsNode)
            .join("");
          return `<div class="article-subsection my-3">${subTitleHtml}${childHtml}</div>`;
        } else if (tagName === "title") {
          const titleText = stripLeadingHeadingNumber(node.textContent.trim());
          return titleText
            ? `<h4 class="section-subtitle fw-bold my-3" style="color: #006f94; font-size: 1.15rem; margin-top: 18px; margin-bottom: 10px;">${titleText}</h4>`
            : "";
        } else if (
          tagName === "fig" ||
          tagName === "graphic" ||
          tagName === "img"
        ) {
          let label = "";
          let caption = "";
          let imgSrc = "";

          if (tagName === "fig") {
            const labelEl = node.querySelector("label");
            if (labelEl) label = labelEl.textContent.trim();

            const captionEl = node.querySelector("caption");
            if (captionEl) caption = captionEl.textContent.trim();

            const graphicEl =
              node.querySelector("graphic") || node.querySelector("img");
            if (graphicEl) {
              imgSrc =
                graphicEl.getAttribute("xlink:href") ||
                graphicEl.getAttribute("href") ||
                graphicEl.getAttribute("src") ||
                "";
            }
          } else if (tagName === "graphic") {
            imgSrc =
              node.getAttribute("xlink:href") ||
              node.getAttribute("href") ||
              node.getAttribute("src") ||
              "";
          } else if (tagName === "img") {
            imgSrc = node.getAttribute("src") || "";
            caption = node.getAttribute("alt") || "";
          }

          if (
            imgSrc &&
            !imgSrc.startsWith("data:") &&
            !imgSrc.startsWith("https://cdn.aakashgangaopen.in") &&
            !imgSrc.startsWith("https://res.cloudinary.com")
          ) {
            const cleanSrc = imgSrc.toLowerCase().split("/").pop();
            const numMatch =
              cleanSrc.match(/(?:fig(?:ure)?|img|image)?\s*(\d+)/i) ||
              (label + " " + caption)
                .toLowerCase()
                .match(/(?:fig(?:ure)?|img|image)?\s*(\d+)/i);

            const availableCdnUrls = [];
            if (uploadedImageUrls && Array.isArray(uploadedImageUrls)) {
              availableCdnUrls.push(...uploadedImageUrls);
            }
            if (uploadeImages && Array.isArray(uploadeImages)) {
              availableCdnUrls.push(...uploadeImages);
            }
            try {
              for (let i = 0; i < sessionStorage.length; i++) {
                const k = sessionStorage.key(i);
                if (k) {
                  const v = sessionStorage.getItem(k);
                  if (v && typeof v === "string" && v.startsWith("http"))
                    availableCdnUrls.push(v);
                }
              }
            } catch (e) {}

            const uniqueUrls = Array.from(
              new Set(
                availableCdnUrls.filter(
                  (u) => u && typeof u === "string" && u.startsWith("http"),
                ),
              ),
            );

            let matchedUrl = null;
            if (uniqueUrls.length > 0) {
              matchedUrl = uniqueUrls.find((url) => {
                const uFile = url.toLowerCase().split("/").pop();
                return uFile.includes(cleanSrc) || cleanSrc.includes(uFile);
              });

              if (!matchedUrl && numMatch && numMatch[1]) {
                const fNum = parseInt(numMatch[1], 10);
                matchedUrl = uniqueUrls.find((url) => {
                  const uFile = url.toLowerCase().split("/").pop();
                  return (
                    uFile.includes(`fig${fNum}`) ||
                    uFile.includes(`figure${fNum}`)
                  );
                });
                if (!matchedUrl && fNum > 0 && uniqueUrls[fNum - 1]) {
                  matchedUrl = uniqueUrls[fNum - 1];
                }
              }

              if (!matchedUrl && uniqueUrls[0]) {
                matchedUrl = uniqueUrls[0];
              }
            }

            if (matchedUrl) {
              imgSrc = matchedUrl;
            }
          }

          if (!imgSrc) return "";

          const figCaptionHtml = caption
            ? `<figcaption class="figure-caption text-center" style="font-weight: 600; color: #006f94; font-size: 0.95rem; margin-top: 6px;">${label ? label + ". " : ""}${caption}</figcaption>`
            : label
              ? `<figcaption class="figure-caption text-center" style="font-weight: 600; color: #006f94; font-size: 0.95rem; margin-top: 6px;">${label}</figcaption>`
              : "";

          return `<figure class="figure my-3 text-center w-100" style="margin: 24px 0; text-align: center; display: block; width: 100%;">
            <img src="${imgSrc}" alt="${label || caption || "Figure"}" class="img-fluid rounded shadow-sm" style="width: 100%; max-width: 100%; height: auto; object-fit: contain; display: block; margin: 0 auto; border-radius: 8px;" />
            ${figCaptionHtml}
          </figure>`;
        } else if (tagName === "disp-formula" || tagName === "inline-formula") {
          const isDisplay = tagName === "disp-formula";
          const texMathEl = node.querySelector("tex-math");
          let latex = texMathEl
            ? texMathEl.textContent.trim()
            : node.textContent.trim();
          latex = latex
            .replace(/^<!\[CDATA\[/, "")
            .replace(/\]\]>$/, "")
            .trim();
          if (latex) {
            try {
              if (typeof katex !== "undefined" && katex.renderToString) {
                const rendered = katex.renderToString(latex, {
                  displayMode: isDisplay,
                  throwOnError: false,
                });
                return isDisplay
                  ? `<div class="disp-formula my-3 text-center" style="margin: 16px 0; text-align: center; overflow-x: auto;">${rendered}</div>`
                  : rendered;
              }
            } catch (e) {
              console.error("KaTeX render error:", e);
            }
            return isDisplay
              ? `<div class="disp-formula my-3 text-center" style="margin: 16px 0; text-align: center; font-style: italic; font-size: 1.1rem; overflow-x: auto;">\\[ ${latex} \\]</div>`
              : `<span class="inline-formula" style="font-style: italic;">\\( ${latex} \\)</span>`;
          }
          return "";
        } else if (tagName === "tex-math") {
          let latex = node.textContent.trim();
          latex = latex
            .replace(/^<!\[CDATA\[/, "")
            .replace(/\]\]>$/, "")
            .trim();
          if (latex) {
            try {
              if (typeof katex !== "undefined" && katex.renderToString) {
                const rendered = katex.renderToString(latex, {
                  displayMode: true,
                  throwOnError: false,
                });
                return `<div class="disp-formula my-3 text-center" style="margin: 16px 0; text-align: center; overflow-x: auto;">${rendered}</div>`;
              }
            } catch (e) {}
            return `<div class="disp-formula my-3 text-center" style="margin: 16px 0; text-align: center; font-style: italic; font-size: 1.1rem;">\\[ ${latex} \\]</div>`;
          }
          return "";
        } else if (tagName === "p") {
          let pInner = "";
          if (node.children.length > 0) {
            const childNodes = Array.from(node.childNodes);
            const hasSpecialTag = childNodes.some(
              (c) =>
                c.nodeType === Node.ELEMENT_NODE &&
                [
                  "inline-formula",
                  "disp-formula",
                  "tex-math",
                  "sec",
                  "title",
                  "fig",
                  "graphic",
                  "img",
                ].includes(c.tagName.toLowerCase()),
            );
            if (hasSpecialTag) {
              pInner = childNodes
                .map((c) =>
                  c.nodeType === Node.ELEMENT_NODE
                    ? parseJatsNode(c)
                    : c.textContent,
                )
                .join("");
            } else {
              pInner = node.innerHTML || node.textContent.trim();
            }
          } else {
            pInner = node.innerHTML || node.textContent.trim();
          }
          return `<p>${pInner}</p>`;
        } else if (tagName === "table") {
          node.setAttribute("class", "table table-bordered align-middle");
          return `<div class="table-responsive my-3">${serializer.serializeToString(node)}</div>`;
        } else if (tagName === "table-wrap") {
          const tableEl = node.querySelector("table");
          const captionEl = node.querySelector("caption");
          const labelEl = node.querySelector("label");
          let cap = "";
          if (labelEl || captionEl) {
            cap = `<caption style="caption-side: top; font-weight: bold; color: #006f94; margin-bottom: 8px;">${labelEl ? labelEl.textContent.trim() + " " : ""}${captionEl ? captionEl.textContent.trim() : ""}</caption>`;
          }
          if (tableEl) {
            tableEl.setAttribute("class", "table table-bordered align-middle");
            return `<div class="table-responsive my-3"><table class="table table-bordered align-middle">${cap}${tableEl.innerHTML}</table></div>`;
          } else {
            return `<div class="table-responsive my-3">${serializer.serializeToString(node)}</div>`;
          }
        } else if (tagName === "list") {
          const listType = node.getAttribute("list-type");
          const tag =
            listType === "order" || listType === "decimal" ? "ol" : "ul";
          const items = Array.from(node.querySelectorAll("list-item"))
            .map((li) => `<li>${li.innerHTML || li.textContent.trim()}</li>`)
            .join("");
          return `<${tag}>${items}</${tag}>`;
        } else {
          return serializer.serializeToString(node);
        }
      };

      secNodes.forEach((sec) => {
        const titleEl = sec.querySelector("title");
        const rawSecTitle = titleEl ? titleEl.textContent.trim() : "Section";
        const secTitle = stripLeadingHeadingNumber(rawSecTitle);

        if (secTitle.toLowerCase() !== "abstract") {
          const secClone = sec.cloneNode(true);
          const cloneTitle = secClone.querySelector("title");
          if (cloneTitle) cloneTitle.remove();

          let contentHtml = Array.from(secClone.childNodes)
            .map(parseJatsNode)
            .join("");

          if (!contentHtml.trim()) {
            const text = secClone.textContent.trim();
            if (text) {
              contentHtml = `<p>${text}</p>`;
            }
          }

          if (contentHtml) {
            sections.push({
              title: secTitle,
              content: contentHtml,
            });
          }
        }
      });

      const organizeSectionFigures = (rawSections) => {
        if (
          !rawSections ||
          !Array.isArray(rawSections) ||
          rawSections.length === 0
        )
          return rawSections;
        const resSections = rawSections.map((s) => ({ ...s }));
        const extractedFigs = [];

        resSections.forEach((sec, secIdx) => {
          if (!sec.content) return;
          const figRegex = /<figure\b[^>]*>([\s\S]*?)<\/figure>/gi;
          let match;
          while ((match = figRegex.exec(sec.content)) !== null) {
            const fullHtml = match[0];
            const inner = match[1];

            let figNum = 0;
            const numMatch =
              inner.match(/Figure\s*(\d+)/i) ||
              inner.match(/fig(?:ure)?\s*(\d+)/i) ||
              fullHtml.match(/(?:fig2|fig3|fig1)/i);
            if (numMatch) {
              if (numMatch[1]) figNum = parseInt(numMatch[1], 10);
              else if (numMatch[0]) {
                const d = numMatch[0].match(/\d+/);
                if (d) figNum = parseInt(d[0], 10);
              }
            }

            const textLower = inner.replace(/<[^>]+>/g, "").toLowerCase();

            extractedFigs.push({
              fullHtml,
              figNum,
              secIdx,
              textLower,
              secTitle: sec.title,
            });
          }
        });

        if (extractedFigs.length === 0) return resSections;

        const fig2Obj = extractedFigs.find(
          (f) => f.figNum === 2 || f.textLower.includes("stroop"),
        );

        if (fig2Obj) {
          const resultsIdx = resSections.findIndex((s) =>
            s.title.toLowerCase().includes("result"),
          );
          if (resultsIdx !== -1) {
            resSections[fig2Obj.secIdx].content = resSections[
              fig2Obj.secIdx
            ].content.replace(fig2Obj.fullHtml, "");

            const resSec = resSections[resultsIdx];
            const wmPos = resSec.content.indexOf("Working Memory");
            const t1Pos = resSec.content.indexOf("Table 1");

            if (wmPos !== -1) {
              const subsecCut = resSec.content.lastIndexOf(
                '<div class="article-subsection',
                wmPos,
              );
              const insPos = subsecCut !== -1 ? subsecCut : wmPos;
              resSec.content =
                resSec.content.slice(0, insPos) +
                fig2Obj.fullHtml +
                resSec.content.slice(insPos);
            } else if (t1Pos !== -1) {
              const table1EndIndex = resSec.content.indexOf("</div>", t1Pos);
              const insPos = table1EndIndex !== -1 ? table1EndIndex + 6 : t1Pos;
              resSec.content =
                resSec.content.slice(0, insPos) +
                fig2Obj.fullHtml +
                resSec.content.slice(insPos);
            } else {
              resSec.content = fig2Obj.fullHtml + resSec.content;
            }
          }
        }

        return resSections;
      };

      const finalSections = organizeSectionFigures(sections);

      let references = "";
      let referenceCount = 0;
      let referenceItems = [];

      const buildRefObject = (text, i) => {
        const cleanText = text
          .replace(/^(\s*(?:<[^>]+>)*\s*)(?:\[\d+\]|\d+\.|\b\d+\b)\s*/gi, "$1")
          .trim();
        const lower = cleanText.toLowerCase();
        let isValid = true;
        let reason = "";

        if (!cleanText || cleanText.length < 15) {
          isValid = false;
          reason = "Citation text is incomplete or too short (< 15 characters)";
        } else if (
          ["n/a", "none", "ibid", "reference", "references"].includes(lower)
        ) {
          isValid = false;
          reason = "Placeholder or invalid reference entry";
        }

        return {
          index: i + 1,
          text: cleanText,
          isValid,
          reason,
        };
      };

      const refList = xmlDoc.querySelector("ref-list");
      if (refList) {
        const refs = refList.querySelectorAll("ref");
        if (refs.length > 0) {
          refs.forEach((ref, i) => {
            const cit =
              ref.querySelector("mixed-citation") ||
              ref.querySelector("element-citation") ||
              ref;
            const text = cit ? cit.textContent.trim() : "";
            if (text) {
              referenceItems.push(buildRefObject(text, i));
            }
          });
        } else {
          const ps = refList.querySelectorAll("p, li");
          if (ps.length > 0) {
            ps.forEach((p, i) => {
              const text = p.textContent.trim();
              if (text) {
                referenceItems.push(buildRefObject(text, i));
              }
            });
          } else {
            const lines = (refList.textContent || "")
              .split(/\n+/)
              .filter((l) => l.trim().length > 5);
            lines.forEach((line, i) => {
              referenceItems.push(buildRefObject(line, i));
            });
          }
        }
      }

      if (referenceItems.length === 0) {
        const rawRefStr = xmlDoc.querySelector("references")
          ? xmlDoc.querySelector("references").textContent
          : "";
        if (rawRefStr) {
          const lines = rawRefStr
            .split(/\n+/)
            .filter((l) => l.trim().length > 5);
          lines.forEach((line, i) => {
            referenceItems.push(buildRefObject(line, i));
          });
        }
      }

      if (
        referenceItems.length === 0 &&
        finalSections &&
        finalSections.length > 0
      ) {
        const refSec = finalSections.find((s) => {
          const t = (s.title || "").toLowerCase().trim();
          return t.includes("reference") || t.includes("bibliography");
        });
        if (refSec && refSec.content) {
          const cleanText = refSec.content.replace(/<[^>]+>/g, "").trim();
          const lines = cleanText
            .split(/\n+/)
            .filter((l) => l.trim().length > 5);
          lines.forEach((line, i) => {
            referenceItems.push(buildRefObject(line, i));
          });
        }
      }

      referenceCount = referenceItems.length;
      references = referenceItems.map((item) => `<p>${item.text}</p>`).join("");

      let acknowledgements = "";
      const ackNode = xmlDoc.querySelector("ack");
      if (ackNode) {
        const ps = ackNode.querySelectorAll("p");
        if (ps.length > 0) {
          acknowledgements = Array.from(ps)
            .map((p) => p.textContent.trim())
            .join("\n\n");
        } else {
          acknowledgements = ackNode.textContent.trim();
        }
      }

      return {
        title,
        abstract,
        keywords,
        sections: finalSections,
        references,
        referenceCount,
        referenceItems,
        acknowledgements,
      };
    } catch (err) {
      console.error("parseJatsXml error:", err);
      return null;
    }
  };

  const processAndUploadFigureImages = async (sectionsList) => {
    if (
      !sectionsList ||
      !Array.isArray(sectionsList) ||
      sectionsList.length === 0
    )
      return sectionsList;

    const updated = [];

    for (let i = 0; i < sectionsList.length; i++) {
      const sec = { ...sectionsList[i] };
      if (!sec.content || typeof sec.content !== "string") {
        updated.push(sec);
        continue;
      }

      let secContent = sec.content;
      const figureRegex = /<figure\b[^>]*>([\s\S]*?)<\/figure>/gi;
      let match;
      const figureMatches = [];

      while ((match = figureRegex.exec(sec.content)) !== null) {
        figureMatches.push({
          fullFigureHtml: match[0],
          innerHtml: match[1],
        });
      }

      for (let f = 0; f < figureMatches.length; f++) {
        const fig = figureMatches[f];
        const imgMatch = fig.innerHtml.match(
          /<img\b([^>]*)\bsrc=["']([^"']+)["']([^>]*)\/?>/i,
        );
        if (!imgMatch) continue;

        const fullImgTag = imgMatch[0];
        const prefixAttr = imgMatch[1];
        const rawSrc = imgMatch[2];
        const suffixAttr = imgMatch[3];

        if (
          rawSrc &&
          (rawSrc.startsWith("https://cdn.aakashgangaopen.in") ||
            rawSrc.startsWith("https://res.cloudinary.com"))
        ) {
          continue;
        }

        try {
          let imageBlob = null;

          if (rawSrc.startsWith("data:")) {
            const arr = rawSrc.split(",");
            const mimeMatch = arr[0].match(/:(.*?);/);
            const mime = mimeMatch ? mimeMatch[1] : "image/png";
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            imageBlob = new Blob([u8arr], { type: mime });
          } else {
            try {
              const fetchRes = await fetch(rawSrc);
              if (fetchRes.ok) {
                imageBlob = await fetchRes.blob();
              }
            } catch (fetchErr) {
              console.error("Fetch image error for src:", rawSrc, fetchErr);
            }
          }

          if (imageBlob) {
            const ext = imageBlob.type
              ? imageBlob.type.split("/").pop()
              : "png";
            const fileName = `figure_${Date.now()}_${Math.floor(Math.random() * 1000)}.${ext}`;
            const file = new File([imageBlob], fileName, {
              type: imageBlob.type || "image/png",
            });

            const formData = new FormData();
            formData.append("file", file);

            const imgResp = await UploadMedia(formData);
            if (imgResp && imgResp.data && imgResp.data.url) {
              const cdnUrl = imgResp.data.url;

              const newImgTag = `<img ${prefixAttr}src="${cdnUrl}"${suffixAttr}/>`;
              const newFigureHtml = fig.fullFigureHtml.replace(
                fullImgTag,
                newImgTag,
              );

              secContent = secContent.replace(
                fig.fullFigureHtml,
                newFigureHtml,
              );
            }
          }
        } catch (e) {
          console.error(
            "Error uploading figure image to DigitalOcean Space:",
            e,
          );
        }
      }

      sec.content = secContent;
      updated.push(sec);
    }

    return updated;
  };

  const validateUgcMandatorySections = (parsedData) => {
    if (!parsedData) {
      return { valid: false, missingSections: ["Document JATS Content"] };
    }
    const missing = [];

    // 1. Title
    const cleanTitle = (parsedData.title || "").trim();
    if (
      !cleanTitle ||
      cleanTitle.toLowerCase() === "untitled" ||
      cleanTitle.toLowerCase() === "n/a"
    ) {
      missing.push("Title");
    }

    // 2. Abstract
    const cleanAbstract = (parsedData.abstract || "")
      .replace(/<[^>]+>/g, "")
      .trim();
    if (
      !cleanAbstract ||
      cleanAbstract.toLowerCase() === "abstract" ||
      cleanAbstract.toLowerCase() === "n/a" ||
      cleanAbstract.toLowerCase() === "none"
    ) {
      missing.push("Abstract");
    }

    // 3. Keywords
    const validKeywords = (parsedData.keywords || []).filter((k) => {
      if (typeof k !== "string") return false;
      const clean = k.trim().toLowerCase();
      return (
        clean.length > 0 &&
        clean !== "keywords" &&
        clean !== "keyword" &&
        clean !== "n/a" &&
        clean !== "none" &&
        clean !== "null" &&
        clean !== "undefined"
      );
    });
    if (validKeywords.length === 0) {
      missing.push("Keywords");
    }

    // 4. Mandatory Section Headings (Strict Concept Checking)
    const sectionsList = parsedData.sections || [];

    // Introduction (Non-negotiable)
    const hasIntroduction = sectionsList.some((s) => {
      const t = (s.title || "").toLowerCase().trim();
      const contentText = (s.content || "").replace(/<[^>]+>/g, "").trim();
      return (
        (t === "introduction" ||
          t.startsWith("1.") ||
          t.includes("introduction") ||
          t === "intro") &&
        contentText.length > 0
      );
    });
    if (!hasIntroduction) {
      missing.push("Introduction");
    }

    // Conclusion (Non-negotiable)
    const hasConclusion = sectionsList.some((s) => {
      const t = (s.title || "").toLowerCase().trim();
      const contentText = (s.content || "").replace(/<[^>]+>/g, "").trim();
      return (
        (t.includes("conclusion") ||
          t.includes("conclusions") ||
          t.includes("summary")) &&
        contentText.length > 0
      );
    });
    if (!hasConclusion) {
      missing.push("Conclusion");
    }

    // 5. References Validation (Minimum 10 valid references required)
    const cleanReferences = (parsedData.references || "")
      .replace(/<[^>]+>/g, "")
      .trim();
    const refCount =
      parsedData.referenceCount !== undefined ? parsedData.referenceCount : 0;
    const refItems = parsedData.referenceItems || [];
    const invalidPoints = [];

    const invalidItems = refItems.filter((item) => !item.isValid);

    if (
      !cleanReferences ||
      cleanReferences.toLowerCase() === "references" ||
      cleanReferences.toLowerCase() === "reference" ||
      cleanReferences.toLowerCase() === "n/a" ||
      cleanReferences.toLowerCase() === "none" ||
      refCount === 0
    ) {
      invalidPoints.push("References section is missing or empty.");
      missing.push(
        "Article has less than 10 references (References section is missing or empty)",
      );
    } else if (refCount < 10) {
      invalidPoints.push(
        `Total References Count: Found ${refCount} reference(s), minimum 10 required.`,
      );
      missing.push(
        `Article has less than 10 references (Found ${refCount}, minimum 10 required)`,
      );
    }

    if (invalidItems.length > 0) {
      invalidItems.forEach((item) => {
        const cReason = cleanReason(item.reason);
        invalidPoints.push(`Reference #${item.index}: ${item.text} - Issue: ${cReason}`);
      });
    }

    return {
      valid: missing.length === 0 && invalidItems.length === 0,
      missingSections: missing,
      invalidPoints,
      invalidItems,
    };
  };

  const cleanReason = (reasonStr) => {
    if (!reasonStr || typeof reasonStr !== "string") return "Reference is likely fake";
    let clean = reasonStr
      .replace(/^Part \d+:\s*/i, "")
      .replace(/^Failed LLM or Similarity checks\s*[\:\-]\s*/gi, "")
      .replace(/^Failed academic database verification\s*\([^\)]*\)\s*[\:\-]?\s*/gi, "")
      .replace(/\s*\("[^"]*"\)\s*$/g, "")
      .trim();

    if (clean.toLowerCase().startsWith("reference ")) {
      clean = "R" + clean.slice(1);
    }
    if (clean.toLowerCase().startsWith("referance ")) {
      clean = "R" + clean.slice(1);
    }
    if (!clean) return "Reference is likely fake";
    return clean.charAt(0).toUpperCase() + clean.slice(1);
  };

  const FLEXIBLE_SECTION_SYNONYMS = {
    "Literature Review": [
      "literature review",
      "background",
      "related work",
      "old works",
      "previous work",
      "literature survey",
      "prior work",
    ],
    Methodology: [
      "methodology",
      "methods",
      "materials and methods",
      "experimental setup",
      "proposed method",
      "proposed methodology",
      "system model",
      "implementation",
    ],
    Results: [
      "results",
      "findings",
      "experimental results",
      "performance evaluation",
      "results and analysis",
      "experimental evaluation",
    ],
    Discussion: [
      "discussion",
      "analysis",
      "discussions",
      "discussion and analysis",
    ],
  };

  const stripLeadingHeadingNumber = (title) => {
    if (!title || typeof title !== "string") return title;
    return title
      .replace(
        /^\s*(?:\d+(?:\.\d+)*\s*[\.\-\:]\s*|\d+\s+(?=[A-Za-z])|\(\d+\)\s*)/i,
        "",
      )
      .trim();
  };

  const normalizeSectionTitle = (rawTitle) => {
    if (!rawTitle) return rawTitle;
    const clean = stripLeadingHeadingNumber(rawTitle);
    const lower = clean.toLowerCase().trim();

    for (const [standardName, synonyms] of Object.entries(
      FLEXIBLE_SECTION_SYNONYMS,
    )) {
      if (synonyms.some((syn) => lower.includes(syn))) {
        return standardName;
      }
    }
    return clean;
  };

  const validateReferencesWithPeerReviewApi = async (
    parsedData,
    articleTitle,
    authorName,
    journalName
  ) => {
    let referenceItems = parsedData?.referenceItems || [];
    const referencesString = parsedData?.references
      ? parsedData.references.replace(/<[^>]+>/g, "\n").trim()
      : (referenceItems.map(r => r.text || r.raw || "").join("\n"));

    if (!referencesString) return referenceItems;

    const candidateUrls = [
      process.env.REACT_APP_PEERREVIEW_API_URL,
      "https://vibemacaw.online/peerreview/api",
      "https://aakashgangaopen.xyz/peerreview/api",
      "http://127.0.0.1:4000",
      "http://localhost:4000",
      "http://127.0.0.1:8002",
      "http://localhost:8002",
      "https://www.aakashgangaopen.in/peerreview/api",
    ].filter(Boolean);

    let validatedResult = null;
    let workingBaseUrl = "";

    for (const baseUrl of candidateUrls) {
      try {
        console.log(`[ReferenceValidator] Attempting validation against: ${baseUrl}/validate-references`);
        const valRes = await axios.post(
          `${baseUrl}/validate-references`,
          { references: referencesString },
          { timeout: 90000 }
        );
        if (valRes?.data && Array.isArray(valRes.data.referenceItems)) {
          validatedResult = valRes.data.referenceItems;
          workingBaseUrl = baseUrl;
          console.log(`[ReferenceValidator] Successfully validated references using ${baseUrl}`);
          break;
        }
      } catch (err) {
        console.warn(`[ReferenceValidator] Could not reach or validate via ${baseUrl}:`, err.message);
      }
    }

    // Trigger generate-reference-report external API on working URL or fallback
    const reportBaseUrl = workingBaseUrl || candidateUrls[0];
    try {
      let token = "";
      try {
        const loginRes = await axios.post(
          `${reportBaseUrl}/login`,
          { username: "admin", password: "admin123" },
          { timeout: 10000 }
        );
        token = loginRes?.data?.access_token || "";
      } catch (lErr) {
        console.warn("Peer review API login note:", lErr.message);
      }

      if (token) {
        try {
          const reportRes = await axios.post(
            `${reportBaseUrl}/generate-reference-report`,
            {
              article_title: articleTitle || "Manuscript Document",
              author_name: authorName || "Author",
              journal_name: journalName || "Aakashganga Open",
              references: referencesString,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
              timeout: 90000,
            }
          );
          if (reportRes?.data?.report_url) {
            console.log("External reference report generated URL:", reportRes.data.report_url);
            sessionStorage.setItem("generated_reference_report_url", reportRes.data.report_url);
          }
        } catch (repErr) {
          console.warn("Reference report generation API note:", repErr.message);
        }
      }
    } catch (err) {
      console.warn("Peer review API report call error:", err.message);
    }

    if (Array.isArray(validatedResult) && validatedResult.length > 0) {
      return validatedResult.map((item, idx) => {
        const isInvalid =
          item.isInvalid === true ||
          item.isValid === false ||
          item.status === "FAILED" ||
          item.status === "REQUIRES ATTENTION" ||
          item.status === "INVALID" ||
          (item.score !== undefined && Number(item.score) < 50);

        return {
          ...item,
          index: item.index || idx + 1,
          text: item.text || item.raw || "",
          isValid: !isInvalid,
          isInvalid: isInvalid,
          status: isInvalid ? "INVALID" : "VALID",
          reason: item.reason || (isInvalid ? "Part 1: References Requiring Attention (Failed academic database verification, Score < 50%)" : ""),
        };
      });
    }

    return referenceItems;
  };

  const handleExtractedXml = async (
    xmlData,
    uploadedImageUrls = [],
    { skipEmail = false, isValidationOnly = false } = {},
    uploadedSupplementaryUrls = [],
  ) => {
    if (!xmlData) return null;
    const parsed = parseJatsXml(xmlData, uploadedImageUrls);
    if (!parsed) return null;

    const targetJournal =
      preStepData?.submissionDetail?.journalName ||
      articleContent?.submissionDetail?.journalName ||
      preStepData?.journalName ||
      gernalMaster?.find(
        (g) =>
          g._id === preStepData?.journal ||
          g.journalName === preStepData?.journal,
      )?.journalName ||
      "";

    let decodedUser = {};
    try {
      if (localStorage?.usertoken) {
        decodedUser = jwt_decode(localStorage.usertoken) || {};
      }
    } catch (err) {}
    const authorName = decodedUser.fullName || decodedUser.name || decodedUser.username || "Author";
    const articleTitle = articleContent.title || preStepData?.title || parsed?.title || "Untitled Article";

    // Validate references via external peer review reference-validator API (/peerreview/api/generate-reference-report)
    try {
      const validatedItems = await validateReferencesWithPeerReviewApi(
        parsed,
        articleTitle,
        authorName,
        targetJournal
      );
      if (Array.isArray(validatedItems) && validatedItems.length > 0) {
        parsed.referenceItems = validatedItems;
        parsed.referenceCount = validatedItems.length;
      }
    } catch (e) {
      console.error("External reference validation error:", e);
    }

    // Run mandatory UGC Guidelines section validation
    const validation = validateUgcMandatorySections(parsed);
    if (!validation.valid) {
      const invalidRefItems = (parsed.referenceItems || []).filter(
        (item) => item.isInvalid || !item.isValid || item.status === "INVALID" || item.status === "REQUIRES ATTENTION" || (item.score !== undefined && Number(item.score) < 50)
      );

      setUgcValidationPopup({
        isOpen: true,
        missingSections: validation.missingSections,
        invalidReferences: invalidRefItems,
      });
      toast.error(
        `Document acceptance failed. Please review invalid references and upload article again.`,
      );

      // Mark or create article with documentUploadFailed so author dashboard displays the Upload Article card
      try {
        const targetArticleId =
          articleContent.id || preStepData?._id || preStepData?.id;
        let currentUserId = "";
        try {
          if (localStorage?.usertoken) {
            const decoded = jwt_decode(localStorage.usertoken);
            currentUserId = decoded?.id || decoded?._id || "";
          }
        } catch (err) {}
        if (!currentUserId) {
          currentUserId = localStorage?.userId || localStorage?.userid || "";
        }

        const headersData = {
          Authorization: `Bearer ${localStorage?.usertoken}`,
        };
        const payloadData = {
          articleId: targetArticleId,
          userId: currentUserId,
          title:
            "Please upload the article manuscript here to complete the submission process",
          submissionDetail:
            preStepData?.submissionDetail ||
            articleContent?.submissionDetail ||
            {},
        };
        const res = await markDocUploadFailedApi({
          payload: payloadData,
          headers: headersData,
        });
        console.log(
          "Article marked/created as documentUploadFailed:",
          res?.data,
        );
        if (res?.data?.articleId) {
          setarticleContent((prev) => ({ ...prev, id: res.data.articleId }));
          setpreStepData((prev) => ({ ...prev, _id: res.data.articleId }));
        }
      } catch (e) {
        console.error("Error marking document upload failed:", e);
      }

      // Trigger email to the author uploading the article
      try {
        const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
        let decodedUser = {};
        try {
          if (localStorage?.usertoken) {
            decodedUser = jwt_decode(localStorage.usertoken) || {};
          }
        } catch (err) {}

        const targetJournal =
          preStepData?.submissionDetail?.journalName ||
          articleContent?.submissionDetail?.journalName ||
          preStepData?.journalName ||
          gernalMaster?.find(
            (g) =>
              g._id === preStepData?.journal ||
              g.journalName === preStepData?.journal,
          )?.journalName ||
          "";

        const isInsufficientRefs =
          validation.missingSections.some(
            (s) =>
              typeof s === "string" &&
              s.toLowerCase().includes("less than 10 references"),
          ) ||
          (validation.invalidPoints && validation.invalidPoints.length > 0);

        const payload = {
          articleTitle:
            articleContent.title ||
            preStepData?.title ||
            parsed?.title ||
            "Untitled Article",
          journalName: targetJournal,
          missingSections: validation.missingSections,
          invalidPoints: validation.invalidPoints || validation.missingSections,
          isInsufficientReferences: isInsufficientRefs,
          referenceCount: parsed?.referenceCount || 0,
          referenceItems: parsed?.referenceItems || [],
          email:
            decodedUser.email ||
            decodedUser.userEmail ||
            localStorage.email ||
            localStorage.userEmail ||
            "",
          salutation: decodedUser.title || decodedUser.salutation || "Dr./Mr.",
          name:
            decodedUser.fullName ||
            decodedUser.username ||
            decodedUser.name ||
            "Author",
        };

        axios
          .post(
            `${SERVER_URL}/AakashGanga/sendExtractionFailureMail`,
            payload,
            { headers },
          )
          .then((res) =>
            console.log(
              "Extraction failure email sent successfully:",
              res.data,
            ),
          )
          .catch((err) =>
            console.error("Error sending extraction failure email:", err),
          );
      } catch (e) {
        console.error("Error triggering extraction failure email:", e);
      }

      return false;
    }

    if (isValidationOnly) {
      return true;
    }

    if (parsed.sections && parsed.sections.length > 0) {
      parsed.sections = parsed.sections.map((sec) => ({
        ...sec,
        title: normalizeSectionTitle(sec.title),
      }));
      parsed.sections = await processAndUploadFigureImages(parsed.sections);
    }

    let updatedTitle = mainTitle;
    if (parsed.title) {
      setmainTitle(parsed.title);
      updatedTitle = parsed.title;
    }

    let updatedAbstract = articleContent.abstract;
    if (parsed.abstract) {
      updatedAbstract = parsed.abstract;
    }

    let updatedKeywords = articleContent.keywords;
    if (parsed.keywords && parsed.keywords.length > 0) {
      updatedKeywords = parsed.keywords;
    }

    let updatedReferences = refranceAck.refrances;
    if (parsed.references) {
      updatedReferences = parsed.references;
    }

    let updatedAck = refranceAck.acknowledgements;
    if (parsed.acknowledgements) {
      updatedAck = parsed.acknowledgements;
    }

    setarticleContent((prev) => ({
      ...prev,
      title: updatedTitle || prev.title,
      abstract: updatedAbstract || prev.abstract,
      keywords: updatedKeywords.length > 0 ? updatedKeywords : prev.keywords,
    }));

    setrefranceAck({
      refrances: updatedReferences,
      acknowledgements: updatedAck,
    });

    let updatedSections = [];
    if (parsed.sections && parsed.sections.length > 0) {
      const newTitles = parsed.sections.map((s) => ({ val: s.title }));
      const newContents = parsed.sections.map((s) => ({ val: s.content }));
      const newEdit = parsed.sections.map(() => ({ val: false }));
      const newError = parsed.sections.map(() => ({ val: "" }));
      const newLength = parsed.sections.map((_, i) => i);

      seteditorTitleValue(newTitles);
      seteditorContentValue(newContents);
      seteditorTitleEdit(newEdit);
      seteditorTitleValueError(newError);
      seteditorLength(newLength);

      updatedSections = parsed.sections.map((s, idx) => ({
        title: s.title,
        content: s.content,
        order: idx + 1,
      }));
    }

    let userId = "";
    try {
      const decoded = jwt_decode(localStorage.usertoken);
      userId = decoded?.id || "";
    } catch (e) {}

    const targetArticleId =
      articleContent.id || preStepData?._id || preStepData?.id;

    let finalImages = uploadeImages;
    if (uploadedImageUrls && uploadedImageUrls.length > 0) {
      finalImages = getUnique([...(uploadeImages || []), ...uploadedImageUrls]);
      setuploadeImages(finalImages);
    }

    const isSocietyJournalExt =
      preStepData?.submissionDetail?.journalType?.journalType ===
        "Society Journal" ||
      preStepData?.submissionDetail?.journalType ===
        "6454a6390d88e62fa10503bf" ||
      preStepData?.submissionDetail?.journalType?._id ===
        "6454a6390d88e62fa10503bf" ||
      preStepData?.journalType === "Society Journal" ||
      preStepData?.journalType === "6454a6390d88e62fa10503bf" ||
      preStepData?.journaldstype === "societyArticle";

    // Perform Profanity Screening on extracted manuscript content (only for society journals; mega journal profanity check runs on SUBMIT ARTICLE click)
    let detectedProfanityWords = [];
    if (isSocietyJournalExt) {
      let currentProfanityWords = profanityWords;
      if (!currentProfanityWords || currentProfanityWords.length === 0) {
        try {
          const headers = {
            Authorization: `Bearer ${localStorage?.usertoken}`,
          };
          const pResponse = await axios.get(
            `${SERVER_URL}/AakashGanga/getProfanityWords`,
            { headers },
          );
          if (pResponse?.data?.data && Array.isArray(pResponse.data.data)) {
            currentProfanityWords = pResponse.data.data;
            setProfanityWords(currentProfanityWords);
          }
        } catch (err) {
          console.error(
            "Error fetching profanity words fallback during extraction:",
            err,
          );
        }
      }

      if (currentProfanityWords && currentProfanityWords.length > 0) {
        const fullTextToScan = [
          updatedTitle || "",
          updatedAbstract || "",
          ...(updatedKeywords || []),
          ...(updatedSections || []).map(
            (s) => `${s.title || ""} ${s.content || ""}`,
          ),
          updatedAck || "",
        ]
          .join(" ")
          .replace(/(<([^>]+)>)/gi, "");

        for (let i = 0; i < currentProfanityWords.length; i++) {
          const wordToTest = currentProfanityWords[i];
          if (
            wordToTest &&
            isExactMatch(fullTextToScan.toLowerCase(), wordToTest)
          ) {
            if (!detectedProfanityWords.includes(wordToTest)) {
              detectedProfanityWords.push(wordToTest);
            }
          }
        }
      }
    }

    const existingSupp = Array.isArray(supplimentImges)
      ? supplimentImges
      : Array.isArray(preStepData?.supplymentaryMaterial)
      ? preStepData.supplymentaryMaterial
      : [];
    const allSupplementary = [
      ...existingSupp,
      ...(uploadedSupplementaryUrls || []),
    ];
    const uniqueSupplementary = Array.from(
      new Set(allSupplementary.filter(Boolean)),
    );

    const payload = {
      userId,
      title: updatedTitle,
      runningTitle: articleContent.runningTitle,
      abstract: updatedAbstract,
      articleSection: updatedSections,
      keywords: updatedKeywords,
      formulae: [],
      citations: [],
      abbreviations: [],
      supplymentaryMaterial: uniqueSupplementary,
      status: "draft",
      stage: finalSubmitds,
      images: finalImages,
      acknowledgement: updatedAck,
      references: updatedReferences,
      articleXmlFormat:
        xmlData || sessionStorage.getItem("articleXmlFormat") || "",
      profanityWordsPresent:
        detectedProfanityWords.length > 0
          ? {
              isPresent: true,
              words: detectedProfanityWords,
            }
          : { isPresent: false, words: [] },
      documentUploadFailed: false,
    };
    if (targetArticleId) {
      payload.articleId = targetArticleId;
    }

    if (detectedProfanityWords.length > 0) {
      setProfanityWordsFound(detectedProfanityWords);

      // Highlight profane words in red inside section editors
      if (updatedSections && updatedSections.length > 0) {
        const highlightedContents = updatedSections.map((s) => {
          let val = s.content || "";
          detectedProfanityWords.forEach((word) => {
            val = val.replace(
              new RegExp(`(<[^>]+>)|(\\b${escapeRegExpMatch(word)}\\b)`, "gi"),
              (match, tag, wordMatch) =>
                tag ? tag : `<strong style="color:red;">${wordMatch}</strong>`,
            );
          });
          return { val };
        });
        seteditorContentValue(highlightedContents);
      }
    } else {
      setProfanityWordsFound([]);
    }

    const headersData = { Authorization: `Bearer ${localStorage?.usertoken}` };
    try {
      const res = await saveArticleToDraftApi({
        payload,
        headers: headersData,
      });
      if (res?.status === 200 && res.data?.articleId) {
        const newId = res.data.articleId;
        setarticleContent((prev) => ({ ...prev, id: newId }));
        setpreStepData((prev) => ({ ...prev, _id: newId }));

        // Trigger success email to author on successful document extraction and accept
        // Only send the email if skipEmail is false (i.e., this is the final call, not the validation-only call)
        if (!skipEmail) {
          try {
            let decodedUser = {};
            if (localStorage?.usertoken) {
              decodedUser = jwt_decode(localStorage.usertoken) || {};
            }
            const targetJournal =
              preStepData?.submissionDetail?.journalName ||
              articleContent?.submissionDetail?.journalName ||
              preStepData?.journalName ||
              gernalMaster?.find(
                (g) =>
                  g._id === preStepData?.journal ||
                  g.journalName === preStepData?.journal,
              )?.journalName ||
              "";

            const mailPayload = {
              articleTitle:
                updatedTitle ||
                articleContent.title ||
                preStepData?.title ||
                "Untitled Article",
              journalName: targetJournal,
              referenceCount: parsed?.referenceCount || 0,
              referenceItems: parsed?.referenceItems || [],
              email:
                decodedUser.email ||
                decodedUser.userEmail ||
                localStorage.email ||
                localStorage.userEmail ||
                "",
              salutation:
                decodedUser.title || decodedUser.salutation || "Dr./Mr.",
              name:
                decodedUser.fullName ||
                decodedUser.username ||
                decodedUser.name ||
                "Author",
            };

            axios
              .post(
                `${SERVER_URL}/AakashGanga/sendExtractionSuccessMail`,
                mailPayload,
                { headers: headersData },
              )
              .then((mRes) =>
                console.log(
                  "Extraction success email sent successfully:",
                  mRes.data,
                ),
              )
              .catch((mErr) =>
                console.error("Error sending extraction success email:", mErr),
              );
          } catch (e) {
            console.error("Error triggering extraction success email:", e);
          }
        }

        return newId;
      }
    } catch (e) {
      console.error("Error saving extracted XML draft to backend:", e);
    }
    return targetArticleId;
  };

  const isSociety = Boolean(
    preStepData?.submissionDetail?.journalType?.journalType === "Society Journal" ||
    preStepData?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
    preStepData?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
    preStepData?.journalType === "Society Journal" ||
    preStepData?.journalType === "6454a6390d88e62fa10503bf" ||
    preStepData?.journalType?._id === "6454a6390d88e62fa10503bf" ||
    preStepData?.journaldstype === "societyArticle" ||
    articleContent?.submissionDetail?.journalType?.journalType === "Society Journal" ||
    articleContent?.journalType === "Society Journal" ||
    articleContent?.journaldstype === "societyArticle"
  );

  return (
    <div
      className={
        preStepData.plagirismCheck !== "notDone"
          ? "editor-view-only manageEditorBox"
          : "manageEditorBox"
      }
    >
      <div className="editorHeadMain">
        <div className="innerMerginHead">
          <div
            className="editorHead d-flex justify-content-between align-items-center"
            style={{ position: "relative" }}
          >
            <div className="editorHeadLeft">
              {isUpdateNewVersion === false && articleID === "" && (
                <h2>Submit Article</h2>
              )}
              {isUpdateNewVersion === true && <h2>New Article Version</h2>}
            </div>

            <div
              className="editCenterWrap"
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                whiteSpace: "nowrap",
              }}
            >
              <b className="blinkText">
                {mendatoryAlert !== "" && (
                  <>
                    <div className="customTool">
                      {/* <img
                          className="pe-cursor ps-1"
                          src={CheckPri}
                          alt="no img"
                        />
                        */}
                    </div>
                    <i className="blink_me">{mendatoryAlert}</i>
                  </>
                )}
                {blinkError !== "" && (
                  <>
                    <div className="customTool">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p>Help</p>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={CheckPri}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                    <i
                      onClick={() =>
                        setprofanityAlert({
                          isOPen: profanityWordsFound.length > 0 ? true : false,
                          type: profanityWordsFound.length > 0 ? 1 : 0,
                        })
                      }
                      className={
                        profanityWordsFound.length > 0 ? " profanityBlink" : ""
                      }
                    >
                      {blinkError}
                    </i>
                  </>
                )}

                {simillarityResult.percent > 15 &&
                  mendatoryAlert === "" &&
                  blinkError !== "" && (
                    <>
                      <img
                        className="pe-cursor ps-1"
                        src={downloadImg}
                        onClick={() => getSimillarityReport()}
                        alt="Download"
                      />
                    </>
                  )}
              </b>
              {preStepData.plagirismCheck === "Done" &&
                preStepData.status === "draft" && (
                  <>
                    <div className="customTool">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p>
                                    The profanity check is an important element
                                    for all articles published on the
                                    Aakashganga platform. This is done to ensure
                                    professionalism, clarity, and
                                    appropriateness of language throughout the
                                    document.{" "}
                                  </p>
                                  <p className="mt-3 mb-0">
                                    {" "}
                                    This process involves identifying and
                                    removing any offensive or inappropriate
                                    language, including profanity, vulgar
                                    expressions, or offensive remarks.
                                  </p>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={vector_img}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                    <div className="checkTextBox">
                      <b className="blinkText">
                        Profanity Check{" "}
                        <img
                          className="pe-cursor ps-1"
                          src={tickChkImg}
                          alt="Download"
                        />{" "}
                      </b>
                      <b
                        className="blinkText"
                        onClick={() => getSimillarityReport()}
                      >
                        Similarity Index Check
                        <img
                          className="pe-cursor ps-1"
                          src={tickChkImg}
                          alt="Download"
                        />
                      </b>
                      <img
                        onClick={() => getSimillarityReport()}
                        className="pe-cursor ps-1"
                        src={downloadImg}
                        alt="Download"
                      />
                    </div>
                  </>
                )}
            </div>

            {/* <div className="text-right">
              <div className="articleRightBtn submisionHead">
                <span className="button-link">
                  Author Submission Guidelines
                </span>
              </div>
            </div> */}
          </div>
          {/* <div className="toBeCompletedWrap">
            <hr />
            <p>To be Completed</p>
            <hr />
          </div> */}
        </div>
      </div>

      <div className="manageEditorInner">
        <div
          className="editNoteWrap"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            alignItems: "end",
            marginBottom: "40px",
          }}
        >
          <div className="editorAction" style={{ justifySelf: "start" }}>
            <a
              onClick={() => getDetailsInfo()}
              className={showprePage === true ? "active" : ""}
              style={{
                color: showprePage === true ? "#009b94" : "#000000",
                fontWeight: showprePage === false ? "normal" : "bold",
              }}
            >
              Submission Details
            </a>
            <a
              onClick={() => {
                const canOpenEditor =
                  completedTabs.conference === true &&
                  (preStepData?.reviewType?.paymentDone == true ||
                    preStepData?.paymentBySociety?.apcPayBySociety === true) &&
                  completedTabs.statement === true;
                if (canOpenEditor) setshowprePage(false);
              }}
              className={
                showprePage === false
                  ? "active"
                  : completedTabs.conference === true &&
                      (preStepData?.reviewType?.paymentDone == true ||
                        preStepData?.paymentBySociety?.apcPayBySociety ===
                          true) &&
                      completedTabs.statement === true
                    ? ""
                    : "opacity-5"
              }
              style={{
                color: showprePage === false ? "#009b94" : "#000000",
              }}
            >
              Article Editor
            </a>
          </div>

          <div style={{ justifySelf: "center", textAlign: "center" }}>
            {showprePage === false && (
              <p
                className="sub-detail"
                style={{
                  fontWeight: 700,
                  fontSize: "22px",
                  lineHeight: "100%",
                  color: "#ff8300",
                  fontStyle: "bold",
                  textTransform: "uppercase",
                  fontFamily: "Inter",
                  letterSpacing: "0%",
                  margin: 0,
                }}
              >
                Manuscript Information
              </p>
            )}
          </div>

          <div style={{ justifySelf: "end" }}>
            {showprePage === false ? (
              <div className="submission-guidelines-header text-end">
                <div className="sg-title fw-bold">
                  ARTICLE SUBMISSION GUIDELINES
                </div>
                <div
                  className="sg-note d-flex align-items-center"
                  style={{
                    color: "#000000",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                >
                  <span
                    className="sg-note-label fw-bold me-1"
                    style={{ color: "#000000" }}
                  >
                    NOTE:
                  </span>{" "}
                  <p
                    style={{
                      textAlign: "left",
                      margin: "0px",
                      fontSize: "13px",
                    }}
                  >
                    The article limit is 10,000 words.
                  </p>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Popover>
                        <Popover.Body>
                          <div className="popoverToolWrap">
                            <p>
                              The total word count of the article text should
                              not exceed 10,000 words.
                            </p>
                          </div>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <img
                      className="pe-cursor ms-1"
                      src={vector_img}
                      alt="info"
                      style={{
                        width: "16px",
                        height: "16px",
                        marginTop: "0px",
                      }}
                    />
                  </OverlayTrigger>
                </div>
              </div>
            ) : (
              <p
                className="sub-detail"
                style={{
                  fontWeight: 700,
                  fontSize: "22px",
                  lineHeight: "100%",
                  color: "#ff8300",
                  fontStyle: "bold",
                  textTransform: "uppercase",
                  fontFamily: "Inter",
                  letterSpacing: "0%",
                  margin: 0,
                }}
              >
                Manuscript Information
              </p>
            )}
          </div>
        </div>

        {/* ADD ARTICLE postValueStatus prePaymentStatus */}
        {showprePage === true &&
          isEdited === false &&
          masterDataLoaded === true &&
          APCData.length > 0 && (
            <MySubmission
              submissionRef={submissionRef}
              subjects={subjectList}
              subjectSpecializationList={subjectSpecializationList}
              articleTypeList={articleTypeList}
              prePaymentStatus={prePaymentStatus}
              saveAndPay={saveAndPay}
              journalMaster={gernalMaster}
              journalType={gernalType}
              completedTabs={completedTabs}
              specializationList={specializationList}
              desciplineMaster={desciplineMaster}
              preStepData={preStepData}
              APCData={APCData}
              isUpdateNewVersion={isUpdateNewVersion}
              isForRevision={isForRevision}
              onPdfGenerated={async (
                url,
                pdfBlob,
                xmlData,
                uploadedImageUrls,
                uploadedSupplementaryUrls = [],
              ) => {
                setPdfPreviewUrl(url);
                if (uploadedImageUrls && uploadedImageUrls.length > 0) {
                  setuploadeImages((prev) => {
                    const combined = [...(prev || []), ...uploadedImageUrls];
                    return getUnique(combined);
                  });
                }
                if (
                  uploadedSupplementaryUrls &&
                  uploadedSupplementaryUrls.length > 0
                ) {
                  setsupplimentImges((prev) => {
                    const combined = [
                      ...(prev || []),
                      ...uploadedSupplementaryUrls,
                    ];
                    return getUnique(combined);
                  });
                }
                let savedId = null;
                if (xmlData) {
                  // Skip email on the first (validation-only) call when url is empty;
                  // the email will be sent on the second call after PDF generation
                  const isValidationOnly = !url;
                  const res = await handleExtractedXml(
                    xmlData,
                    uploadedImageUrls,
                    { skipEmail: isValidationOnly, isValidationOnly },
                    uploadedSupplementaryUrls,
                  );
                  if (res === false) {
                    return false;
                  }
                  if (res) {
                    savedId = typeof res === "string" ? res : res.articleId;
                  }
                }
                return savedId || true;
              }}
              onContinueToEditor={(savedId) => {
                if (
                  preStepData.paymentBySociety?.apcPayBySociety &&
                  preStepData.validCouponCode?._id
                ) {
                  handleRedirect(
                    "",
                    `/manage-payment/${savedId || articleContent.id}`,
                  );
                } else {
                  const isSocietyJournal =
                    preStepData?.submissionDetail?.journalType?.journalType ===
                      "Society Journal" ||
                    preStepData?.submissionDetail?.journalType ===
                      "6454a6390d88e62fa10503bf" ||
                    preStepData?.submissionDetail?.journalType?._id ===
                      "6454a6390d88e62fa10503bf" ||
                    preStepData?.journalType === "Society Journal" ||
                    preStepData?.journalType === "6454a6390d88e62fa10503bf" ||
                    preStepData?.journaldstype === "societyArticle";

                  if (isSocietyJournal) {
                    setshowprePage(false);
                  } else {
                    const articleID =
                      savedId ||
                      articleContent.id ||
                      preStepData?._id ||
                      preStepData?.id;
                    if (articleID) {
                      handleRedirect("", `/perviewArticle/${articleID}`);
                    } else {
                      setshowprePage(false);
                    }
                  }
                }
              }}
            />
          )}
        {/* ADD ARTICLE END */}
        {profanityMatches.length > 0 && (
          <div>
            {showProfinityAl && (
              <div className="profinatyWordAlways">
                <div className="d-flex">
                  <div>
                    <h3>Profanity Check Results</h3>
                    <small>
                      Please click on titles below to correct that section
                    </small>
                  </div>
                  <button
                    onClick={(e) => {
                      setShowProfinityAl(false);
                    }}
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                  ></button>
                </div>
                <ol>
                  {profanityMatches.map((wrd, idx) => (
                    <>
                      <li
                        className="pt-2"
                        onClick={() => scrollToSection(wrd?.index)}
                      >
                        <Link>{editorTitleValue[wrd?.index].val}</Link>
                      </li>
                      <ul className="ps-3 d-flex mw-60 justify-content-between">
                        {wrd?.words?.map((word) => (
                          <li>{word}</li>
                        ))}
                      </ul>
                    </>
                  ))}
                </ol>
              </div>
            )}
            {!showProfinityAl && (
              <div
                className="floatingProfinity"
                onClick={(e) => setShowProfinityAl(true)}
              >
                <p>Profanity Words</p>
                <img src={arrowwhiteright} />
              </div>
            )}
          </div>
        )}

        {showprePage === false && (
          <div className="personal-details" id="article-editor__comp">
            <div className="row mt-4">
              <div className="col-lg-4">
                <div className="commanBox mb-25 pb-0">
                  <div
                    className={
                      isOpenTableContent === true
                        ? "dragWrapShow active"
                        : "dragWrapShow"
                    }
                  >
                    <div className="dragWrapHead">
                      <h2>
                        Article structure{" "}
                        <div className="customTool">
                          {["bottom"].map((placement) => (
                            <OverlayTrigger
                              key={placement}
                              placement={placement}
                              overlay={
                                <Popover>
                                  <Popover.Body>
                                    <div className="popoverToolWrap">
                                      <p>
                                        Please use the elements below to change
                                        <br />
                                        the sequence of the article sections as
                                        <br />
                                        you may desire.
                                      </p>
                                    </div>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <img
                                className="pe-cursor"
                                src={vector_img}
                                alt="no img"
                              />
                            </OverlayTrigger>
                          ))}
                        </div>
                      </h2>
                      <b
                        onClick={() =>
                          setisOpenTableContent(!isOpenTableContent)
                        }
                      />
                    </div>
                    <div className="dragWrapContent">
                      <span>Title</span>
                      <span>Running Title</span>
                      <span>Abstract</span>
                      <span>Introduction</span>
                      <ul>
                        <DragDropContextn onDragEnd={(detl) => onDragEnd(detl)}>
                          <Droppablen droppableId="droppable">
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {editorLength.map((key, index) => (
                                  <>
                                    {key > 0 && (
                                      <div id={`editordiv${index}`}>
                                        <Draggablen
                                          key={key}
                                          draggableId={`dragid${index}`}
                                          index={index}
                                        >
                                          {(provided, snapshot) => (
                                            <li
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                            >
                                              <span>
                                                {editorTitleEdit[key]?.val ===
                                                  false && (
                                                  <>
                                                    <i
                                                      onClick={() => {
                                                        editInputLable(key);
                                                      }}
                                                    />
                                                    {editorTitleValue[key]
                                                      ?.val === ""
                                                      ? ""
                                                      : editorTitleValue[key]
                                                          ?.val}
                                                  </>
                                                )}{" "}
                                                {editorTitleEdit[key]?.val ===
                                                  true && (
                                                  <div className="editTime">
                                                    <Input
                                                      errors={
                                                        editorTitleValueError[
                                                          key
                                                        ] &&
                                                        editorTitleValueError[
                                                          key
                                                        ].val !== ""
                                                          ? editorTitleValueError[
                                                              key
                                                            ].val
                                                          : ""
                                                      }
                                                      name={`editorTitle${key}`}
                                                      handleChange={(e) =>
                                                        handleChangeInputEditorTitle(
                                                          e,
                                                          key,
                                                        )
                                                      }
                                                      handleBlur={(e) =>
                                                        removeFocusFromEditorTitle(
                                                          e,
                                                          key,
                                                        )
                                                      }
                                                      className="fieldForm"
                                                      type="text"
                                                      required={"required"}
                                                      value={
                                                        editorTitleValue[key]
                                                          ?.val
                                                      }
                                                      label=""
                                                      readOnly={
                                                        editorTitleValue[key]
                                                          ?.val === "References"
                                                          ? true
                                                          : false
                                                      }
                                                      placeholder="Enter Title"
                                                    />
                                                    <div
                                                      className="saveEdit"
                                                      onClick={(e) =>
                                                        removeFocusFromEditorTitle(
                                                          e,
                                                          key,
                                                        )
                                                      }
                                                    >
                                                      Done
                                                    </div>
                                                  </div>
                                                )}
                                              </span>
                                              <div class="dragArea"></div>
                                            </li>
                                          )}
                                        </Draggablen>
                                      </div>
                                    )}
                                  </>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppablen>
                        </DragDropContextn>
                      </ul>

                      <span>References</span>
                      <span>Acknowledgments</span>
                    </div>
                  </div>
                </div>
                <div className="commanBox mb-25">
                  <div className="fieldMore d-inline-block w-100 pt-0 pb-2 editMore">
                    <span>
                      Keywords{" "}
                      <small className="small-Text">
                        (<b>Minimum limit:</b> 5)
                      </small>
                    </span>
                    <a className="addKey" onClick={() => addKeyWord("keyword")}>
                      + Add{" "}
                    </a>
                  </div>

                  <div className="fieldWrap">
                    <input
                      title=""
                      ref={keyRef}
                      className="fieldForm"
                      placeholder="Enter Keywords"
                      type="text"
                      name=""
                      onKeyDown={(e) => {
                        if (e.code === "Enter") addKeyWord("keyword");
                      }}
                    />
                  </div>
                  {articleContentError.keywordsError !== "" && (
                    <div className="label-error">
                      {articleContentError.keywordsError}
                    </div>
                  )}
                  <div
                    className={
                      articleContent.keywords.length > 0
                        ? "keyBox tagsNewWrap"
                        : "keyBox"
                    }
                  >
                    {articleContent.keywords.map((keyword, index) => (
                      <span key={keyword} className="t-tag">
                        {keyword}
                        <i
                          className="imgClose"
                          onClick={() => removeKeyWord("keyword", index)}
                        ></i>
                      </span>
                    ))}
                  </div>
                </div>
                <div className="commanBox mb-25">
                  <div className="fieldMore pt-0 pb-0 editMore">
                    <span className="pb-2">Abbreviations</span>
                    <a
                      className="addKey pb-2"
                      onClick={() => addKeyWord("abbreviations")}
                    >
                      + Add
                    </a>
                  </div>

                  <div className="abbreviationWrap">
                    <div className="fieldWrap">
                      <input
                        title=""
                        ref={abbreviationsRef}
                        className="fieldForm"
                        placeholder="Abbr."
                        type="text"
                        name=""
                        required
                        onKeyDown={(e) => {
                          if (e.code === "Enter") addKeyWord("abbreviations");
                        }}
                      />
                    </div>
                    <div className="fieldWrap">
                      <input
                        title=""
                        ref={abbreviationsFullRef}
                        className="fieldForm"
                        placeholder="Full Form"
                        type="text"
                        name=""
                        required
                        onKeyDown={(e) => {
                          if (e.code === "Enter") addKeyWord("abbreviations");
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className={
                      articleContent.abbreviations.length > 0
                        ? "keyBox w-100 tagsNewWrap"
                        : "keyBox w-100"
                    }
                  >
                    {articleContent.abbreviations.map((abbreviation, index) => (
                      <span key={abbreviation} className="t-tag abbreView">
                        <b>{abbreviation}</b>
                        <b>{articleContent.abbreviationsFull[index]}</b>
                        <i
                          className="imgClose"
                          onClick={() => removeKeyWord("abbreviations", index)}
                        ></i>
                      </span>
                    ))}
                  </div>
                </div>

                <div className="commanBox mb-25 addCitation">
                  <span className="tagTitle mb-0">
                    Insert Citations
                    <div className="customTool top-3">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p>
                                    Proper citation is essential for
                                    acknowledging the work of other researchers
                                    and ensuring the integrity and credibility
                                    of your own research.
                                  </p>
                                  <p className="mt-3">
                                    Use this feature to cite any article you
                                    have used in your research. The button opens
                                    up a simple screen, which asks for
                                    elementary details of the author(s). You
                                    also need to copy and paste the URL or DOI
                                    of the same article in the indicated field.
                                    The system will automatically, generate the
                                    in-text citation, and place the URL/DOI in
                                    the references section. Note: If you delete
                                    the in-text citation, the referenced URL
                                    will still remain in the references section
                                    of your article.
                                  </p>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={vector_img}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                    <label className="fileBox" onClick={addCitation}>
                      CREATE
                    </label>
                  </span>
                </div>

                <div className="commanBox mb-25">
                  <span className="tagTitle">
                    Images and Figures
                    <div className="customTool top-3">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p className="mb-3">
                                    In order to enhance the impact and
                                    understanding of your work, please
                                    incorporate relevant images and figures into
                                    the designated section of your document.
                                  </p>
                                  <p>
                                    <b>Guidelines</b>:
                                  </p>
                                  <p>
                                    <b>Placement</b>: Please ensure that the
                                    images and figures are inserted on the left
                                    side of the editor screen within the
                                    specified section. This will maintain
                                    consistency and aid in seamless navigation.
                                  </p>
                                  <p>
                                    <b>Relevance</b>: Select images and figures
                                    that directly correlate with the content of
                                    the section. Visual aids should enhance the
                                    understanding of your research and provide
                                    valuable insights.
                                  </p>
                                  <p>
                                    <b>Captioning</b>: Each image or figure
                                    should be accompanied by a clear and concise
                                    caption. The caption should describe the
                                    content of the visual and its significance
                                    in relation to the section's topic.
                                  </p>
                                  <p>
                                    <b>Formatting</b>: Ensure that the images
                                    and figures are appropriately sized to
                                    maintain readability.
                                  </p>
                                  <p>
                                    <b>Source Attribution</b>: If the images or
                                    figures are sourced from external
                                    references, please provide proper
                                    attribution, including the source title,
                                    author, publication, and publication date.
                                  </p>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={vector_img}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                  </span>

                  <div className="imgShowBox">
                    {uploadeImages?.length > 0 ? (
                      uploadeImages.map((src, index) => (
                        <b
                          key={src}
                          style={{
                            backgroundImage: `url("${src}")`,
                          }}
                        ></b>
                      ))
                    ) : (
                      <div className="fieldWrap">
                        <p>
                          <span>Nothing uploaded yet</span>
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="commanBox mb-25">
                  <span className="tagTitle">
                    Supplementary Material
                    <div className="customTool">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p>
                                    You can upload PDF, MS Word, Excel, PPT,
                                    Data and RTF files in this section.
                                  </p>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={vector_img}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                    <label className="fileBox">
                      <input type="file" onChange={uploadSupplimentFile} />
                      UPLOAD
                    </label>
                  </span>
                  {supplimentImges.length === 0 && (
                    <div className="fieldWrap">
                      <p>Nothing uploaded yet</p>
                    </div>
                  )}
                  {supplimentImges.map((img, index) => (
                    <div className="docShowBox suppleBox" key={`mat${index}`}>
                      <div className="docShowList">
                        <a>
                          <span>{getNameFromUrl(img)}</span>
                        </a>

                        <i
                          className="imgClose"
                          onClick={() => removeSupplimentFile(index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                {/* Download Article & Note Section */}
                <div
                  className="download-note-section"
                  style={{
                    marginTop: "30px",
                    marginBottom: "30px",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: "25px" }}>
                    <button
                      type="button"
                      onClick={() =>
                        handledownloadWordArticle(articleContent.id)
                      }
                      style={{
                        width: "100%",
                        padding: "11px 20px",
                        border: "1.5px solid #006f94",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        color: "#006f94",
                        fontWeight: "600",
                        fontSize: "17px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        outline: "none",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#eefbf7";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#ffffff";
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ff4d4d"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                          marginRight: "8px",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                      Download Article
                    </button>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#000000",
                        marginTop: "8px",
                        marginBottom: "0px",
                      }}
                    >
                      For offline editing in MS Word format
                    </p>
                  </div>

                  <div
                    className="note-card-container"
                    style={{ textAlign: "left" }}
                  >
                    <h4
                      style={{
                        color: "#006f94",
                        fontWeight: "700",
                        fontSize: "16px",
                        marginBottom: "12px",
                        textTransform: "none",
                      }}
                    >
                      Note:
                    </h4>
                    <div
                      style={{
                        backgroundColor: "#f8fafd",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        padding: "16px 18px",
                      }}
                    >
                      <ol
                        style={{
                          margin: 0,
                          paddingLeft: "15px",
                          fontSize: "13px",
                          lineHeight: "1.6",
                          color: "#000000",
                          listStyleType: "decimal",
                        }}
                      >
                        <li
                          style={{ marginBottom: "12px", paddingLeft: "4px" }}
                        >
                          Use the{" "}
                          <span style={{ color: "#ff4d4d", fontWeight: "600" }}>
                            red language and grammar checker
                          </span>{" "}
                          button available at the bottom-right corner of every
                          input box to review and refine your article before
                          final submission.
                        </li>
                        <li
                          style={{ marginBottom: "16px", paddingLeft: "4px" }}
                        >
                          For better formatting and input accuracy, we recommend
                          preparing your article in an MS Word file first. Copy
                          the relevant sections and paste them into the
                          respective input boxes.
                        </li>
                      </ol>

                      <div style={{ paddingLeft: "4px" }}>
                        <h5
                          style={{
                            fontWeight: "700",
                            fontSize: "13.5px",
                            color: "#000000",
                            marginTop: "16px",
                            marginBottom: "10px",
                            textTransform: "none",
                          }}
                        >
                          Additional Tips:
                        </h5>
                        <ul
                          style={{
                            margin: 0,
                            paddingLeft: "15px",
                            fontSize: "13px",
                            lineHeight: "1.6",
                            color: "#000000",
                            listStyleType: "disc",
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>
                            Please save your article frequently while editing.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Upload clear figures/images with proper captions.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Ensure all mandatory sections (*) are completed
                            before submission.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            We use British English in this article editor.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Avoid copying directly from websites or PDFs to
                            prevent formatting and similarity issues.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Review author names, affiliations, and email IDs
                            carefully before final submission.
                          </li>
                          <li style={{ marginBottom: "0px" }}>
                            Kindly preview the article once before clicking
                            “Final Submit.”
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="commanBox mb-25">
                  <div className="fieldWrap">
                    <label className="labelFormTwo">
                      Title {/*  <div className="supTag">Mandatory</div> */}
                    </label>

                    <Input
                      errors={articleContentError.titleError}
                      name="title"
                      handleChange={handleChangeInput}
                      className="fieldForm"
                      type="text"
                      required={"required"}
                      value={mainTitle}
                      label=""
                      placeholder="Click to add text"
                      readOnly={isUpdateNewVersion && !isForRevision}
                    />
                  </div>
                </div>

                <div className="commanBox mb-25">
                  <div className="fieldWrap">
                    <label
                      className="labelFormTwo word10"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      Running Title{" "}
                      <div>
                        <small>
                          (<b>word limit:</b> 10)
                        </small>
                        <div className="customTool">
                          {["bottom"].map((placement) => (
                            <OverlayTrigger
                              key={placement}
                              placement={placement}
                              overlay={
                                <Popover>
                                  <Popover.Body>
                                    <div className="popoverToolWrap">
                                      <p>
                                        The running title will be displayed at
                                        the top of each PDF page of an article.
                                      </p>
                                      <p className="mb-0">
                                        {" "}
                                        A running title can be a maximum of 10
                                        words in length.
                                      </p>
                                    </div>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <img
                                className="pe-cursor ps-1"
                                src={vector_img}
                                alt="no img"
                              />
                            </OverlayTrigger>
                          ))}
                        </div>
                      </div>
                    </label>

                    <Input
                      errors={articleContentError.runningTitleError}
                      name="runningTitle"
                      handleChange={handleChangeInput}
                      className="fieldForm"
                      type="text"
                      required={"required"}
                      value={articleContent?.runningTitle}
                      label=""
                      placeholder="Click to add text"
                    />
                  </div>
                </div>
                <div className="commanBox mb-25">
                  <div className="fieldWrap">
                    <label
                      className="labelFormTwo word50"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      Abstract{" "}
                      <div>
                        <small>
                          (
                          <b style={{ fontWeight: "400 !important" }}>
                            word limit:
                          </b>{" "}
                          500)
                        </small>
                        <div className="customTool">
                          {["bottom"].map((placement) => (
                            <OverlayTrigger
                              key={placement}
                              placement={placement}
                              overlay={
                                <Popover>
                                  <Popover.Body>
                                    <div className="popoverToolWrap">
                                      <p>
                                        Please note that your abstract should
                                        not exceed 500 words. We recommend that
                                        you carefully provide a concise and
                                        accurate summary of your research,
                                        highlighting its significance, methods,
                                        results, conclusions, and others. A
                                        well-written abstract captures the
                                        interest of readers, increase the
                                        visibility of your work, and conveys the
                                        importance of their research findings to
                                        the academic community.
                                      </p>
                                    </div>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <img
                                className="pe-cursor ps-1"
                                src={vector_img}
                                alt="no img"
                              />
                            </OverlayTrigger>
                          ))}
                        </div>
                      </div>
                    </label>
                    <Textarea
                      name="abstract"
                      rows="15"
                      className="form-control grey-input title"
                      placeholder="Click to add text"
                      style={{ minHeight: "375px" }}
                      value={articleContent?.abstract}
                      onChange={(e) => {
                        handleChangeInput(e);
                      }}
                    />
                    {articleContentError.abstractError !== "" && (
                      <div className="label-error">
                        {articleContentError.abstractError}
                      </div>
                    )}
                  </div>
                </div>

                <Grammarly
                  clientId={gramrlyClientID}
                  config={{
                    documentDialect: "british",
                    activation: "immediate",
                  }}
                >
                  {editorLength.map((key, index) => (
                    <>
                      {" "}
                      {preStepData.plagirismCheck === "Done" &&
                        checkEmptyArticle(editorContentValue[key]?.val) !==
                          "" &&
                        (preStepData.status === "draft" ||
                          preStepData.status === "approved") && (
                          <ContentDetails
                            pagename="previewArticle"
                            details={{
                              title: editorTitleValue[key]?.val,
                              desc: editorContentValue[key]?.val,
                            }}
                          />
                        )}
                      {preStepData.plagirismCheck === "notDone" &&
                        preStepData.status === "draft" && (
                          <div
                            id={`editordiv${index}`}
                            className="addSctionEditor"
                          >
                            <div className="commanBox mb-25">
                              {key > 5 &&
                                (editorTitleValue[key]?.val !==
                                  "Introduction" ||
                                  editorTitleValue[key]?.val !==
                                    "Abstract") && (
                                  <i
                                    className="imgClose"
                                    onClick={() => removeEditor(index)}
                                  ></i>
                                )}
                              <div className="fieldWrap">
                                {editorTitleValue[key]?.val === "Abstract" && (
                                  <label className="labelFormTwo">
                                    Abstract
                                    <small>
                                      (word limit - 500 words){" "}
                                    </small>{" "}
                                    <div className="supTag">Mandatory</div>
                                  </label>
                                )}
                                {editorTitleValue[key]?.val ===
                                  "Introduction" && (
                                  <label className="labelFormTwo">
                                    Introduction{" "}
                                    <div className="customTool manageInto">
                                      {["bottom"].map((placement) => (
                                        <OverlayTrigger
                                          key={placement}
                                          placement={placement}
                                          overlay={
                                            <Popover>
                                              <Popover.Body>
                                                <div className="popoverToolWrap">
                                                  <p>
                                                    The introduction section of
                                                    a research paper plays a
                                                    vital role in setting the
                                                    tone, context, and purpose
                                                    of the study. It serves as a
                                                    bridge between the reader
                                                    and the research, providing
                                                    essential information and
                                                    establishing the foundation
                                                    for the rest of the paper.
                                                    In this context, the
                                                    introduction can be seen as
                                                    the "gateway" to the
                                                    research, guiding readers
                                                    into the topic and capturing
                                                    their interest.
                                                  </p>
                                                  <br />
                                                  <p>
                                                    It provides background
                                                    information, presents the
                                                    problem statement or
                                                    research question(s),
                                                    incorporates a literature
                                                    review, outlines the
                                                    methodology (if applicable),
                                                    and offers an overview of
                                                    the paper's structure. By
                                                    effectively addressing these
                                                    elements, the introduction
                                                    engages readers, clarifies
                                                    the purpose of the research,
                                                    and establishes its
                                                    relevance within the
                                                    academic community.
                                                  </p>
                                                </div>
                                              </Popover.Body>
                                            </Popover>
                                          }
                                        >
                                          <img
                                            className="pe-cursor ps-1"
                                            src={vector_img}
                                            alt="no img"
                                          />
                                        </OverlayTrigger>
                                      ))}
                                    </div>
                                  </label>
                                )}
                                {editorTitleValue[key]?.val !==
                                  "Introduction" &&
                                  editorTitleValue[key]?.val !== "Abstract" && (
                                    <div>
                                      {editorTitleEdit[key]?.val === true && (
                                        <div className="edtInputEditor">
                                          <Input
                                            errors={
                                              editorTitleValueError[key] &&
                                              editorTitleValueError[key].val !==
                                                ""
                                                ? editorTitleValueError[key].val
                                                : ""
                                            }
                                            name={`editorTitle${key}`}
                                            handleChange={(e) =>
                                              handleChangeInputEditorTitle(
                                                e,
                                                key,
                                              )
                                            }
                                            className="fieldForm"
                                            type="text"
                                            required={"required"}
                                            value={editorTitleValue[key]?.val}
                                            label=""
                                            readOnly={
                                              editorTitleValue[key]?.val ===
                                              "References"
                                                ? true
                                                : false
                                            }
                                            placeholder="Enter Title"
                                          />
                                          <div
                                            className="edtDone"
                                            onClick={(e) => {
                                              removeFocusFromEditorTitle(
                                                e,
                                                key,
                                              );
                                            }}
                                          >
                                            Done
                                          </div>
                                        </div>
                                      )}
                                      {editorTitleEdit[key]?.val === false && (
                                        <div className="editEditorLabel">
                                          <b>{editorTitleValue[key]?.val}</b>
                                          <i
                                            onClick={() => {
                                              editInputLable(key);
                                            }}
                                          ></i>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                <div
                                  className="editorWrap"
                                  ref={articleContentRefs.current[index]}
                                >
                                  {/* <GrammarlyEditorPlugin> */}
                                  <SunRichText
                                    name={editorTitleValue[key]?.val}
                                    value={editorContentValue[key]?.val}
                                    placeholder="Click to add text"
                                    handleChange={(content, type) => {
                                      editorContent(content, type, key);
                                    }}
                                    uploadedImg={(imgUrl) => {
                                      editorUploadedImg(
                                        imgUrl,
                                        editorTitleValue[key],
                                      );
                                    }}
                                    manageCiatation={(citation) => {
                                      manageCiatation(citation);
                                    }}
                                    refranceRef={(el) =>
                                      (articleContentRefs[key] = el)
                                    }
                                  />
                                  {/* <QuillRichText
                                    name={editorTitleValue[key]?.val}
                                    value={editorContentValue[key]?.val}
                                    handleChange={(content, type) => {
                                      editorContent(content, type, key);
                                    }}
                                    uploadedImg={(imgUrl) => {
                                      editorUploadedImg(
                                        imgUrl,
                                        editorTitleValue[key]
                                      );
                                    }}
                                    manageCiatation={(citation) => {
                                      manageCiatation(citation);
                                    }}
                                    refranceRef={(el) =>
                                      (articleContentRefs[key] = el)
                                    }
                                  /> */}
                                  {/* </GrammarlyEditorPlugin> */}
                                  {editorTitleValue[key]?.val === "Abstract" &&
                                    articleContentError.abstractError !==
                                      "" && (
                                      <div className="label-error">
                                        {articleContentError.abstractError}
                                      </div>
                                    )}
                                  {editorTitleValue[key]?.val ===
                                    "Introduction" &&
                                    articleContentError.introductionError !==
                                      "" && (
                                      <div className="label-error">
                                        {articleContentError.introductionError}
                                      </div>
                                    )}
                                  {editorTitleValue[key]?.val?.toLowerCase()?.trim() ===
                                    "conclusion" &&
                                    articleContentError.conclusionError !==
                                    "" && (
                                      <div className="label-error">
                                        {articleContentError.conclusionError}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </>
                  ))}

                  <div className="fieldMore pt-0 pb-0 text-center mb-25">
                    <a onClick={() => addMoreEditor()}>+ ADD NEW SECTION</a>
                  </div>
                  <div>
                    {preStepData.plagirismCheck === "Done" &&
                      checkEmptyArticle(refranceAck.refrances) !== "" &&
                      (preStepData.status === "draft" ||
                        preStepData.status === "approved") && (
                        <div className="commanBox mb-25">
                          <div className="fieldWrap">
                            <ContentDetails
                              pagename="previewArticle"
                              details={{
                                title: "References",
                                desc: refranceAck.refrances,
                              }}
                            />{" "}
                          </div>{" "}
                        </div>
                      )}
                    {preStepData.plagirismCheck === "notDone" &&
                      preStepData.status === "draft" && (
                        <>
                          <div className="commanBox mb-25">
                            <div className="fieldWrap">
                              <label className="labelFormTwo">
                                References{" "}
                              </label>
                              <div className="editorWrap" id="refranceEditr">
                                {/* <GrammarlyEditorPlugin> */}
                                <SunRichText
                                  name="References"
                                  value={refranceAck.refrances}
                                  placeholder="Click to add text"
                                  handleChange={(content, type) => {
                                    editorContent(content, type, "references");
                                  }}
                                  uploadedImg={(imgUrl) => {
                                    editorUploadedImg(imgUrl, "References");
                                  }}
                                  manageCiatation={(citation) => {
                                    manageCiatation(citation);
                                  }}
                                  refranceRef={refranceRef}
                                />
                                {/* </GrammarlyEditorPlugin> */}
                                {articleContentError.referencesError !== "" && (
                                  <div className="label-error">
                                    {articleContentError.referencesError}
                                  </div>
                                )}
                              </div>{" "}
                            </div>{" "}
                          </div>
                        </>
                      )}
                  </div>
                  <div>
                    {preStepData.plagirismCheck === "Done" &&
                      checkEmptyArticle(refranceAck.acknowledgements) !== "" &&
                      (preStepData.status === "draft" ||
                        preStepData.status === "approved") && (
                        <div className="commanBox mb-25">
                          <div className="fieldWrap">
                            <ContentDetails
                              pagename="previewArticle"
                              details={{
                                title: "Acknowledgements",
                                desc: refranceAck.acknowledgements,
                              }}
                            />
                          </div>
                        </div>
                      )}
                    {preStepData.plagirismCheck === "notDone" &&
                      preStepData.status === "draft" && (
                        <>
                          <div className="commanBox mb-25">
                            <div className="fieldWrap">
                              <label className="labelFormTwo">
                                Acknowledgements{" "}
                              </label>
                              <div className="editorWrap">
                                {/* <GrammarlyEditorPlugin> */}
                                <SunRichText
                                  name="Acknowledgements"
                                  value={refranceAck.acknowledgements}
                                  handleChange={(content, type) => {
                                    editorContent(
                                      content,
                                      type,
                                      "acknowledgements",
                                    );
                                  }}
                                  placeholder="Click to add text"
                                  uploadedImg={(imgUrl) => {
                                    editorUploadedImg(
                                      imgUrl,
                                      "Acknowledgements",
                                    );
                                  }}
                                  manageCiatation={(citation) => {
                                    manageCiatation(citation);
                                  }}
                                  refranceRef={acknowledgementRef}
                                />
                                {/* </GrammarlyEditorPlugin> */}
                              </div>{" "}
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </Grammarly>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-10 my-3 m-auto"></div>
            </div>
          </div>
        )}
        {showprePage === false && (
          <div className="confirmFooter confirmFooterFix">
            <div className="confirmContent">
              {preStepData?.submissionDetail?.journalType?.journalType ===
                "Society Journal" &&
              preStepData?.paymentBySociety?.apcPayBySociety ? (
                <>
                  <h3> Article Publishing Charge PAID BY THE SOCIETY </h3>
                  <div className="questionBox">
                    <span style={{ fontSize: "12px", fontWeight: "400" }}>
                      After submission, your article will be reviewed by the
                      Editor-in-Chief for its suitability <br />
                      and alignment with the journal’s scope. If accepted, it
                      will proceed to the next stage, <br />
                      and you will be notified accordingly. We appreciate your
                      submission and will keep <br />
                      you informed at each stage of the process.
                    </span>
                    <span></span>
                  </div>
                </>
              ) : (
                <>
                  {APCData.length > 0 && isUpdateNewVersion === false && (
                    <h3>
                      ARTICLE PROCESSING CHARGE:{" "}
                      <b>
                        {user?.nationality === "outSideIndia" ? "USD" : "INR"}{" "}
                        {preStepData?.submissionDetail?.journalName
                          ?.trim()
                          ?.toLowerCase() === "minorities in world politics" &&
                        (preStepData?.submissionDetail?.journalType?._id ===
                          "6454a6390d88e62fa10503bf" ||
                          preStepData?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf") ? (
                          <>
                            6499{" "}
                            <span style={{ textTransform: "lowercase" }}>
                              plus
                            </span>{" "}
                            GST
                          </>
                        ) : (
                          8999
                        )}
                      </b>
                    </h3>
                  )}

                  {isUpdateNewVersion === false && (
                    <div className="questionBox reddot">
                      <span style={{ fontWeight: "normal" }}>
                        You may also be eligible for additional grants and
                        discounts
                      </span>
                      <span style={{ fontWeight: "normal" }}>
                        {preStepData?.submissionDetail?.journalType
                          ?.journalType === "Society Journal" ||
                        preStepData?.submissionDetail?.journalType?._id ===
                          "6454a6390d88e62fa10503bf"
                          ? "All offers will be applied after the article is accepted for publication"
                          : "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"}
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="confirmBtn">
              {/* <span
                className="btn-link-active"
                onClick={() => checkGrammarTool()}
              >
                Check Grammar
                <div className="customTool">
                  {["top"].map((placement) => (
                    <OverlayTrigger
                      key={placement}
                      placement={placement}
                      overlay={
                        <Popover>
                          <Popover.Body>
                            <div className="popoverToolWrap">
                              <p>
                                This tool is meant to help you identify any
                                corrections in language and grammar before you
                                finally submit your article.{" "}
                              </p>
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <img
                        className="pe-cursor ps-1"
                        src={vector_img}
                        alt="no img"
                      />
                    </OverlayTrigger>
                  ))}
                </div>
              </span> */}
              {preStepData.status === "draft" && (
                <span
                  className="btn-link-active me-3"
                  style={{ cursor: "pointer", marginRight: "15px" }}
                  onClick={() => previewArticle()}
                >
                  Preview Article
                </span>
              )}
              {preStepData.plagirismCheck === "notDone" &&
                preStepData.status === "draft" && (
                  <span
                    className="btn-link-active"
                    onClick={() => submitAsDraft()}
                  >
                    Save
                  </span>
                )}

              {preStepData.plagirismCheck === "notDone" &&
                preStepData.status === "draft" && (
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={() => {
                      submitArticleWithGrammar();
                    }}
                  >
                    SUBMIT ARTICLE
                  </button>
                )}
              {preStepData.plagirismCheck === "Done" &&
                preStepData.status === "draft" && (
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={() => setfinalSubmitPupup(true)}
                  >
                    PROCEED TO SUBMISSION
                  </button>
                )}
              {preStepData.plagirismCheck === "Done" &&
                preStepData.status === "approved" && (
                  <Link
                    to={{
                      pathname: `/manage-payment/${articleID}`,
                    }}
                  >
                    {" "}
                    <button
                      className="button button-primary"
                      type="button"
                      onClick={() => setfinalSubmitPupup(true)}
                    >
                      PUBLISH NOW
                    </button>{" "}
                  </Link>
                )}
            </div>
          </div>
        )}
      </div>

      <style>{`
        .custom-grammar-success-dialog {
          max-width: 580px !important;
        }
        .custom-grammar-success-dialog .modal-content {
          border-radius: 20px !important;
          padding: 25px 35px 30px 35px !important;
          border: 1.5px solid #d1d5db !important;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
          position: relative !important;
        }
        .custom-grammar-success-dialog .modal-header {
          border-bottom: none !important;
          padding: 0 !important;
          height: 0 !important;
          min-height: 0 !important;
          margin: 0 !important;
        }
        .custom-grammar-success-dialog .btn-close {
          position: absolute !important;
          right: 20px !important;
          top: 20px !important;
          opacity: 0.8 !important;
          margin: 0 !important;
          z-index: 9999 !important;
          width: 13px !important;
          height: 13px !important;
          background-size: 13px !important;
        }
        .custom-grammar-success-dialog .btn-close:hover {
          opacity: 1 !important;
        }
        .custom-grammar-success-dialog .modal-body {
          padding: 10px 0 0 0 !important;
        }
        .custom-grammar-success-dialog .modal-footer {
          border-top: none !important;
          padding: 0 !important;
          justify-content: center !important;
        }
        #similarity-popover {
          border: 2px solid #a8202a !important;
          border-radius: 10px !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
          max-width: 580px !important;
        }
        #similarity-popover .popover-body {
          padding: 12px 16px !important;
          color: #000000 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: 1.5 !important;
        }
        #similarity-popover .popover-arrow::before {
          border-bottom-color: #a8202a !important;
          border-top-color: #a8202a !important;
        }
      `}</style>
      <Modal
        show={showGrammarSucessModal}
        size="md"
        id="grammar-check-success-modal"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered custom-grammar-success-dialog"
        className="authorModal"
      >
        <Modal.Header className="modal-header">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setshowGrammarSucessModal(false)}
          />
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div style={{ textAlign: "center", fontFamily: "Inter, sans-serif" }}>
            <h3
              style={{
                color: "#f78c1e",
                fontWeight: "800",
                fontSize: "21px",
                marginBottom: "20px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Thank You for Submitting the Article
            </h3>

            <div
              style={{
                fontSize: "17px",
                fontWeight: "700",
                color: "#1a1a1a",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              The PROFANITY CHECK is
              <img
                src={group}
                alt="check"
                style={{
                  marginLeft: "8px",
                  width: "20px",
                  height: "20px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              />
            </div>

            <p
              style={{
                fontSize: "17px",
                color: "#000000",
                lineHeight: "1.6",
                marginBottom: "25px",
                padding: "0 10px",
                textAlign: "left",
              }}
            >
              As the next step, we will now run the manuscript through a
              Similarity Index check. To cross this stage, your manuscript
              should have a similarity index of{" "}
              <span style={{ color: "#a8202a", fontWeight: "700" }}>
                not more than 15%
              </span>
              <OverlayTrigger
                trigger={["hover", "focus", "click"]}
                placement="bottom"
                overlay={
                  <Popover id="similarity-popover">
                    <Popover.Body>
                      It is important to note that plagiarism is not just about
                      the percentage of content copied; it also involves the
                      manner in which the material is used, cited, and
                      referenced. Similarity indices are not the only indicator
                      of plagiarism. Even if the similarity index is within an
                      acceptable range, if the language, structure, and ideas in
                      the research article are too similar to another work, it
                      could still be considered plagiarism.
                    </Popover.Body>
                  </Popover>
                }
              >
                <span
                  style={{
                    cursor: "pointer",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#dc3545"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ marginLeft: "5px" }}
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                </span>
              </OverlayTrigger>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            className="button"
            type="button"
            onClick={() => runSimilarityCheck(9)}
            style={{
              backgroundColor: "#1c7293",
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "15px",
              padding: "12px 35px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              transition: "background-color 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#14526c";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#1c7293";
            }}
          >
            Run the Check Now
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .custom-similarity-in-progress-dialog {
          max-width: 540px !important;
          width: 100% !important;
          position: relative !important;
        }
        .custom-similarity-in-progress-dialog .modal-content {
          border: 3px solid #1c7293 !important;
          border-radius: 20px !important;
          padding: 35px 45px !important;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
          position: relative !important;
        }
        .custom-similarity-in-progress-dialog .modal-header {
          border-bottom: none !important;
          padding: 0 !important;
          height: 0 !important;
          min-height: 0 !important;
          margin: 0 !important;
        }
        .custom-similarity-in-progress-dialog .btn-close {
          position: absolute !important;
          right: 25px !important;
          top: 25px !important;
          opacity: 0.8 !important;
          margin: 0 !important;
          z-index: 9999 !important;
          width: 13px !important;
          height: 13px !important;
          background-size: 13px !important;
        }
        .custom-similarity-in-progress-dialog .btn-close:hover {
          opacity: 1 !important;
        }
        .custom-ugc-validation-modal-wrap {
          z-index: 1070 !important;
        }
        .custom-ugc-validation-modal-wrap .modal-backdrop {
          z-index: 1069 !important;
        }
        .custom-ugc-validation-dialog {
          max-width: 580px !important;
          width: 92% !important;
          margin: 0 auto !important;
          z-index: 1071 !important;
        }
        .custom-ugc-validation-dialog .modal-content {
          border-radius: 12px !important;
          overflow: hidden !important;
          border: none !important;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
        }
        .custom-ugc-validation-dialog .modal-footer {
          border-top: none !important;
          padding: 16px 24px 24px 24px !important;
          justify-content: center !important;
        }
        .custom-similarity-in-progress-dialog .modal-body {
          padding: 0 !important;
          text-align: left !important;
          font-family: "Inter", sans-serif !important;
        }
        .custom-similarity-in-progress-dialog .modal-footer {
          border-top: none !important;
          padding: 20px 0 0 0 !important;
          justify-content: center !important;
        }
      `}</style>
      <Modal
        show={ugcValidationPopup.isOpen}
        onHide={() =>
          setUgcValidationPopup({ isOpen: false, missingSections: [], invalidReferences: [] })
        }
        centered
        className="custom-ugc-validation-modal-wrap"
        dialogClassName="custom-ugc-validation-dialog"
        style={{ zIndex: 1070 }}
      >
        <Modal.Header
          closeButton
          style={{
            borderBottom: "1px solid #fee2e2",
            backgroundColor: "#fef2f2",
            padding: "18px 24px",
          }}
        >
          <Modal.Title
            style={{ color: "#dc2626", fontWeight: "700", fontSize: "1.15rem" }}
          >
            Document Acceptance Failure & Reference Validation Report
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}>
          <p
            style={{
              color: "#374151",
              fontSize: "0.95rem",
              marginBottom: "16px",
              lineHeight: "1.5",
            }}
          >
            The uploaded manuscript document cannot be accepted because it contains missing sections or invalid references requiring attention. The submission process has been stopped. Please review the invalid references below, update your manuscript, and upload the article again with correct references.
          </p>
          <div
            style={{
              backgroundColor: "#fff5f5",
              borderRadius: "8px",
              padding: "16px",
              borderLeft: "4px solid #dc2626",
              marginBottom: "16px",
              textAlign: "left",
            }}
          >
            <h6 style={{ color: "#991b1b", fontWeight: "700", fontSize: "0.95rem", marginBottom: "12px" }}>
              Part 1: References Requiring Attention
            </h6>
            {ugcValidationPopup.missingSections &&
              ugcValidationPopup.missingSections
                .filter((sec) => typeof sec === "string" && !sec.startsWith("Reference #"))
                .map((sec, idx) => (
                  <div
                    key={`sec-${idx}`}
                    style={{
                      fontWeight: "600",
                      fontSize: "0.9rem",
                      color: "#b91c1c",
                      marginBottom: "8px",
                    }}
                  >
                    • {sec}
                  </div>
                ))}
            {ugcValidationPopup.invalidReferences &&
              ugcValidationPopup.invalidReferences.map((ref, idx) => {
                const cleanIssueText = cleanReason(ref.reason);
                return (
                  <div
                    key={`ref-${idx}`}
                    style={{
                      marginBottom: "12px",
                      fontSize: "0.88rem",
                      textAlign: "left",
                      lineHeight: "1.4",
                    }}
                  >
                    <div style={{ fontWeight: "600", color: "#b91c1c" }}>
                      Reference #{ref.index || idx + 1}: {ref.text || ref.raw || ""}
                    </div>
                    <div style={{ color: "#dc2626", fontWeight: "500", marginTop: "2px" }}>
                      Issue: {cleanIssueText}
                    </div>
                  </div>
                );
              })}
          </div>
          <p
            style={{
              color: "#4b5563",
              fontSize: "0.9rem",
              marginBottom: "8px",
              lineHeight: "1.5",
            }}
          >
            For complete information please see the guidelines at{" "}
            <a
              href="/author-submission-guidelines"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#006f94",
                textDecoration: "underline",
                fontWeight: "600",
              }}
            >
              this link
            </a>
            .
          </p>
          <p
            style={{
              color: "#4b5563",
              fontSize: "0.9rem",
              marginBottom: 0,
              lineHeight: "1.5",
            }}
          >
            In case of any further assistance please write to us at{" "}
            <a
              href="mailto:submissions@aakashgangaopen.in"
              style={{
                color: "#006f94",
                textDecoration: "underline",
                fontWeight: "600",
              }}
            >
              submissions@aakashgangaopen.in
            </a>
          </p>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          <button
            className="btn"
            style={{
              backgroundColor: "#dc2626",
              borderColor: "#dc2626",
              color: "#ffffff",
              fontWeight: "600",
              padding: "10px 28px",
              borderRadius: "8px",
              whiteSpace: "normal",
              width: "auto",
              minWidth: "260px",
              display: "inline-block",
              textAlign: "center",
              fontSize: "0.95rem",
              boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
            }}
            onClick={() =>
              setUgcValidationPopup({ isOpen: false, missingSections: [], invalidReferences: [] })
            }
          >
            Close and reupload with correct references
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSimilarityInProgressModal}
        size="md"
        id="similarity-in-progress-modal"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered custom-similarity-in-progress-dialog"
        className="authorModal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowSimilarityInProgressModal(false)}
          />
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div style={{ textAlign: "left", fontFamily: "Inter, sans-serif" }}>
            <h3
              style={{
                color: "#f78c1e",
                fontWeight: "800",
                fontSize: "21px",
                margin: "15px 0 25px 0",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                textAlign: "center",
              }}
            >
              SIMILARITY INDEX CHECK IN PROGRESS
            </h3>

            <p
              style={{
                fontSize: "17px",
                fontWeight: "500",
                color: "#1a1a1a",
                lineHeight: "1.6",
                marginBottom: "20px",
                padding: "0 10px",
                textAlign: "left",
              }}
            >
              We will notify you via email when your article has <br />
              cleared this stage.
            </p>

            <p
              style={{
                fontSize: "17px",
                fontWeight: "500",
                color: "#1a1a1a",
                lineHeight: "1.6",
                marginBottom: "15px",
                padding: "0 10px",
                textAlign: "left",
              }}
            >
              You can also view your report in the{" "}
              <span style={{ color: "#1c7293", fontWeight: "700" }}>
                Drafts
              </span>{" "}
              section
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            className="button"
            type="button"
            onClick={() => navigate("/dashboard")}
            style={{
              backgroundColor: "#1c7293",
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "15px",
              padding: "12px 35px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              transition: "background-color 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#14526c";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#1c7293";
            }}
          >
            My Dashboard
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showResult}
        size="lg"
        id="unicheck-results__modal"
        tabIndex={-1}
        dialogclassName="modal-dialog-centered"
      >
        <Modal.Header>
          <h5 className="modal-title pr-color">Plagarism Report</h5>
          <button
            type="button"
            className="btn-close"
            onClick={(e) => setShowResult(false)}
            aria-label="Close"
          />
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          <div className="row">
            <div className="col-lg-12">
              <iframe
                style={{
                  border: 0,
                  width: "100%",
                  height: "500px",
                  overflow: "auto",
                }}
                src={unicheckData.url}
              ></iframe>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={saveArticleConfirmation}
        size="md"
        id="unicheck-results__modal"
        tabIndex={-1}
        dialogclassName="modal-dialog-centered authorModal"
        className="authorModal md-x"
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title pl-0 pr-0">
            NEXT STEPS OF ARTICLE SUBMISSION
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setsaveArticleConfirmation(false)}
          />
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="submissionPopup">
            <strong>STEP 1: Profanity Check</strong>
            <strong>STEP 2: Similarity Index Check</strong>
            <p>
              After your article has cleared both checks,
              <br />
              it will be sent for editorial assessment including
              <br />
              peer review of your choice.
            </p>
            <p>
              Please also note that you will not be able to edit the article
              while the checks are underway.
            </p>
            <p>Would you like to proceed with the submission?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span
            className="btn-link-active mr-3"
            onClick={(e) => setsaveArticleConfirmation(false)}
          >
            GO BACK
          </span>
          <button
            className="button button-primary ml-3"
            onClick={() => confirmToSubmitArticle()}
            type="button"
          >
            Continue
          </button>
        </Modal.Footer>
      </Modal>
      <style>{`
        .submit-confirmation-modal .modal-dialog {
          max-width: 800px !important;
        }
        .submit-confirmation-modal .modal-content {
          min-height: 580px !important;
          display: flex !important;
          flex-direction: column !important;
          justify-content: space-between !important;
        }
        .submit-confirmation-modal .modal-header {
          padding-top: 25px !important;
          padding-bottom: 5px !important;
          padding-left: 45px !important;
          padding-right: 45px !important;
        }
        .submit-confirmation-modal .modal-body {
          padding-top: 15px !important;
          padding-left: 45px !important;
          padding-right: 40px !important;
        }
        .submit-confirmation-modal .modal-footer {
          padding-left: 45px !important;
          padding-right: 45px !important;
          padding-bottom: 25px !important;
        }
        .submit-confirmation-modal .modal-footer .btn-link-active {
          font-size: 17px !important;
        }
        .submit-confirmation-modal .modal-footer .button {
          font-size: 17px !important;
        }
      `}</style>
      <Modal
        show={saveArticleConfirmationNew}
        size="md"
        id="unicheck-results__modal2"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered authorModal"
        className="authorModal lg-xl submit-confirmation-modal"
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title pl-0 pr-0">
            NEXT STEPS OF ARTICLE SUBMISSION
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setsaveArticleConfirmationNew(false)}
          />
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="submissionPopup">
            <strong>Your article has been successfully submitted.</strong>
            <strong style={{ marginBottom: "4px" }}>
              Step 1: Profanity Check
            </strong>
            <p>The manuscript will undergo an automated profanity screening.</p>
            <strong style={{ marginBottom: "4px" }}>
              Step 2: Similarity Index Review
            </strong>
            <p>
              Once the profanity check is completed, the article will be
              forwarded to the Editorial Office for similarity index assessment.
            </p>
            <strong style={{ marginBottom: "4px" }}>Important:</strong>
            <p>
              Language editing tools are available within the Article Editor and
              should be
              <br />
              used before submission. Once submitted, the manuscript cannot be
              edited while these checks are in progress.
            </p>
            <p>
              After successfully clearing these checks, your manuscript will
              proceed to editorial assessment and peer review.
            </p>
            <strong>Would you like to continue with the submission?</strong>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span
            className="btn-link-active mr-3"
            onClick={(e) => setsaveArticleConfirmationNew(false)}
          >
            GO BACK
          </span>
          <button
            className="button button-primary ml-3"
            onClick={() => confirmToSubmitArticle()}
            type="button"
          >
            CONTINUE
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={cancelArticle}
        size="sm"
        id="unicheck-results__modal"
        tabIndex={-1}
        dialogclassName="modal-dialog-centered authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">
            Are you sure you would like to cancel?
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setCancelArticle(false)}
          />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div className="grantDetails pl-2 pr-2 mb-3">
            <div className="row text-center">
              <p className="mb-3">The article will be not be saved. </p>
              <p>
                This could take some time. Please come back in some time and
                access the Similarity Index Report in your Drafts section.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="pb-4">
          <span
            className="btn-link-active"
            onClick={(e) => setCancelArticle(false)}
          >
            No, GO BACK
          </span>
          <button
            className="button button-primary"
            type="button"
            onClick={(e) => handleRedirect(e, "/myArticle/draft")}
          >
            YES, CANCEL
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=" "
        show={savedDraftArticle}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title pl-0 pr-0">
            Similarity index check in progress
          </h5>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="similarity pl-2 pr-2 mb-3">
            <div className="similarityText" style={{ textAlign: "left" }}>
              <p style={{ textAlign: "left" }}>
                We will notify you via email when your <br />
                article has cleared this stage.
              </p>
              <p>
                You can also view your report in the{" "}
                <Link to={{ pathname: "/myArticle/draft" }} state={"draft"}>
                  <u>Drafts</u>
                </Link>{" "}
                section{" "}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary"
            onClick={(e) => {
              if (e) e.preventDefault();
              navigate("/dashboard");
            }}
          >
            My dashboard
          </button>
        </Modal.Footer>
      </Modal>

      {/* Profanity Alert */}
      <Modal
        dialogclassName=""
        show={profanityAlert.isOPen}
        id="congratsMobile"
        tabIndex={-1}
        className={
          profanityAlert.type === 0
            ? "authorModal md-x"
            : "authorModal rightSide profanity-content-right"
        }
        centered
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            <img src={alertSearch} alt="#" />
          </div>
          <h5 className="modal-title">
            {profanityWordsFound.length === 0
              ? "PROFANITY Check Complete"
              : "PROFANITY Check Results"}
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setprofanityAlert({ isOPen: false, type: 0 })}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0 pl-2 pr-2">
          <div className="grantDetails alertPopup">
            {profanityWordsFound.length > 0 ? (
              <>
                <div className="checkResultText">
                  <strong>
                    Thank you for submitting your research article.
                  </strong>
                  <p>
                    Our system has flagged certain terms that may require
                    review. These words can be sensitive depending on context.
                  </p>
                  <p>
                    If these terms are used in a valid academic or clinical
                    context, you may proceed. Otherwise, please revise as
                    appropriate.
                  </p>
                </div>

                <div className="offensiveBox">
                  <ol>
                    {profanityWordsFound.map((wrd, index) => (
                      <li key={index}>{wrd}</li>
                    ))}
                  </ol>
                </div>

                <div className="mt-4 mb-3 d-flex justify-content-center gap-2">
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={(e) => {
                      setprofanityAlert({ isOPen: false, type: 0 });
                      makeProfinityCheck();
                      const articleID =
                        articleContent.id ||
                        preStepData?._id ||
                        preStepData?.id;
                      if (articleID) {
                        handleRedirect("", `/perviewArticle/${articleID}`);
                      } else {
                        setshowprePage(false);
                      }
                    }}
                  >
                    Make Amendments
                  </button>
                  {isSociety ? (
                    <button
                      className="button button-primary"
                      type="button"
                      onClick={(e) => {
                        setprofanityAlert({ isOPen: false, type: 0 });
                        setshowprePage(false);
                        const articleID =
                          articleContent.id ||
                          preStepData?._id ||
                          preStepData?.id;
                        if (articleID) {
                          handleRedirect(
                            "",
                            `/dashboard/edit-article/${articleID}`,
                          );
                        }
                      }}
                    >
                      Article Editor
                    </button>
                  ) : (
                    <button
                      className="button button-primary"
                      type="button"
                      onClick={(e) => {
                        setprofanityAlert({ isOPen: false, type: 0 });
                        sessionStorage.setItem(
                          "reupload_article_triggered",
                          "true",
                        );
                        setshowprePage(true);
                        if (
                          submissionRef.current &&
                          typeof submissionRef.current.openUploadModal ===
                            "function"
                        ) {
                          submissionRef.current.openUploadModal();
                        }
                      }}
                    >
                      Reupload Article
                    </button>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="checkResultText text-center my-3">
                  <h4 style={{ color: "#198754", fontWeight: "600" }}>
                    ✓ No Profane Words Found
                  </h4>
                  <p
                    className="mt-2"
                    style={{ fontSize: "14px", color: "#555" }}
                  >
                    Your manuscript has been scanned and no profane terms were
                    detected. You may now proceed to preview your article.
                  </p>
                </div>

                <div className="mt-4 mb-3 d-flex justify-content-center gap-3">
                  <button
                    className="button button-secondary"
                    type="button"
                    style={{
                      backgroundColor: "#6c757d",
                      borderColor: "#6c757d",
                      color: "#fff",
                      padding: "8px 20px",
                    }}
                    onClick={() =>
                      setprofanityAlert({ isOPen: false, type: 0 })
                    }
                  >
                    Cancel
                  </button>
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={() => {
                      setprofanityAlert({ isOPen: false, type: 0 });
                      const articleID =
                        articleContent.id ||
                        preStepData?._id ||
                        preStepData?.id;
                      if (articleID) {
                        handleRedirect("", `/perviewArticle/${articleID}`);
                      } else {
                        setshowprePage(false);
                      }
                    }}
                  >
                    Article Preview
                  </button>
                </div>
              </>
            )}

            <div>
              <p className="text-center">Having trouble moving forward?</p>
              <p
                className="fs-5 fw-bold text-center text-danger pe-cursor"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={async () => {
                  setprofanityAlert({ isOPen: false, type: 0 });
                  try {
                    const data = getPayload("draft");
                    data.saveDetails.profanityWordsPresent = {
                      isPresent: true,
                      words: profanityWordsFound,
                      isFlaggedToUs: true,
                    };
                    data.saveDetails.isFlaggedToUs = true;
                    data.saveDetails.isProfaneFlagged = true;
                    const headersData = {
                      Authorization: `Bearer ${localStorage?.usertoken}`,
                    };
                    await saveArticleToDraftApi({
                      payload: data.saveDetails,
                      headers: headersData,
                    });
                    toast.info(
                      "This article is flagged to admin as it contains some flagged words.",
                    );
                    setShowFlaggedNotificationModal(true);
                  } catch (err) {
                    console.error("Error flagging article to admin:", err);
                    toast.error("Failed to flag article. Please try again.");
                  }
                }}
              >
                Flag it to us
              </p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-0">
          <div className="helpPopupText pb-3">
            Need help? Write to us at{" "}
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFlaggedNotificationModal}
        onHide={() => setShowFlaggedNotificationModal(false)}
        centered
        size="md"
        className="customProfanityModal"
      >
        <Modal.Header closeButton style={{ borderBottom: "none" }}>
          <Modal.Title
            style={{ color: "#bf1e2e", fontWeight: "bold", fontSize: "20px" }}
          >
            Profanity Check Notice
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", padding: "20px 30px" }}>
          <div
            style={{ fontSize: "44px", color: "#bf1e2e", marginBottom: "12px" }}
          >
            🚩
          </div>
          <p
            style={{
              fontSize: "16px",
              color: "#222",
              fontWeight: "500",
              lineHeight: "1.5",
            }}
          >
            This article is flagged to admin as it contains some Profane words.
          </p>
        </Modal.Body>
        <Modal.Footer
          style={{
            justifyContent: "center",
            borderTop: "none",
            paddingBottom: "20px",
          }}
        >
          <button
            className="btn btn-danger px-4"
            style={{
              backgroundColor: "#bf1e2e",
              borderColor: "#bf1e2e",
              borderRadius: "5px",
            }}
            onClick={() => setShowFlaggedNotificationModal(false)}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>

      <GrammarSpellModal
        spellCheckModal={spellCheckModal}
        setSpellCheckModal={setSpellCheckModal}
        mainContent={
          "Thank you for sharing your research article for submission."
        }
        upperContent={
          "We have noticed that there are still some grammar and language issues that need your attention."
        }
        middleContent={
          "You will find them highlighted in the article for correction."
        }
        lowerContent={
          "Before your manuscript is processed, please make sure that the highlighted issues are fixed."
        }
      />

      {/*Article Word Limit */}
      <Modal
        dialogclassName="modal-dialog-centered modal-md "
        show={plagiarismAlert}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal authorModalRed md-x"
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={alertSvg} alt="#" />
          </div>
          <h5 className="modal-title mt-0">ATTENTION</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setPlagiarismAlert(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="attentionText">
            <p>
              The article has exceeded the word count
              <br />
              limit of 10,000.
            </p>
            <p>
              Please revise your article to bring it below
              <br />
              the word count limit.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-3">
          <button
            className="button button-primary redBtn"
            type="button"
            onClick={() => setPlagiarismAlert(false)}
          >
            OKAY
          </button>

          <div className="helpPopupText mt-4">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=" modal-sm modal-dialog  "
        size="md"
        show={savedDetailsPupup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Confetti width={"450px"} height={"350px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">Your work has been saved</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setsavedDetailsPupup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave text-center">
            <div style={{ textAlign: "left", marginLeft: "10px" }}>
              {preStepData?.submissionDetail?.journalType?.journalType ===
                "Society Journal" ||
              preStepData?.submissionDetail?.journalType?._id ===
                "6454a6390d88e62fa10503bf" ||
              preStepData?.submissionDetail?.journalType ===
                "6454a6390d88e62fa10503bf" ||
              preStepData?.journalType === "6454a6390d88e62fa10503bf" ||
              preStepData?.journalType?._id === "6454a6390d88e62fa10503bf" ? (
                <>
                  <div style={{ marginBottom: "15px" }}>
                    <span style={{ display: "block" }}>
                      Please complete all sections of the submission
                    </span>
                    <span style={{ display: "block" }}>
                      {" "}
                      journey to access the article editor and begin writing
                      your article.
                    </span>
                  </div>
                  <div>
                    <span style={{ display: "block" }}>
                      These details are required for a smooth and
                    </span>
                    <span style={{ display: "block" }}>
                      accurate submission process.
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: "15px" }}>
                    <span style={{ display: "block" }}>
                      Please complete all sections of the submission journey to
                      be able to upload your article.
                    </span>
                  </div>
                  <div>
                    <span style={{ display: "block" }}>
                      The details you fill in form a critical part of the
                      Article’s Meta Data and assist in global visibility.
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary sm ml-3"
            onClick={(e) => setsavedDetailsPupup(false)}
          >
            CONTINUE
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogclassName=""
        show={invalidFilePopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal authorModalRed md-x"
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={alertSvg} alt="#" />
          </div>
          <h5 className="modal-title">Invalid file</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setinvalidFilePopup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="grantDetails alertPopup">
            <div className="invalidText">
              You can only upload MS Word, Excel, PPT,
              <br />
              Data and RTF files in this section.
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary redBtn"
            type="button"
            onClick={() => setinvalidFilePopup(false)}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        show={finalSubmitPupup}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x authorModal"
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title mb-0">congratulations!</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setfinalSubmitPupup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          {isUpdateNewVersion === false && (
            <div className="congratulationsPopup">
              <h3>All checks are now complete</h3>
              <p>
                You can now perform two actions:
                <br />
                1. Preview article
                <br />
                2. Submit Article
              </p>
              <p>
                Once you submit your article, it will move towards editorial
                assessment based on your choice of review.
              </p>
              <p>
                {" "}
                The estimated time to complete the assessment and reach a
                decision is{" "}
                <u>
                  {preStepData?.reviewType?.typeOfReview ==
                  "only post-publication open review"
                    ? "thirty"
                    : "forty five"}{" "}
                  working days
                </u>
                .
              </p>
              <p>
                <i>
                  Please note that you will not be able to edit the article
                  while the editorial assessment is underway.
                </i>
              </p>
              <p>
                You will receive an email once the assessment result is
                available. You can also check for status updates in the{" "}
                <Link to={{ pathname: "/myArticle/submit" }} state={"submit"}>
                  <u>Under Review</u>
                </Link>{" "}
                section on your dashboard.
              </p>
            </div>
          )}
          {isUpdateNewVersion === true && (
            <div className="congratulationsPopup">
              <h3>All checks are now complete</h3>
              <p>
                You can now perform two actions:
                <br />
                1. Preview article
                <br />
                2. Submit Article
              </p>
              <p>
                Once you submit your article, it will be reviewed assessed by a{" "}
                {preStepData?.submissionDetail?.journalType?.journalType ===
                "Society Journal"
                  ? "Society Editor"
                  : "Publishing Editor"}{" "}
                and available for <b>Post Open Peer Review</b>.
              </p>
              <p>
                {" "}
                The estimated time to complete the assessment and reach a
                decision is{" "}
                <u>
                  {preStepData?.reviewType?.typeOfReview ==
                  "only post-publication open review"
                    ? "thirty"
                    : "forty five"}{" "}
                  working days
                </u>
                .
              </p>
              <p>Please check your inbox for more details.</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-active mr-3"
            onClick={(e) => {
              setfinalSubmitPupup(false);
              previewArticle();
            }}
          >
            preview article
          </span>
          <button
            className="button button-primary ml-3"
            onClick={() => finalSubmitNow()}
          >
            SUBMIT article
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=""
        show={finalSubmitConfirmPupup}
        //show={true}
        id="congratsMobile"
        tabIndex={-1}
        centered
        //className="authorModal md-640"
        className="authorModal md-x"
      >
        <Confetti width={"450px"} height={"600px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <h5 className="modal-title">
            {preStepData.reviewType?.typeOfReview ===
            "pre-publication peer review only"
              ? "PRE-PUBLISHING DOUBLE ANONYMOUS PEER REVIEW"
              : "POST PUBLISHING OPEN PEER REVIEW"}
          </h5>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          {preStepData.reviewType?.typeOfReview !==
            "pre-publication peer review only" && (
            <div className="preeReviewPopup">
              <b className="congText">congratulations</b>
              <h3 className="mb-3 d-block">
                Your article is now submitted for <br />
                Editorial Assessment
              </h3>
              <p>
                You should receive notification of the decision to your
                registered email address within <u>three weeks</u>.
              </p>
              <p>
                If your manuscript is accepted by the{" "}
                {preStepData?.submissionDetail?.journalType?.journalType ===
                "Society Journal"
                  ? "Society Editor"
                  : "Publishing Editor"}
                , it will be published on the platform within{" "}
                <u>72 working hours</u> after making the final payment.
              </p>
              <p>
                Check for status updates in the{" "}
                <Link to={{ pathname: "/myArticle/submit" }} state={"submit"}>
                  <u>Under Review</u>
                </Link>{" "}
                section on your dashboard.
              </p>
            </div>
          )}

          {preStepData.reviewType?.typeOfReview ===
            "pre-publication peer review only" && (
            <div className="preeReviewPopup postReviewPopup">
              <b className="congText">congratulations</b>
              <h3 className="mb-3 d-block">
                Your article is now submitted for <br /> Editorial Assessment
              </h3>
              <p>
                Typically, the editorial assessment by the{" "}
                {preStepData?.submissionDetail?.journalType?.journalType ===
                "Society Journal"
                  ? "Society Editor"
                  : "Publishing Editor"}{" "}
                will be completed within three weeks. Post this, the Peer Review
                Process will take an additional three weeks.{" "}
              </p>
              <p>
                At every stage, we will update you on the status of your
                article.{" "}
              </p>
              <p>
                Should your article be approved for publishing, it will be
                published on our platform within <u>72 working hours</u>,
                subject to the payment of the balance Article Processing Charge.
              </p>
              <p>
                You can also check the status updates in the{" "}
                <Link
                  to={{ pathname: "/myArticle/submit" }}
                  state={"submit"}
                  className="d-inline-block text-decoration-underline"
                >
                  Under Review
                </Link>{" "}
                section of your dashboard.
              </p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="pb-2">
          <button
            className="button button-primary"
            onClick={() => {
              appointArticleStatus === "First Revision" ? (
                <Link
                  to={{ pathname: "/myArticle/submit" }}
                  state={"submit"}
                ></Link>
              ) : (
                setfinalSubmitConfirmPupup(false)
              );
              const f = feedbackPupup;
              f.openPopup = true;
              setfeedbackPupup({ ...f });
            }}
          >
            OKAY
          </button>
          <div className="helpPopupText mt-4">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogclassName=""
        show={profanitySuccess}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title pl-0 pr-0">
            Thank you for submitting THE article
          </h5>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          <div className="profanityTeatPopup">
            <strong>
              The PROFANITY CHECK is <img src={group} />
            </strong>
            <p>
              As the next step, we will now run the manuscript through a
              Similarity Index check. To cross this stage, your manuscript
              should have a similarity index of <b>not more than 15%</b>
              <div className="customTool iconManage">
                {["bottom"].map((placement) => (
                  <OverlayTrigger
                    key={placement}
                    placement={placement}
                    overlay={
                      <Popover>
                        <Popover.Body>
                          <div className="popoverToolWrap">
                            <p>
                              It is important to note that plagiarism is not
                              just about the percentage of content copied; it
                              also involves the manner in which the material is
                              used, cited, and referenced. Similarity indices
                              are not the only indicator of plagiarism.
                            </p>
                            <p className="mt-3 mb-0">
                              {" "}
                              Even if the similarity index is within an
                              acceptable range, if the language, structure, and
                              ideas in the research article are too similar to
                              another work, it could still be considered
                              plagiarism.
                            </p>
                          </div>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <img
                      className="pe-cursor ps-1"
                      src={vector_img}
                      alt="no img"
                    />
                  </OverlayTrigger>
                ))}
              </div>
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="button button-primary"
            onClick={() => runSimilarityCheck(8)}
          >
            RUN THE CHECK NOW
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        show={citationPopup}
        id="congratsMobile"
        tabIndex={-1}
        className=" authorModal md-x"
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title mb-0">Create Citation</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setcitationPopup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className=" pb-0">
          <div className="citationPopup ">
            <div className="isMultiAuthor">
              <h2>
                Author Name<sup className="supStar">*</sup>
              </h2>
              <label className="customCheck">
                <Checkbox
                  onRadioChange={handleMultiAuthorCheckbox}
                  name="isMultiAuthor"
                  checked={citationDetails?.isMulti}
                  className="multiAuthorCheckbox"
                />

                <i></i>
                <b>Article has multiple authors</b>
              </label>
            </div>

            <div className="authorsDetail">
              {citationDetails.totalLength.map((total, index) => (
                <div
                  className={
                    index === 0 ? "fnamelname" : "fnamelname repeatAuthor"
                  }
                >
                  <div className="fieldWrap">
                    <label className="labelForm">
                      First Name<sup className="supStar">*</sup>
                    </label>
                    <Input
                      errors={citationDetails?.fnameError[index]}
                      name={`fname${index}`}
                      handleChange={(e) =>
                        handleCitationInput(e, index, "fname")
                      }
                      className="fieldForm"
                      placeholder="Enter"
                      type="text"
                      value={citationDetails?.fname[index].val}
                    />
                  </div>
                  <div className="fieldWrap">
                    <label className="labelForm">
                      Last Name<sup className="supStar">*</sup>
                    </label>
                    <div className="repetField">
                      <Input
                        errors={citationDetails?.lnameError[index]}
                        name={`fname${index}`}
                        handleChange={(e) =>
                          handleCitationInput(e, index, "lname")
                        }
                        className="fieldForm"
                        placeholder="Enter"
                        type="text"
                        label=""
                        value={citationDetails?.lname[index].val}
                      />
                    </div>
                    {index > 0 && (
                      <b
                        class="closeAuthor"
                        onClick={() => removeCitationAuthor(index)}
                      ></b>
                    )}
                  </div>
                </div>
              ))}
              {citationDetails.isMulti === true && (
                <div
                  className="button-link addCoAuthor"
                  onClick={handleMultiCitation}
                >
                  Add co-Author
                </div>
              )}
            </div>
            <div className="creationUrl">
              <div className="fieldWrap">
                <label className="labelForm">
                  Article Title<sup className="supStar">*</sup>
                </label>
                <Input
                  errors={citationDetails?.artTitleError}
                  name="artTitle"
                  handleChange={(e) => handleCitationInput(e, 0, "artTitle")}
                  className="fieldForm _se_link_url"
                  placeholder="Enter"
                  type="text"
                  value={citationDetails?.artTitle}
                />
              </div>
            </div>
            <div className="creation-publication">
              <div className="fieldWrap">
                <label className="labelForm">
                  Year of Publication<sup className="supStar">*</sup>
                </label>
                <Input
                  errors={citationDetails?.yearError}
                  name="year"
                  handleChange={(e) => handleCitationInput(e, 0, "year")}
                  className="fieldForm"
                  placeholder="Enter"
                  type="text"
                  value={citationDetails?.year}
                />
              </div>
            </div>
            <div className="creationUrl">
              <div className="fieldWrap">
                <label className="labelForm">
                  URL<sup className="supStar">*</sup>
                </label>
                <Input
                  errors={citationDetails?.urlError}
                  name="url"
                  handleChange={(e) => handleCitationInput(e, 0, "url")}
                  className="fieldForm _se_link_url"
                  placeholder="Enter"
                  type="text"
                  value={citationDetails?.url}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="button button-primary mb-3"
            onClick={() => genrateCitaion()}
          >
            Generate
          </button>

          <div class="guidelinesWrap statementsGuide pl-0 pr-0">
            <span>
              <sup class="supStar">*</sup>Mandatory
            </span>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        show={citationDetails.publishPopup}
        id="congratsMobile"
        tabIndex={-1}
        className=" authorModal widthAuto"
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title mb-0">Citation Generated</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => closeCitationPublish()}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <div className="citationPopup">
            <div class="finalData mb-3">
              <label class="labelForm d-block mb-2">In-text Citation</label>
              <div class="copyInput">
                {citationDetails.lname.length === 1 && (
                  <div className="finalInputWrap">{`(${citationDetails.lname
                    .map((x) => x.val)
                    .join(", ")}, ${citationDetails.year})`}</div>
                )}
                {citationDetails.lname.length === 2 && (
                  <div className="finalInputWrap">{`(${citationDetails.lname
                    .map((x) => x.val)
                    .join(", ")}, ${citationDetails.year})`}</div>
                )}
                {citationDetails.lname.length > 2 && (
                  <div className="finalInputWrap">{`(${citationDetails.lname[0].val},${citationDetails.lname[1].val} ${citationDetails.year}), et al.`}</div>
                )}
                <b onClick={() => copyCitationDetails()}>Copy</b>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="button button-primary"
            onClick={() => closeCitationPublish()}
          >
            Done
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=""
        show={feedbackPupup.openPopup}
        size="lg"
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal feedBack"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title pl-0 pr-0">
            <div className="feedHead">
              <span>
                <img src={feedWant} />
              </span>
              <b>
                HOW WAS YOUR
                <br />
                ARTICLE SUBMISSION JOURNEY?
              </b>
            </div>
          </h5>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          <div className="feedBackPopup">
            <div className="feedStar">
              <StarRating getRatingValue={getRatingValue} />
              {feedbackPupup.rateError !== "" && (
                <div className="label-error">{feedbackPupup.rateError}</div>
              )}
            </div>
            <p className="feedText">
              On a scale of 1 to 5, 1 is "Difficult" and 5 is "Smooth Sailing”
            </p>
            <p>
              Additionally, we would greatly appreciate any specific feedback
              you can provide. Your feedback will help us create a seamless
              experience for all researchers.
            </p>
            <div className="feedInput">
              <Textarea
                name="feedback"
                rows="5"
                className="mb-[14px]"
                style={{ marginBottom: "14px" }}
                placeholder="Enter feedback here..."
                value={feedbackPupup?.feedback}
                onChange={(e) => {
                  const f = feedbackPupup;
                  f.feedback = e.target.value;
                  setfeedbackPupup({ ...f });
                }}
              />
            </div>
            <div className="feedBtn">
              <Link
                className=""
                to={{ pathname: "/myArticle/submit" }}
                state={"submit"}
              >
                <span>Not now</span>
              </Link>

              <button onClick={() => saveFeedBackDetails()}>
                Send Feedback
              </button>
            </div>
            <div className="helpPopupText mt-4 mb-2">
              Need help? Write to us at
              <a href="mailto:contactus@vikramshilaedu.in">
                contactus@vikramshilaedu.in
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogclassName=" modal-md modal-dialog  "
        size="md"
        show={feedbackPupup.successPopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Confetti width={"450px"} height={"460px"} numberOfPieces={100} />
        <Modal.Header className="modal-header pb-1">
          <div className="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">Thank you for your feedback</h5>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <div className="congratulationsPopup text-center">
            {user?.nationality === "outSideIndia" ? (
              <p className="text-left pl-2 ml-2">
                It is an integral part of our platform, and we are honoured to
                be a part of your scholarly journey.
              </p>
            ) : (
              <>
                <p className="text-left pl-2 ml-2">
                  It is an integral part of our platform, and we are honoured to
                  be a part of your scholarly journey.
                </p>
                <div className="earnCoinWrap">
                  <b>REFER and EARN</b>
                  <span>
                    <img src={coins} />
                  </span>
                </div>
                <p className="text-left pl-2 ml-2 mb-0">
                  {" "}
                  Refer 5 colleagues to the Aakashganga platform, and earn 250
                  Mudras (INR) in your Mudra Kosh (Wallet).
                </p>
                <p className="text-left pl-2 ml-2 mt-2 mb-4">
                  You can use the mudras to write a new article or update an
                  existing one.
                </p>
              </>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-2">
          <Link
            className="button-link mr-3"
            to={{ pathname: "/myArticle/submit" }}
            state={"submit"}
          >
            My dashboard
          </Link>
          {user?.nationality === "outSideIndia" ? null : (
            <Link
              className="button button-primary sm ml-3"
              onClick={() => {
                setfeedbackPupup({ successPopup: false });
                setShowReferAndEarn(true);
              }}
            >
              Refer and Earn
            </Link>
          )}

          <div className="helpPopupText mt-4 paymentTile">
            <sup className="sub">**</sup>
            <span>Payment of 250 Mudras is only applicable in India.</span>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showReferAndEarn}
        id="referModal"
        tabIndex={-1}
        className="md-x authorReferPopup"
        keyboard={false}
        backdrop="static"
      >
        <div>
          <div className="modal-content border-0 referContent">
            <div className="modal-header pb-0">
              <h5 className="modal-title referText">Refer and Earn</h5>
              <p className="bigSubText">Invite 5 friends to register</p>
              <div className="mudraCount">
                <span>
                  <b>Earn</b>
                  <br />
                  250 Mudras
                </span>
                <i>
                  <img src={kalashIcon} alt="#" />
                </i>
              </div>
            </div>
            <div className="modal-body pt-0 pb-0">
              <div className="px-2 text-center shareModal">
                <div className="referStep">
                  <ul>
                    <li>
                      <span>
                        <b className="icon-persons" />
                      </span>
                      Invite 5 friends to register
                    </li>
                    <li>
                      <span>
                        <b className="icon-register" />
                      </span>
                      Your friends register
                    </li>
                    <li>
                      <span>
                        <b className="icon-wallet" />
                      </span>
                      You receive 250 Mudras{" "}
                    </li>
                  </ul>
                </div>
                <p className="receiveText">
                  Your friends also receive 250 Mudras
                  <br />
                  each as joining bonus after registration.
                </p>
                <div className="socialShare">
                  <small>Invite via</small>
                  <ul className="socialRefer">
                    <li>
                      <EmailShareButton
                        separator=" "
                        subject="Your friend has invited you to join Mission Aakashganga"
                        body={title}
                        url=" "
                        shareUrl={title}
                      >
                        <img src={email48} alt="#" />
                      </EmailShareButton>
                    </li>

                    <li>
                      <WhatsappShareButton
                        url={shareUrl}
                        title={title}
                        separator=" "
                        className="Demo__some-network__share-button"
                      >
                        <img src={whatsapp48} alt="#" />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <TwitterShareButton
                        url={shareUrl}
                        title={title}
                        separator=" "
                        className="Demo__some-network__share-button"
                      >
                        <img src={twitter48} alt="#" />
                      </TwitterShareButton>
                    </li>
                  </ul>
                </div>
                <div className="divideLine">
                  <b>or</b>
                </div>
                <div className="codeBelow ">
                  <small>Refer using your unique code</small>
                  <div className="codeWrap">
                    <p id="#code" className="pr-color flex-fill">
                      {code}
                    </p>
                    <p onClick={(e) => handleCodeCopy(e)} className="sr-color">
                      <b id="code" className="icon-copy sr-color" />
                      &nbsp;&nbsp;Copy Code
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer pt-0 pb-0">
              <a
                className="link-gray mr-5"
                onClick={(e) => handleRedirect(e, "/dashboard")}
              >
                NOT NOW
              </a>
              <button
                className="button button-primary ml-3"
                onClick={(e) => handleRedirect(e, "/dashboard")}
              >
                MY DASHBOARD
              </button>
              <div class="questionBox reddot">
                <span>
                  Receiving 250 Mudras is conditional to 5 individuals
                  registering with us using your referral code
                </span>
                <span>
                  You will be able to check your reward in the “Mudrakosh”
                  section
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        dialogclassName=""
        show={articleWordLimit.openPopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal authorModalRed md-x"
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={alertSvg} alt="#" />
          </div>
          <h5 className="modal-title">ATTENTION</h5>
          <h5 className="wordCount">
            {articleWordLimit.isIncrease === true
              ? "Maximum Word Count Exceeded"
              : "Minimum Word Count Requirement Not Met"}
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              const f = articleWordLimit;
              f.openPopup = false;
              setarticleWordLimit({ ...f });
            }}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="attentionPopup">
            {articleWordLimit.isIncrease === true && (
              <>
                <p>
                  The research article you are submitting has exceeded the
                  maximum word limit of 10,000 words imposed by our publication
                  guidelines.
                </p>
                <p>
                  Please adhere to the word limit to ensure consistency and
                  revise your article to meet the specified limit.
                </p>
                <p>
                  If you believe your research requires additional words to
                  convey its significance effectively, we encourage you to list
                  your reason in the box below.
                </p>
              </>
            )}
            {articleWordLimit.isDecrease === true && (
              <>
                <p>
                  Please note that we have set a minimum word count requirement
                  of {(preStepData?.submissionDetail?.journalType?.journalType === "Society Journal" || preStepData?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" || preStepData?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf") ? 1000 : 8000} words for research articles.
                </p>
                <p>
                  We do this to ensure the comprehensive coverage of research
                  topics and maintain the integrity of our journal.
                </p>
                <p>
                  However, if you believe that your research falls into a
                  category where a lower word count would be more appropriate,
                  we kindly request you to list your reason in the box below.
                </p>
              </>
            )}
            <Textarea
              name="limit"
              rows="3"
              className=""
              placeholder="Enter reason here..."
              value={articleWordLimit?.detail}
              onChange={(e) => {
                const f = articleWordLimit;
                f.detail = e.target.value;
                f.detailError = "";
                setarticleWordLimit({ ...f });
              }}
            />
            {articleWordLimit.detailError !== "" && (
              <div className="label-error">{articleWordLimit.detailError}</div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer pb-2">
          <span
            className="button-link-gray text-transform-uppercase mr-3"
            onClick={(e) => {
              const f = articleWordLimit;
              f.openPopup = false;
              setarticleWordLimit({ ...f });
            }}
          >
            Back to the article
          </span>
          <button
            className="button button-primary redBtn"
            type="button"
            onClick={() => sendLimitReason()}
          >
            Okay
          </button>
          <div className="helpPopupText mt-4">
            Still need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=" modal-sm modal-dialog"
        size="md"
        show={articleWordLimit.reqSuccessPopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">Thank You</h5>
          <span className="greenTitle">Request sent successfully </span>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave pl-4">
            <p className="mb-3">
              We have received your request and you will receive a response
              within <u>three working days</u>.
            </p>
            <p>Check your inbox for more details.</p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-active mr-3"
            onClick={(e) => {
              const f = articleWordLimit;
              f.reqSuccessPopup = false;
              setarticleWordLimit({ ...f });
            }}
          >
            continue
          </span>
          <Link
            className="button button-primary sm ml-3"
            to={{ pathname: "/dashboard" }}
          >
            My dashboard
          </Link>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogclassName=" modal-sm modal-dialog"
        size="md"
        show={articleWordLimit.alreadyExistReqPopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">
            Your Request is
            <br />
            already submitted
          </h5>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave pl-4">
            <p className="mb-3">
              We will respond within <u>three working days.</u>
            </p>
            <p>
              If you are checking for an update after three days, we recommend
              that you check your email for a response.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary sm "
            onClick={(e) => {
              const f = articleWordLimit;
              f.alreadyExistReqPopup = false;
              setarticleWordLimit({ ...f });
            }}
          >
            OKAY
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogclassName=" modal-md modal-dialog"
        size="md"
        show={isUpdateNewVersionPopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title p-0">Article submitted for processing</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setisUpdateNewVersionPopup(false);
            }}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave pl-4">
            <p
              className="text-[16px] text-[#000000]"
              style={{ fontSize: "16px", color: "#000000" }}
            >
              You can also check for status updates in the{" "}
              <Link
                className="btn-link-active text-transform-none"
                to={{ pathname: "/myArticle/submit" }}
                state={"submit"}
              >
                <u>
                  <b>Under Review</b>
                </u>
              </Link>{" "}
              section on your dashboard.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary sm "
            onClick={() => {
              appointArticleStatus === "First Revision" ? (
                <Link
                  to={{ pathname: "/myArticle/submit" }}
                  state={"submit"}
                ></Link>
              ) : (
                setisUpdateNewVersionPopup(false)
              );
              const f = feedbackPupup;
              f.openPopup = true;
              setfeedbackPupup({ ...f });
            }}
          >
            OKAY
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={mobileAlert}
        size="md"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered authorModal"
      >
        <Modal.Header className="modal-header pb-0">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => (setMobileAlert(false), handleRedirect(e, "/"))}
          />
          <Modal.Title className="modal-title pl-0">
            <h2 className="fontsizeshastra ml-4">Note</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="grantDetails pl-2 pr-2 mb-3">
            <div className="writeYourContent pb-0 pt-0">
              <p className="mb-0 text-left">
                <p className="yellowTextWelcome text-center blackColorTestRegst">
                  For a better publishing experience, article submission is
                  currently supported on desktop only. Please log in again from
                  your desktop.
                </p>
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* //<UniqueDraggableDiv> */}
      <Modal
        dialogclassName=""
        // show={true}
        show={grammarModal}
        id="congratsMobile"
        tabIndex={-1}
        className="authorModal md-x grammar-large"
        centered
      >
        <Modal.Header className="modal-header   ">
          <div className="modal-icon">
            <img src={alertSearch} alt="#" />
          </div>
          <h5 className="modal-title p-0">
            Article Grammar and Spelling Check
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setGrammarModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0 pl-2 pr-2">
          <div className=" alertPopup">
            <div className="checkResultText">
              {editorContentGrammar?.[editorContentGrammarIndex]?.length > 0 ||
              titleGrammarHandle ? (
                <>
                  <p style={{ maxWidth: "840px" }}>
                    The following checks below will display the proposed
                    corrections in your article. Please choose the green{" "}
                    <img src={checkRounded} className="w-25px" alt="" /> or the
                    red <img src={closeRounded} className="w-25px" alt="" />{" "}
                    button to make your choice. All corrections will be applied
                    automatically to the document once you have reviewed all the
                    pages in the grammar and spelling check.
                  </p>
                  {/* <p>You will find them highlighted in the article for correction.</p> */}

                  <blockquote
                    className="bg-secondary-subtle p-2 rounded-2 mt-4 text-center d-flex justify-content-center gap-5"
                    style={{ backgroundColor: "#e2e3e5c9" }}
                  >
                    {/* <div class="customTool fw-semibold"><img style={{filter:"grayscale(1)"}} className="pe-cursor ps-1 w-25px opacity-5" src={vector_img} alt="no img"/ > Information </div> */}
                    <Link
                      className={`my-1 accptbtn pointer-events-none mx-2 ds-darkblue fw-semibold`}
                    >
                      <img src={checkRounded} className="w-30px" alt="" />
                      Accept Change
                    </Link>
                    <Link
                      className={`my-1 rejectbtn pointer-events-none mx-2 ds-darkblue fw-semibold`}
                    >
                      <img src={closeRounded} className="w-30px" alt="" />
                      Reject Change
                    </Link>
                    <Link
                      className={` my-1 addtodictionarybtn pointer-events-none mx-2 ds-darkblue fw-semibold`}
                    >
                      <img src={bookmark} className="w-30px" alt="" />
                      Add to Dictionary
                    </Link>
                  </blockquote>
                </>
              ) : null}
              {titleGrammarHandle ? null : (
                <>
                  <strong className="text-uppercase">
                    {editorTitleValue[editorContentGrammarIndex].val}
                  </strong>
                </>
              )}
              {!titleGrammarHandle ? (
                editorContentGrammar?.[editorContentGrammarIndex]?.length >
                0 ? (
                  // Content to display when titleGrammarHandle is false
                  editorContentGrammar?.[editorContentGrammarIndex]?.map?.(
                    (grammar, index) => (
                      <div key={index} className="grammar-item">
                        <div className="row align-items-center justify-content-center">
                          <div className="col-9">
                            <div className="wrong-sen">
                              <div
                                className="text-center d-block m-auto w-80"
                                dangerouslySetInnerHTML={{
                                  __html: grammar.text,
                                }}
                              ></div>
                            </div>
                          </div>
                          {grammar?.result?.map((item, indx) => (
                            <React.Fragment key={`${index}-${indx}`}>
                              {checkInDictionary(
                                item?.suggestions?.[0]?.suggestion,
                              ) === true ? (
                                <div className="col-9">
                                  <div className="d-flex my-1 gap-2 align-items-center">
                                    {item?.text === "" ||
                                    item?.suggestions?.[0]?.suggestion ===
                                      "" ? (
                                      <>
                                        <div
                                          className="wrong-sen mb-0 min-w-50p"
                                          dangerouslySetInnerHTML={{
                                            __html: `${extractClosestWords(
                                              grammar.text,
                                              item?.begin,
                                              item?.end,
                                            )} ${item?.text}`,
                                          }}
                                        ></div>
                                        <div
                                          className="right-sen min-w-50p"
                                          dangerouslySetInnerHTML={{
                                            __html: `${extractClosestWords(
                                              grammar.text,
                                              item?.begin,
                                              item?.end,
                                            )} ${
                                              item?.suggestions?.[0]?.suggestion
                                            }`,
                                          }}
                                        ></div>
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          className="wrong-sen mb-0 min-w-50p"
                                          dangerouslySetInnerHTML={{
                                            __html: item?.text,
                                          }}
                                        ></div>
                                        <div
                                          className="right-sen min-w-50p"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              item?.suggestions?.[0]
                                                ?.suggestion,
                                          }}
                                        ></div>
                                      </>
                                    )}
                                    <Link
                                      className={`d-block accptbtn ${
                                        item?.status === "accepted"
                                          ? "active"
                                          : ""
                                      }`}
                                      type="button"
                                      onClick={() =>
                                        updateResultStatus(
                                          editorContentGrammarIndex,
                                          index,
                                          indx,
                                          "accepted",
                                        )
                                      }
                                    >
                                      <img
                                        src={checkRounded}
                                        className="w-35px"
                                        alt="Accept"
                                      />
                                    </Link>
                                    <Link
                                      className={`d-block  rejectbtn ${
                                        item?.status === "rejected"
                                          ? "active"
                                          : ""
                                      }`}
                                      type="button"
                                      onClick={() =>
                                        updateResultStatus(
                                          editorContentGrammarIndex,
                                          index,
                                          indx,
                                          "rejected",
                                        )
                                      }
                                    >
                                      <img
                                        className="w-35px"
                                        src={closeRounded}
                                        alt="Reject"
                                      />
                                    </Link>
                                    <Link
                                      className={`d-block addtodictionarybtn ${
                                        item?.status === "addToDictionary"
                                          ? "active"
                                          : ""
                                      }`}
                                      type="button"
                                      onClick={() =>
                                        updateResultStatus(
                                          editorContentGrammarIndex,
                                          index,
                                          indx,
                                          "addToDictionary",
                                        )
                                      }
                                    >
                                      <img
                                        src={
                                          item?.status === "addToDictionary"
                                            ? bookmarkSelected
                                            : bookmark
                                        }
                                        alt="Add to Dictionary"
                                        className="w-35px"
                                      />
                                    </Link>
                                  </div>
                                </div>
                              ) : null}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    ),
                  )
                ) : (
                  <div>
                    <img
                      src={noGrammar}
                      className="d-block m-auto mw-120"
                      alt="No Article"
                    />
                    <p className="text-center theme-orange-color fw-semibold">
                      {grammarWaiting
                        ? "Great! No errors here to correct."
                        : "Grammar check in progress, please wait."}
                    </p>
                  </div>
                )
              ) : (
                // Content to display when titleGrammarHandle is true
                <>
                  {editorTitleGrammar?.map?.((grammarList, listIndex) => (
                    <React.Fragment key={listIndex}>
                      <div>
                        <strong className="text-uppercase">
                          {listIndex === 0
                            ? "Title"
                            : listIndex === 1
                              ? "Running Title"
                              : listIndex === 2
                                ? "Abstract"
                                : null}
                        </strong>
                      </div>
                      {grammarList?.length > 0 ? (
                        grammarList?.map?.((grammar, index) => (
                          <div key={index} className="grammar-item">
                            <div className="row align-items-center justify-content-center">
                              <div className="col-9">
                                <div
                                  className="wrong-sen text-center"
                                  dangerouslySetInnerHTML={{
                                    __html: grammar.text,
                                  }}
                                ></div>
                              </div>
                              {grammar?.result?.map((item, indx) => (
                                <React.Fragment key={`${index}-${indx}`}>
                                  {checkInDictionary(
                                    item?.suggestions?.[0]?.suggestion,
                                  ) === true ? (
                                    <div className="col-9">
                                      <div className="d-flex my-1 gap-2 align-items-center">
                                        {item?.text === "" ||
                                        item?.suggestions?.[0]?.suggestion ===
                                          "" ? (
                                          <>
                                            <div
                                              className="wrong-sen mb-0 min-w-50p"
                                              dangerouslySetInnerHTML={{
                                                __html: `${extractClosestWords(
                                                  grammar.text,
                                                  item?.begin,
                                                  item?.end,
                                                )} ${item?.text}`,
                                              }}
                                            ></div>
                                            <div
                                              className="right-sen min-w-50p"
                                              dangerouslySetInnerHTML={{
                                                __html: `${extractClosestWords(
                                                  grammar.text,
                                                  item?.begin,
                                                  item?.end,
                                                )} ${
                                                  item?.suggestions?.[0]
                                                    ?.suggestion
                                                }`,
                                              }}
                                            ></div>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="wrong-sen mb-0 min-w-50p"
                                              dangerouslySetInnerHTML={{
                                                __html: item?.text,
                                              }}
                                            ></div>
                                            <div
                                              className="right-sen min-w-50p"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  item?.suggestions?.[0]
                                                    ?.suggestion,
                                              }}
                                            ></div>
                                          </>
                                        )}

                                        <Link
                                          className={`d-block  accptbtn ${
                                            item?.status === "accepted"
                                              ? "active"
                                              : ""
                                          }`}
                                          type="button"
                                          onClick={() =>
                                            updateResultStatus(
                                              listIndex,
                                              index,
                                              indx,
                                              "accepted",
                                              "titleGrammarSection",
                                            )
                                          }
                                        >
                                          <img
                                            className="w-35px"
                                            src={checkRounded}
                                            alt="Accept"
                                          />
                                        </Link>
                                        <Link
                                          className={`d-block rejectbtn ${
                                            item?.status === "rejected"
                                              ? "active"
                                              : ""
                                          }`}
                                          type="button"
                                          onClick={() =>
                                            updateResultStatus(
                                              listIndex,
                                              index,
                                              indx,
                                              "rejected",
                                              "titleGrammarSection",
                                            )
                                          }
                                        >
                                          <img
                                            className="w-35px"
                                            src={closeRounded}
                                            alt="Reject"
                                          />
                                        </Link>
                                        <Link
                                          className={`d-block  addtodictionarybtn ${
                                            item?.status === "addToDictionary"
                                              ? "active"
                                              : ""
                                          }`}
                                          type="button"
                                          onClick={() =>
                                            updateResultStatus(
                                              listIndex,
                                              index,
                                              indx,
                                              "addToDictionary",
                                              "titleGrammarSection",
                                            )
                                          }
                                        >
                                          <img
                                            className="w-35px"
                                            src={
                                              item?.status === "addToDictionary"
                                                ? bookmarkSelected
                                                : bookmark
                                            }
                                            alt="Add to Dictionary"
                                          />
                                        </Link>
                                      </div>
                                    </div>
                                  ) : null}
                                </React.Fragment>
                              ))}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div>
                          <img
                            src={noGrammar}
                            className="d-block m-auto mw-120"
                            alt="No Article"
                          />
                          <p className="text-center theme-orange-color fw-semibold">
                            {grammarWaiting
                              ? "Great! No errors here to correct."
                              : "Grammar check in progress, please wait."}
                          </p>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </>
              )}

              {editorContentGrammar?.[editorContentGrammarIndex]?.length > 0 ? (
                <>
                  {editorContentGrammarIndex == 5 ? (
                    <>
                      <p className="text-center">
                        Please review your changes once before submitting them
                        for final amendments. <br />
                        You can revisit these changes before moving the article
                        to the next level.
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="text-center">
                        Please continue accepting or rejecting the options
                        proposed in the following pages.
                      </p>
                    </>
                  )}
                </>
              ) : null}
            </div>
            <div className="mt-4 mb-3 d-flex justify-content-center gap-4">
              <button
                className="button button-primary"
                type="button"
                // onClick={(e) => {makeGrammarAmendments(),setGrammarModal(false)}}
                onClick={(e) => {
                  handleNavigation("previous");
                }}
                // disabled={editorContentGrammarIndex==0}
              >
                Previous
              </button>
              {editorContentGrammarIndex == 5 ? (
                <>
                  <button
                    className="button button-primary"
                    type="button"
                    // onClick={(e) => {makeGrammarAmendments(),setGrammarModal(false)}}
                    onClick={(e) => {
                      (makeGrammarAmendments(), setGrammarModal(false));
                    }}
                  >
                    Make Amendments
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="button button-primary"
                    type="button"
                    // onClick={(e) => {makeGrammarAmendments(),setGrammarModal(false)}}
                    onClick={(e) => {
                      handleNavigation("next");
                    }}
                    disabled={editorContentGrammarIndex == 5}
                  >
                    Next
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="pb-0">
          <div className="helpPopupText pb-3">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>
      {/* </UniqueDraggableDiv> */}
    </div>
  );
};

export default SubmitArticle;
